// Faturas.js - VERSÃO COMPLETA CORRIGIDA COM CRIAÇÃO DIRETA DE GUIA DE ENTREGA
// 🔥 INTEGRADO: Cria guia de entrega diretamente via API
// 🔥 ALTERADO: Botão mostra "Guia Criada" quando já existe guia ativa
// 🔥 ALTERADO: Stock só sai na Guia de Entrega (não no pagamento)
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import axios from 'axios';
import './Faturas.css';
import { Icon } from './SharedComponents';
import ClienteModal from './ClienteModal';
import ProdutoModal from './ProdutoModal';
import ServicoModal from './ServicoModal';

const API_BASE_URL = '/api';

// 🔥 STATUS DA FATURA
const STATUS_FATURA = [
    { value: 'Rascunho', label: 'Rascunho', color: '#6b7280', icon: 'file' },
    { value: 'Aberta', label: 'Aberta', color: '#f59e0b', icon: 'pending' },
    { value: 'Emitida', label: 'Emitida', color: '#3b82f6', icon: 'check_circle' },
    { value: 'Pago', label: 'Pago', color: '#10b981', icon: 'check_circle' },
    { value: 'Vencida', label: 'Vencida', color: '#dc2626', icon: 'block' },
    { value: 'Cancelada', label: 'Cancelada', color: '#6b7280', icon: 'cancel' },
    { value: 'Duplicado', label: 'Duplicado', color: '#8b5cf6', icon: 'content_copy' },
];

// 🔥 FORMAS DE PAGAMENTO
const FORMAS_PAGAMENTO = [
    { value: 'Dinheiro', label: 'Dinheiro', icon: 'payments' },
    { value: 'Transferência Bancária', label: 'Transferência Bancária', icon: 'account_balance' },
    { value: 'Cheque', label: 'Cheque', icon: 'receipt' },
    { value: 'Cartão', label: 'Cartão', icon: 'credit_card' },
    { value: 'M-Kesh', label: 'M-Kesh', icon: 'phone_android' },
    { value: 'M-Pesa', label: 'M-Pesa', icon: 'phone_android' },
    { value: 'E-Mola', label: 'E-Mola', icon: 'phone_android' },
    { value: 'Outro', label: 'Outro', icon: 'more_horiz' },
];

const PERCENTUAIS_IVA_PADRAO = [0, 5, 15, 16];
const ITEMS_PER_PAGE = 6;
const SEARCH_ITEMS_PER_PAGE = 5;

const getStatusInfo = (status) => {
    if (!status) return { value: 'Rascunho', label: 'Rascunho', color: '#6b7280', icon: 'file' };
    const found = STATUS_FATURA.find(s => s.value === status);
    return found || { value: status, label: status, color: '#6b7280', icon: 'help' };
};

// =============================================
// COMPONENTE TOAST
// =============================================
function Toast({ message, type, onClose }) {
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                onClose();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [message, onClose]);

    if (!message) return null;

    const icons = {
        success: 'check_circle',
        danger: 'error',
        warning: 'warning',
        info: 'info'
    };

    const colors = {
        success: '#10b981',
        danger: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6'
    };

    return (
        <div className="toast-container" style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 99999,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            maxWidth: '400px',
            width: '100%',
            pointerEvents: 'none'
        }}>
            <div className={`toast-message toast-${type}`} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 16px',
                background: '#ffffff',
                borderRadius: '12px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.05)',
                borderLeft: `4px solid ${colors[type] || '#6b7280'}`,
                pointerEvents: 'auto',
                animation: 'slideInRight 0.3s ease-out',
                transition: 'all 0.3s ease'
            }}>
                <Icon
                    name={icons[type] || 'info'}
                    size={20}
                    style={{ color: colors[type] || '#6b7280', flexShrink: 0 }}
                />
                <span style={{
                    flex: 1,
                    fontSize: '0.875rem',
                    color: '#1a1a2e',
                    fontWeight: 500,
                    lineHeight: 1.4
                }}>
                    {message}
                </span>
                <button
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#9ca3af',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        transition: 'all 0.2s ease',
                        flexShrink: 0
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f3f4f6';
                        e.currentTarget.style.color = '#4b5563';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#9ca3af';
                    }}
                >
                    <Icon name="close" size={16} />
                </button>
            </div>
            <style>{`
                @keyframes slideInRight {
                    from {
                        opacity: 0;
                        transform: translateX(40px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                @keyframes slideOutRight {
                    from {
                        opacity: 1;
                        transform: translateX(0);
                    }
                    to {
                        opacity: 0;
                        transform: translateX(40px);
                    }
                }
                .toast-message {
                    animation: slideInRight 0.3s ease-out;
                }
                .toast-message.removing {
                    animation: slideOutRight 0.3s ease-in forwards;
                }
            `}</style>
        </div>
    );
}

// =============================================
// COMPONENTE DE PAGINAÇÃO PARA ITENS
// =============================================
function ItensPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const getPageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
            return pages;
        }

        pages.push(1);

        let startPage = Math.max(2, currentPage - 1);
        let endPage = Math.min(totalPages - 1, currentPage + 1);

        if (currentPage <= 3) {
            startPage = 2;
            endPage = Math.min(totalPages - 1, 4);
        }

        if (currentPage >= totalPages - 2) {
            startPage = Math.max(2, totalPages - 3);
            endPage = totalPages - 1;
        }

        if (startPage > 2) {
            pages.push('...');
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < totalPages - 1) {
            pages.push('...');
        }

        pages.push(totalPages);

        return pages;
    };

    const renderPageNumbers = () => {
        const pageNumbers = getPageNumbers();

        return pageNumbers.map((p, index) => {
            if (p === '...') {
                return (
                    <span key={`dots-${index}`} className="pagination-dots">
                        …
                    </span>
                );
            }
            return (
                <button
                    key={p}
                    className={`pagination-number ${p === currentPage ? 'active' : ''}`}
                    onClick={() => onPageChange(p)}
                >
                    {p}
                </button>
            );
        });
    };

    return (
        <div className="itens-pagination" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '0.25rem',
            padding: '0.5rem 0.5rem 0.25rem 0.5rem',
            marginTop: '0.25rem',
            borderTop: '1px solid #e5e7eb'
        }}>
            <button
                className="pagination-btn"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                    width: '26px',
                    height: '26px',
                    border: '1px solid #e5e7eb',
                    borderRadius: '50%',
                    background: 'transparent',
                    color: '#1a1a2e',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s ease',
                    opacity: currentPage === 1 ? 0.4 : 1,
                    pointerEvents: currentPage === 1 ? 'none' : 'auto'
                }}
            >
                <Icon name="chevron_left" size={14} />
            </button>
            {renderPageNumbers()}
            <button
                className="pagination-btn"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                    width: '26px',
                    height: '26px',
                    border: '1px solid #e5e7eb',
                    borderRadius: '50%',
                    background: 'transparent',
                    color: '#1a1a2e',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s ease',
                    opacity: currentPage === totalPages ? 0.4 : 1,
                    pointerEvents: currentPage === totalPages ? 'none' : 'auto'
                }}
            >
                <Icon name="chevron_right" size={14} />
            </button>
        </div>
    );
}

// =============================================
// COMPONENTE SEARCH INPUT REUTILIZÁVEL COM PAGINAÇÃO
// =============================================
function SearchInput({
    value,
    onChange,
    onSelect,
    onClear,
    placeholder,
    items = [],
    getItemLabel,
    getItemSub,
    getItemTag,
    getItemPrice,
    getItemSearchFields,
    getItemStatus,
    selectedId,
    iconName = 'search',
    noResultsMessage = 'Nenhum resultado encontrado',
    className = '',
    inputStyle = {},
    dropdownStyle = {},
    itemsPerPage = SEARCH_ITEMS_PER_PAGE,
    ...props
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState(value || '');
    const [currentPage, setCurrentPage] = useState(1);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
        setSearchTerm(value || '');
    }, [value]);

    const filteredItems = useMemo(() => {
        if (!items || !Array.isArray(items) || items.length === 0) {
            return [];
        }

        if (!searchTerm || searchTerm.trim() === '') {
            return items;
        }

        const search = searchTerm.toLowerCase().trim();

        return items.filter(item => {
            if (!item) return false;

            const searchableFields = [];

            if (getItemLabel) {
                searchableFields.push(getItemLabel(item).toLowerCase());
            } else if (item.nome) {
                searchableFields.push(item.nome.toLowerCase());
            }

            if (getItemSearchFields) {
                const extraFields = getItemSearchFields(item);
                if (Array.isArray(extraFields)) {
                    searchableFields.push(...extraFields.map(f => String(f).toLowerCase()));
                }
            }

            if (getItemStatus) {
                const status = getItemStatus(item);
                if (status) {
                    searchableFields.push(String(status).toLowerCase());
                }
            } else if (item.status) {
                searchableFields.push(String(item.status).toLowerCase());
            } else if (item.estado) {
                searchableFields.push(String(item.estado).toLowerCase());
            }

            if (item.codigo) searchableFields.push(item.codigo.toLowerCase());
            if (item.nif) searchableFields.push(item.nif.toLowerCase());
            if (item.nuit) searchableFields.push(item.nuit.toLowerCase());
            if (item.email) searchableFields.push(item.email.toLowerCase());
            if (item.telefone) searchableFields.push(item.telefone.toLowerCase());
            if (item.documento) searchableFields.push(item.documento.toLowerCase());
            if (item.referencia) searchableFields.push(item.referencia.toLowerCase());
            if (item.tipo) searchableFields.push(String(item.tipo).toLowerCase());
            if (item.categoria) {
                if (typeof item.categoria === 'string') {
                    searchableFields.push(item.categoria.toLowerCase());
                } else if (item.categoria?.nome) {
                    searchableFields.push(item.categoria.nome.toLowerCase());
                }
            }

            if (item.morada) {
                if (item.morada.cidade) searchableFields.push(item.morada.cidade.toLowerCase());
                if (item.morada.bairro) searchableFields.push(item.morada.bairro.toLowerCase());
                if (item.morada.provincia) searchableFields.push(item.morada.provincia.toLowerCase());
                if (item.morada.rua) searchableFields.push(item.morada.rua.toLowerCase());
                if (item.morada.pais) searchableFields.push(item.morada.pais.toLowerCase());
            }

            if (item.contacto) {
                if (item.contacto.nome) searchableFields.push(item.contacto.nome.toLowerCase());
                if (item.contacto.telefone) searchableFields.push(item.contacto.telefone.toLowerCase());
                if (item.contacto.email) searchableFields.push(item.contacto.email.toLowerCase());
            }

            if (item.empresa) {
                if (item.empresa.nome) searchableFields.push(item.empresa.nome.toLowerCase());
                if (item.empresa.nif) searchableFields.push(item.empresa.nif.toLowerCase());
            }

            return searchableFields.some(field => field && field.includes(search));
        });
    }, [items, searchTerm, getItemLabel, getItemSearchFields, getItemStatus]);

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedItems = filteredItems.slice(startIndex, startIndex + itemsPerPage);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const getPageNumbers = useCallback(() => {
        const pages = [];
        const total = totalPages;

        if (total <= 5) {
            for (let i = 1; i <= total; i++) {
                pages.push(i);
            }
            return pages;
        }

        pages.push(1);

        let startPage = Math.max(2, currentPage - 2);
        let endPage = Math.min(total - 1, currentPage + 2);

        if (currentPage <= 4) {
            startPage = 2;
            endPage = Math.min(total - 1, 5);
        }

        if (currentPage >= total - 3) {
            startPage = Math.max(2, total - 4);
            endPage = total - 1;
        }

        if (startPage > 2) {
            pages.push('...');
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < total - 1) {
            pages.push('...');
        }

        pages.push(total);

        return pages;
    }, [currentPage, totalPages]);

    const handleSelect = (item) => {
        if (onSelect) onSelect(item);
        setIsOpen(false);
        if (inputRef.current) inputRef.current.blur();
    };

    const handleClear = () => {
        if (onClear) onClear();
        setSearchTerm('');
        setIsOpen(false);
        if (inputRef.current) inputRef.current.focus();
    };

    const handleInputChange = (e) => {
        const val = e.target.value;
        setSearchTerm(val);
        if (onChange) onChange(val);
        setIsOpen(true);
        if (val === '' && onClear) {
            onClear();
        }
    };

    const handleInputFocus = () => {
        const hasItems = items && Array.isArray(items) && items.length > 0;
        if (searchTerm.trim() !== '' || hasItems) {
            setIsOpen(true);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const hasValue = !!selectedId || searchTerm?.trim() !== '';

    const preventFormSubmit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const pageNumbers = getPageNumbers();

        return (
            <div
                className="search-dropdown-pagination"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.15rem',
                    padding: '0.4rem 0.5rem',
                    borderTop: '1px solid #e5e7eb',
                    background: 'rgba(0,0,0,0.02)',
                    flexWrap: 'wrap'
                }}
                onMouseDown={preventFormSubmit}
                onClick={preventFormSubmit}
            >
                <button
                    type="button"
                    className="pagination-btn"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCurrentPage(prev => Math.max(1, prev - 1));
                    }}
                    disabled={currentPage === 1}
                    style={{
                        width: '24px',
                        height: '24px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '50%',
                        background: 'transparent',
                        color: '#1a1a2e',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                        opacity: currentPage === 1 ? 0.4 : 1,
                        pointerEvents: currentPage === 1 ? 'none' : 'auto',
                        fontSize: '12px',
                        padding: 0
                    }}
                >
                    <Icon name="chevron_left" size={12} />
                </button>

                {pageNumbers.map((p, index) => {
                    if (p === '...') {
                        return (
                            <span key={`dots-${index}`} style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: '20px',
                                height: '24px',
                                color: '#6b7280',
                                fontSize: '0.7rem',
                                fontWeight: 600,
                                userSelect: 'none'
                            }}>
                                …
                            </span>
                        );
                    }
                    return (
                        <button
                            key={p}
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setCurrentPage(p);
                            }}
                            style={{
                                minWidth: '24px',
                                height: '24px',
                                padding: '0 0.15rem',
                                border: p === currentPage ? '1px solid #4f46e5' : '1px solid transparent',
                                borderRadius: '50%',
                                background: p === currentPage ? '#4f46e5' : 'transparent',
                                color: p === currentPage ? '#ffffff' : '#1a1a2e',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.6rem',
                                fontWeight: p === currentPage ? 700 : 500,
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                if (p !== currentPage) {
                                    e.currentTarget.style.background = '#f3f4f6';
                                    e.currentTarget.style.borderColor = '#e5e7eb';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (p !== currentPage) {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }
                            }}
                        >
                            {p}
                        </button>
                    );
                })}

                <button
                    type="button"
                    className="pagination-btn"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCurrentPage(prev => Math.min(totalPages, prev + 1));
                    }}
                    disabled={currentPage === totalPages}
                    style={{
                        width: '24px',
                        height: '24px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '50%',
                        background: 'transparent',
                        color: '#1a1a2e',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                        opacity: currentPage === totalPages ? 0.4 : 1,
                        pointerEvents: currentPage === totalPages ? 'none' : 'auto',
                        fontSize: '12px',
                        padding: 0
                    }}
                >
                    <Icon name="chevron_right" size={12} />
                </button>

                <span style={{
                    fontSize: '0.55rem',
                    color: '#9ca3af',
                    marginLeft: '0.2rem'
                }}>
                    {filteredItems.length} itens
                </span>
            </div>
        );
    };

    const darkModeStyles = `
        .dark-mode-variables .search-dropdown-pagination {
            border-top-color: rgba(255, 255, 255, 0.08);
            background: rgba(255, 255, 255, 0.03);
        }
        .dark-mode-variables .search-dropdown-pagination .pagination-btn {
            border-color: rgba(255, 255, 255, 0.1);
            color: rgba(255, 255, 255, 0.7);
        }
        .dark-mode-variables .search-dropdown-pagination .pagination-btn:hover:not(:disabled) {
            background: rgba(255, 255, 255, 0.1);
        }
        .dark-mode-variables .search-dropdown-pagination button:not(.pagination-btn) {
            color: rgba(255, 255, 255, 0.7);
        }
        .dark-mode-variables .search-dropdown-pagination button:not(.pagination-btn):hover {
            background: rgba(255, 255, 255, 0.08) !important;
            border-color: rgba(255, 255, 255, 0.15) !important;
        }
        .dark-mode-variables .search-dropdown-pagination .pagination-number.active {
            background: #4f46e5 !important;
            color: #ffffff !important;
            border-color: #4f46e5 !important;
        }
        .dark-mode-variables .search-dropdown-pagination .pagination-dots {
            color: rgba(255, 255, 255, 0.4);
        }
        .dark-mode-variables .search-dropdown-pagination .itens-count {
            color: rgba(255, 255, 255, 0.3);
        }
    `;

    return (
        <div className={`search-input-wrapper ${className}`} ref={wrapperRef}>
            <style>{darkModeStyles}</style>
            <div className="search-input-inner">
                <Icon name={iconName} size={16} className={`search-icon ${hasValue ? 'has-value' : ''}`} />
                <input
                    ref={inputRef}
                    type="text"
                    className={`search-input-field ${hasValue ? 'has-value' : ''}`}
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                    style={inputStyle}
                    {...props}
                />
                {selectedId && (
                    <button type="button" className="search-clear-btn" onClick={handleClear} title="Limpar seleção">
                        <Icon name="close" size={14} />
                    </button>
                )}
            </div>
            {isOpen && (
                <div className="search-dropdown" ref={dropdownRef} style={dropdownStyle}>
                    {filteredItems.length === 0 ? (
                        <div className="search-dropdown-empty">
                            {items && Array.isArray(items) && items.length > 0
                                ? noResultsMessage
                                : 'Carregando itens...'}
                        </div>
                    ) : (
                        <>
                            {paginatedItems.map((item, index) => (
                                <div
                                    key={item._id || index}
                                    className="search-dropdown-item"
                                    onClick={() => handleSelect(item)}
                                >
                                    <div className="search-dropdown-item-info">
                                        <span className="item-name">
                                            {getItemLabel ? getItemLabel(item) : item.nome}
                                        </span>
                                        {getItemSub && getItemSub(item) && (
                                            <span className="item-sub">{getItemSub(item)}</span>
                                        )}
                                        {getItemStatus && getItemStatus(item) && (
                                            <span className="item-status" style={{
                                                fontSize: '0.6rem',
                                                padding: '0.05rem 0.5rem',
                                                borderRadius: '100px',
                                                background: '#e5e7eb',
                                                color: '#6b7280',
                                                fontWeight: 500,
                                                marginLeft: '0.3rem'
                                            }}>
                                                {getItemStatus(item)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="search-dropdown-item-actions">
                                        {getItemTag && getItemTag(item) && (
                                            <span className="item-tag">{getItemTag(item)}</span>
                                        )}
                                        {getItemPrice && getItemPrice(item) && (
                                            <span className="item-price">{getItemPrice(item)}</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                            {renderPagination()}
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

// =============================================
// 🔥 COMPONENTE TOGGLE PRODUTO/SERVIÇO
// =============================================
function ToggleProdutoServico({
    tipo,
    onChange,
    onAddProduto,
    onAddServico,
    disabled = false,
    showProduto = true,
    showServico = true
}) {
    const tipoEfetivo = useMemo(() => {
        if (!showProduto && showServico) return 'servico';
        if (showProduto && !showServico) return 'produto';
        return tipo;
    }, [showProduto, showServico, tipo]);

    const mostrarProduto = showProduto === true;
    const mostrarServico = showServico === true;

    const temAlgumVisivel = mostrarProduto || mostrarServico;
    const mostrarProdutoFinal = temAlgumVisivel ? mostrarProduto : false;
    const mostrarServicoFinal = temAlgumVisivel ? mostrarServico : true;

    const isSingleButton = !(mostrarProdutoFinal && mostrarServicoFinal);

    return (
        <div className="toggle-wrapper">
            <div className={`toggle-produto-servico ${isSingleButton ? 'single-button' : ''}`}>
                {mostrarProdutoFinal && (
                    <button
                        type="button"
                        className={`toggle-option ${tipoEfetivo === 'produto' ? 'active' : ''}`}
                        onClick={() => !disabled && onChange('produto')}
                        disabled={disabled}
                    >
                        <Icon name="inventory_2" size={14} /> Produtos
                    </button>
                )}
                {mostrarServicoFinal && (
                    <button
                        type="button"
                        className={`toggle-option ${tipoEfetivo === 'servico' ? 'active' : ''}`}
                        onClick={() => !disabled && onChange('servico')}
                        disabled={disabled}
                    >
                        <Icon name="build" size={14} /> Serviços
                    </button>
                )}
                {mostrarProdutoFinal && mostrarServicoFinal && (
                    <div
                        className="toggle-slider"
                        style={{
                            transform: tipoEfetivo === 'produto'
                                ? 'translateX(0)'
                                : 'translateX(calc(100% + 3px))'
                        }}
                    />
                )}
            </div>
            <div className="toggle-actions">
                {tipoEfetivo === 'produto' && mostrarProdutoFinal ? (
                    <button
                        type="button"
                        className="btn-add-toggle"
                        onClick={onAddProduto}
                        title="Adicionar novo produto"
                    >
                        <Icon name="add" size={16} />
                    </button>
                ) : mostrarServicoFinal ? (
                    <button
                        type="button"
                        className="btn-add-toggle"
                        onClick={onAddServico}
                        title="Adicionar novo serviço"
                    >
                        <Icon name="add" size={16} />
                    </button>
                ) : null}
            </div>
        </div>
    );
}

// =============================================
// COMPONENTE PRINCIPAL
// =============================================
export default function Faturas() {
    // =============================================
    // ESTADOS PRINCIPAIS
    // =============================================
    const [faturas, setFaturas] = useState([]);
    const [filteredFaturas, setFilteredFaturas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filtroStatus, setFiltroStatus] = useState('todos');

    const [expandedRows, setExpandedRows] = useState({});
    const [itensPage, setItensPage] = useState({});

    // =============================================
    // ESTADO PARA TOAST
    // =============================================
    const [toast, setToast] = useState({ message: '', type: '' });

    const showToast = (text, type = 'success') => {
        setToast({ message: text, type });
    };

    const closeToast = () => {
        setToast({ message: '', type: '' });
    };

    // =============================================
    // 🔥 REF PARA GUARDAR O IVA PERMANENTEMENTE
    // =============================================
    const ivaRef = useRef(null);

    // =============================================
    // CONFIGURAÇÕES DA EMPRESA - COM SUBMODULOS
    // =============================================
    const [empresaConfig, setEmpresaConfig] = useState({
        id: null,
        nome: '',
        nomeCurto: '',
        slug: '',
        imagemPerfil: null,
        nuit: '',
        alvara: '',
        email: '',
        emailAlternativo: '',
        telefone: '',
        telefoneAlternativo: '',
        whatsapp: '',
        website: '',
        morada: {
            rua: '',
            numero: '',
            complemento: '',
            bairro: '',
            quarteirao: '',
            casa: '',
            cidade: '',
            provincia: '',
            distrito: '',
            postoAdministrativo: '',
            pais: '',
            codigoPostal: '',
            coordenadas: {},
            enderecoCompleto: ''
        },
        dadosBancarios: [],
        bancoPrincipal: null,
        regimeIVA: 'Normal',
        retencoaFonte: false,
        moeda: {
            simbolo: 'MT',
            codigo: 'MZN',
            casasDecimais: 2,
            separadorDecimal: ',',
            separadorMilhar: '.',
            posicaoSimbolo: 'depois',
            nome: 'Metical'
        },
        formatacao: {
            data: { formato: 'DD/MM/YYYY', separador: '/', incluirHora: false },
            numero: { separadorDecimal: ',', separadorMilhar: '.', casasDecimais: 2 }
        },
        configuracao: {
            plano: {},
            setorActividade: '',
            ramoAtividade: ''
        },
        status: 'Ativa',
        arquivado: false,
        cafe: '',
        criadoEm: null,
        actualizadoEm: null,
        dataArquivo: null,
        motivoArquivo: '',
        utilizadores: [],
        actualizadoPor: null,
        contactosEmergencia: [],
        sedes: [],
        actividadesEconomicas: [],
        estatisticas: {},
        timezone: 'Africa/Maputo',
        idioma: 'pt-PT',
        formatoHora: '24h',
        modulos: {
            gestaoStock: false,
            gestaoProdutos: false,
            gestaoServicos: false,
            gestaoEstoque: false,
            gestaoArmazens: false,
            gestaoInventario: false,
            gestaoCategorias: false,
            gestaoFrotas: false,
            gestaoProjetos: false,
            gestaoRh: false,
            gestaoAtivos: false
        }
    });

    const [percentuaisIva, setPercentuaisIva] = useState(PERCENTUAIS_IVA_PADRAO);

    // =============================================
    // MODAIS
    // =============================================
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showPayModal, setShowPayModal] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showClienteModal, setShowClienteModal] = useState(false);
    const [showProdutoModal, setShowProdutoModal] = useState(false);
    const [showServicoModal, setShowServicoModal] = useState(false);

    // 🔥 Estado para o modal de criação de Guia de Entrega
    const [showCreateGuiaModal, setShowCreateGuiaModal] = useState(false);
    const [faturaParaGuia, setFaturaParaGuia] = useState(null);

    const [faturaToDelete, setFaturaToDelete] = useState(null);
    const [faturaToPay, setFaturaToPay] = useState(null);
    const [faturaToCancel, setFaturaToCancel] = useState(null);
    const [faturaDetalhes, setFaturaDetalhes] = useState(null);
    const [motivoCancelamento, setMotivoCancelamento] = useState('');
    const [dataPagamento, setDataPagamento] = useState('');

    // 🔥 ESTADOS PARA REGISTRO DE PAGAMENTO
    const [formaPagamentoSelecionada, setFormaPagamentoSelecionada] = useState('Dinheiro');
    const [detalhesPagamento, setDetalhesPagamento] = useState('');
    const [observacaoPagamento, setObservacaoPagamento] = useState('');
    const [showDetalhesPagamento, setShowDetalhesPagamento] = useState(false);

    const [message, setMessage] = useState({ text: '', type: '' });

    const [ivaIncluso, setIvaIncluso] = useState(false);
    const [empresaId, setEmpresaId] = useState(null);

    // 🔥 Inicializar tipoItem baseado no módulo Stock
    const [tipoItem, setTipoItem] = useState(() => {
        const userStr = localStorage.getItem('usuario');
        let stockActive = false;
        try {
            if (userStr) {
                const user = JSON.parse(userStr);
                const empresaModulos = user.empresa?.modulos || {};
                stockActive = empresaModulos.gestaoStock === true ||
                    empresaModulos.stock === true ||
                    empresaModulos.estoque === true;
            }
        } catch (e) {
            console.warn('⚠️ Erro ao verificar módulo Stock:', e);
        }
        return stockActive ? 'produto' : 'servico';
    });

    // =============================================
    // ESTATÍSTICAS
    // =============================================
    const [stats, setStats] = useState({
        total: 0,
        rascunho: 0,
        aberta: 0,
        emitida: 0,
        pago: 0,
        vencida: 0,
        cancelada: 0,
        totalValor: 0,
        totalValorFormatado: '0 MT'
    });

    // =============================================
    // PAGINAÇÃO
    // =============================================
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 11,
        total: 0,
        pages: 0
    });

    // =============================================
    // DADOS AUXILIARES
    // =============================================
    const [clientes, setClientes] = useState([]);
    const [clientesFiltrados, setClientesFiltrados] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [servicos, setServicos] = useState([]);

    // =============================================
    // FORM DATA - CRIAÇÃO
    // =============================================
    const [formData, setFormData] = useState({
        clienteId: '',
        produtos: [],
        ivaPercent: null,
        descontoGlobal: 0,
        dataEmissao: new Date().toISOString().split('T')[0],
        dataVencimento: '',
        observacoes: '',
        status: 'Aberta'
    });

    const [editFormData, setEditFormData] = useState(null);
    const [novoItem, setNovoItem] = useState({
        id: '',
        quantidade: 1,
        precoUnitario: 0,
        descontoPercentual: 0,
        tipo: 'produto'
    });

    // =============================================
    // 🔥 ESTADO PARA EDIÇÃO DE ITEM
    // =============================================
    const [itemEditando, setItemEditando] = useState({
        index: null,
        isEdit: false,
        dados: null
    });

    // =============================================
    // ESTADOS PARA PESQUISA
    // =============================================
    const [searchCliente, setSearchCliente] = useState('');
    const [searchClienteEdit, setSearchClienteEdit] = useState('');
    const [searchItem, setSearchItem] = useState('');
    const [searchItemEdit, setSearchItemEdit] = useState('');

    // =============================================
    // 🔥 FUNÇÃO PARA VERIFICAR SE O MÓDULO STOCK ESTÁ ATIVO
    // =============================================
    const hasStockModule = useCallback(() => {
        return empresaConfig?.modulos?.gestaoStock === true;
    }, [empresaConfig]);

    const shouldShowProdutos = useCallback(() => {
        if (!hasStockModule()) return false;
        const modulos = empresaConfig?.modulos || {};
        const hasProdutoSubmodulo =
            modulos.gestaoProdutos === true ||
            modulos.gestaoEstoque === true ||
            modulos.gestaoArmazens === true ||
            modulos.gestaoInventario === true;
        const hasServicoSubmodulo =
            modulos.gestaoServicos === true ||
            modulos.gestaoCategorias === true;
        if (hasServicoSubmodulo && !hasProdutoSubmodulo) return false;
        if (hasProdutoSubmodulo) return true;
        return produtos.length > 0;
    }, [empresaConfig, produtos, hasStockModule]);

    const shouldShowServicos = useCallback(() => {
        if (!hasStockModule()) return false;
        const modulos = empresaConfig?.modulos || {};
        const hasServicoSubmodulo =
            modulos.gestaoServicos === true ||
            modulos.gestaoCategorias === true;
        const hasProdutoSubmodulo =
            modulos.gestaoProdutos === true ||
            modulos.gestaoEstoque === true ||
            modulos.gestaoArmazens === true ||
            modulos.gestaoInventario === true;
        if (hasProdutoSubmodulo && !hasServicoSubmodulo) return false;
        if (hasServicoSubmodulo) return true;
        return servicos.length > 0 || hasStockModule();
    }, [empresaConfig, servicos, hasStockModule]);

    const showProduto = shouldShowProdutos();
    const showServico = shouldShowServicos();

    // =============================================
    // API INSTANCE
    // =============================================
    const api = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    });

    // =============================================
    // FUNÇÃO PARA FORMATAR MOEDA
    // =============================================
    const formatarMoeda = useMemo(() => {
        return (valor) => {
            const cfg = empresaConfig.moeda;
            const sepDec = cfg.separadorDecimal || ',';
            const sepMil = cfg.separadorMilhar || '.';
            const casasDec = cfg.casasDecimais || 2;
            const simbolo = cfg.simbolo || 'MT';

            if (valor === undefined || valor === null || isNaN(valor)) {
                const zeros = '0'.repeat(casasDec);
                return `0${sepDec}${zeros} ${simbolo}`;
            }

            let valorFormatado = Number(valor).toFixed(casasDec);
            valorFormatado = valorFormatado.replace('.', sepDec);

            const partes = valorFormatado.split(sepDec);
            partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMil);
            valorFormatado = partes.join(sepDec);

            return `${valorFormatado} ${simbolo}`;
        };
    }, [empresaConfig.moeda]);

    // =============================================
    // FUNÇÃO PARA FORMATAR DATA
    // =============================================
    const formatarData = useCallback((data) => {
        if (!data) return '-';
        const d = new Date(data);
        if (isNaN(d.getTime())) return '-';

        const cfg = empresaConfig.formatacao?.data || { formato: 'DD/MM/YYYY', separador: '/' };
        let formato = cfg.formato || 'DD/MM/YYYY';
        const dia = String(d.getDate()).padStart(2, '0');
        const mes = String(d.getMonth() + 1).padStart(2, '0');
        const ano = d.getFullYear();

        formato = formato.replace('DD', dia);
        formato = formato.replace('MM', mes);
        formato = formato.replace('YYYY', ano);
        formato = formato.replace('YY', String(ano).slice(-2));

        if (cfg.incluirHora) {
            const horas = String(d.getHours()).padStart(2, '0');
            const minutos = String(d.getMinutes()).padStart(2, '0');
            return `${formato} ${horas}:${minutos}`;
        }

        return formato;
    }, [empresaConfig.formatacao]);

    // =============================================
    // FUNÇÕES AUXILIARES
    // =============================================
    const getClienteNome = (fatura) => {
        if (!fatura) return 'N/A';
        if (fatura.clienteInfo?.nome) return fatura.clienteInfo.nome;
        if (fatura.clienteId?.nome) return fatura.clienteId.nome;
        if (typeof fatura.clienteId === 'string') return 'Carregando...';
        return 'N/A';
    };

    const getClienteNif = (fatura) => {
        if (!fatura) return '';
        if (fatura.clienteInfo?.nif) return fatura.clienteInfo.nif;
        if (fatura.clienteId?.nif) return fatura.clienteId.nif;
        if (fatura.clienteId?.nuit) return fatura.clienteId.nuit;
        return '';
    };

    const getItemNome = (item) => {
        if (!item) return 'N/A';
        if (item.produtoInfo?.nome) return item.produtoInfo.nome;
        if (item.produtoId?.nome) return item.produtoId.nome;
        if (item.servicoId?.nome) return item.servicoId.nome;
        if (item.nomeItem) return item.nomeItem;
        return 'N/A';
    };

    const getItemCodigo = (item) => {
        if (!item) return '';
        if (item.produtoInfo?.codigo) return item.produtoInfo.codigo;
        if (item.produtoId?.codigo) return item.produtoId.codigo;
        if (item.servicoId?.codigo) return item.servicoId.codigo;
        return '';
    };

    const getDescontoDisplay = (fatura) => {
        if (fatura.descontoGlobal !== undefined && fatura.descontoGlobal > 0) {
            return `${fatura.descontoGlobal}%`;
        }
        return '-';
    };

    const getTotalDisplay = (fatura) => {
        if (fatura.totalFormatado) return fatura.totalFormatado;
        return formatarMoeda(fatura.total || 0);
    };

    const getVencimentoDisplay = (fatura) => {
        if (fatura.dataVencimentoFormatado) return fatura.dataVencimentoFormatado;
        return formatarData(fatura.dataVencimento);
    };

    const getStatusFormatado = (fatura) => {
        return fatura.statusFormatado || getStatusInfo(fatura.status).label;
    };

    const getStatusClass = (fatura) => {
        return fatura.statusClass || (fatura.status || 'Rascunho').toLowerCase();
    };

    const getStatusIcon = (fatura) => {
        return fatura.statusIcon || getStatusInfo(fatura.status).icon;
    };

    const getIvaDescricao = (fatura) => {
        if (fatura.ivaIncluso) return 'Incluso';
        return fatura.ivaDescricao || `${fatura.ivaPercent || 0}%`;
    };

    const getTotais = (itens, ivaPercent, descontoGlobal = 0, ivaInclusoParam = false) => {
        if (!itens || itens.length === 0) {
            return { subtotal: 0, descontoValor: 0, subtotalComDesconto: 0, iva: 0, total: 0, ivaIncluso: ivaInclusoParam };
        }

        let subtotal = itens.reduce((acc, p) => acc + (p.quantidade * p.precoUnitario * (1 - (p.descontoPercentual || 0) / 100)), 0);

        let descontoValor = 0;
        let subtotalComDesconto = subtotal;
        if (descontoGlobal > 0 && subtotal > 0) {
            descontoValor = subtotal * (descontoGlobal / 100);
            subtotalComDesconto = subtotal - descontoValor;
        }

        let iva = 0;
        let total = subtotalComDesconto;

        if (!ivaInclusoParam) {
            iva = subtotalComDesconto * ((ivaPercent || 0) / 100);
            total = subtotalComDesconto + iva;
        }

        return { subtotal, descontoValor, subtotalComDesconto, iva, total, ivaIncluso: ivaInclusoParam };
    };

    // =============================================
    // FUNÇÕES DE PESQUISA
    // =============================================
    const selecionarCliente = (cliente) => {
        if (!cliente) return;
        setFormData(prev => ({ ...prev, clienteId: cliente._id }));
        setSearchCliente(cliente.nome);
    };

    const selecionarClienteEdit = (cliente) => {
        if (!cliente) return;
        setEditFormData(prev => ({ ...prev, clienteId: cliente._id }));
        setSearchClienteEdit(cliente.nome);
    };

    const limparSelecaoCliente = () => {
        setFormData(prev => ({ ...prev, clienteId: '' }));
        setSearchCliente('');
    };

    const limparSelecaoClienteEdit = () => {
        setEditFormData(prev => ({ ...prev, clienteId: '' }));
        setSearchClienteEdit('');
    };

    const getItemsPorTipo = useCallback(() => {
        if (tipoItem === 'produto') {
            return produtos || [];
        } else {
            return servicos || [];
        }
    }, [tipoItem, produtos, servicos]);

    const getItemLabel = useCallback((item) => {
        return item?.nome || 'Item sem nome';
    }, []);

    const getItemSub = useCallback((item) => {
        return item?.codigo ? `Cód: ${item.codigo}` : '';
    }, []);

    const getItemTag = useCallback((item) => {
        if (tipoItem === 'produto') {
            return item?.categoria?.nome || 'Produto';
        }
        return item?.categoria?.nome || 'Serviço';
    }, [tipoItem]);

    const getItemPrice = useCallback((item) => {
        return formatarMoeda(item?.precoVenda || 0);
    }, [formatarMoeda]);

    const selecionarItem = (item) => {
        if (!item) return;
        setNovoItem(prev => ({
            ...prev,
            id: item._id,
            precoUnitario: item.precoVenda || 0,
            descontoPercentual: 0,
            tipo: tipoItem
        }));
        setSearchItem(item.nome);
    };

    const selecionarItemEdit = (item) => {
        if (!item) return;
        setNovoItem(prev => ({
            ...prev,
            id: item._id,
            precoUnitario: item.precoVenda || 0,
            descontoPercentual: 0,
            tipo: tipoItem
        }));
        setSearchItemEdit(item.nome);
    };

    const limparSelecaoItem = () => {
        setNovoItem({
            id: '',
            quantidade: 1,
            precoUnitario: 0,
            descontoPercentual: 0,
            tipo: tipoItem
        });
        setSearchItem('');
    };

    const limparSelecaoItemEdit = () => {
        setNovoItem({
            id: '',
            quantidade: 1,
            precoUnitario: 0,
            descontoPercentual: 0,
            tipo: tipoItem
        });
        setSearchItemEdit('');
    };

    // =============================================
    // HANDLERS PARA ADICIONAR PRODUTO/SERVIÇO
    // =============================================
    const handleAddProduto = () => {
        setShowProdutoModal(true);
    };

    const handleAddServico = () => {
        setShowServicoModal(true);
    };

    const handleProdutoCriado = (produto) => {
        fetchProdutos();
        if (produto) {
            setTipoItem('produto');
            setNovoItem(prev => ({
                ...prev,
                id: produto._id,
                precoUnitario: produto.precoVenda || 0,
                descontoPercentual: 0,
                tipo: 'produto'
            }));
            setSearchItem(produto.nome);
        }
        showToast(`Produto "${produto.nome}" adicionado com sucesso!`, 'success');
    };

    const handleServicoCriado = (servico) => {
        fetchServicos();
        if (servico) {
            setTipoItem('servico');
            setNovoItem(prev => ({
                ...prev,
                id: servico._id,
                precoUnitario: servico.precoVenda || 0,
                descontoPercentual: 0,
                tipo: 'servico'
            }));
            setSearchItem(servico.nome);
        }
        showToast(`Serviço "${servico.nome}" adicionado com sucesso!`, 'success');
    };

    // =============================================
    // 🔥 FUNÇÃO PARA INICIAR EDIÇÃO DE ITEM
    // =============================================
    const iniciarEdicaoItem = (index, isEdit = false) => {
        const produtos = isEdit ? editFormData.produtos : formData.produtos;
        const item = produtos[index];

        if (!item) return;

        const isServico = !!item.servicoId;
        const itemId = isServico ? item.servicoId : item.produtoId;
        const itemsList = isServico ? servicos : produtos;
        const itemData = itemsList.find(p => p._id === itemId);
        const nomeItem = itemData ? itemData.nome : item.nomeItem || 'Item';

        const tipoItemAtual = isServico ? 'servico' : 'produto';

        setItemEditando({
            index: index,
            isEdit: isEdit,
            dados: {
                ...item,
                nomeItem: nomeItem,
                tipoItem: tipoItemAtual,
                itemId: itemId,
                itemData: itemData
            }
        });

        setNovoItem({
            id: itemId || '',
            quantidade: item.quantidade || 1,
            precoUnitario: item.precoUnitario || 0,
            descontoPercentual: item.descontoPercentual || 0,
            tipo: tipoItemAtual
        });

        setTipoItem(tipoItemAtual);

        if (isEdit) {
            setSearchItemEdit(nomeItem);
        } else {
            setSearchItem(nomeItem);
        }
    };

    // =============================================
    // 🔥 FUNÇÃO PARA SALVAR EDIÇÃO DE ITEM
    // =============================================
    const salvarEdicaoItem = () => {
        const { index, isEdit } = itemEditando;

        if (index === null) return;

        if (!novoItem.id) {
            showToast(`Selecione um ${tipoItem === 'produto' ? 'produto' : 'serviço'}`, 'danger');
            return;
        }

        if (novoItem.quantidade <= 0) {
            showToast('Quantidade deve ser maior que zero', 'danger');
            return;
        }

        if (novoItem.precoUnitario <= 0) {
            showToast('Preço unitário deve ser maior que zero', 'danger');
            return;
        }

        let nomeItem = '';
        let codigoItem = '';
        let tipoLabel = tipoItem === 'produto' ? 'Produto' : 'Servico';
        const itemsList = tipoItem === 'produto' ? produtos : servicos;
        const itemData = itemsList.find(p => p._id === novoItem.id);
        if (itemData) {
            nomeItem = itemData.nome || '';
            codigoItem = itemData.codigo || '';
        }

        const descontoPercentual = parseFloat(novoItem.descontoPercentual) || 0;

        const itemAtualizado = {
            quantidade: parseInt(novoItem.quantidade),
            precoUnitario: parseFloat(novoItem.precoUnitario),
            descontoPercentual: descontoPercentual,
            nomeItem: nomeItem,
            codigoItem: codigoItem,
            tipoItem: tipoLabel
        };

        if (tipoItem === 'produto') {
            itemAtualizado.produtoId = novoItem.id;
        } else {
            itemAtualizado.servicoId = novoItem.id;
        }

        if (isEdit && editFormData) {
            const novosProdutos = [...editFormData.produtos];
            novosProdutos[index] = itemAtualizado;
            setEditFormData(prev => ({
                ...prev,
                produtos: novosProdutos
            }));
        } else {
            const novosProdutos = [...formData.produtos];
            novosProdutos[index] = itemAtualizado;
            setFormData(prev => ({
                ...prev,
                produtos: novosProdutos
            }));
        }

        cancelarEdicaoItem();
        showToast('Item atualizado com sucesso!', 'success');
    };

    // =============================================
    // 🔥 FUNÇÃO PARA CANCELAR EDIÇÃO DE ITEM
    // =============================================
    const cancelarEdicaoItem = () => {
        setItemEditando({
            index: null,
            isEdit: false,
            dados: null
        });
        setNovoItem({
            id: '',
            quantidade: 1,
            precoUnitario: 0,
            descontoPercentual: 0,
            tipo: tipoItem
        });
        setSearchItem('');
        setSearchItemEdit('');
    };

    // =============================================
    // ADICIONAR ITEM
    // =============================================
    const adicionarItem = (isEdit = false) => {
        if (itemEditando.index !== null) {
            salvarEdicaoItem();
            return;
        }

        if (!novoItem.id) {
            showToast(`Selecione um ${tipoItem === 'produto' ? 'produto' : 'serviço'}`, 'danger');
            return;
        }

        if (novoItem.quantidade <= 0) {
            showToast('Quantidade deve ser maior que zero', 'danger');
            return;
        }

        if (novoItem.precoUnitario <= 0) {
            showToast('Preço unitário deve ser maior que zero', 'danger');
            return;
        }

        const produtosAtuais = isEdit ? editFormData.produtos : formData.produtos;

        const itemExistente = produtosAtuais.find(p => {
            if (tipoItem === 'produto') {
                return p.produtoId === novoItem.id;
            } else {
                return p.servicoId === novoItem.id;
            }
        });

        if (itemExistente) {
            showToast(`${tipoItem === 'produto' ? 'Produto' : 'Serviço'} já adicionado`, 'warning');
            return;
        }

        let nomeItem = '';
        let codigoItem = '';
        let tipoLabel = tipoItem === 'produto' ? 'Produto' : 'Servico';
        const itemsList = tipoItem === 'produto' ? produtos : servicos;
        const itemData = itemsList.find(p => p._id === novoItem.id);
        if (itemData) {
            nomeItem = itemData.nome || '';
            codigoItem = itemData.codigo || '';
        }

        const descontoPercentual = parseFloat(novoItem.descontoPercentual) || 0;

        const item = {
            quantidade: parseInt(novoItem.quantidade),
            precoUnitario: parseFloat(novoItem.precoUnitario),
            descontoPercentual: descontoPercentual,
            nomeItem: nomeItem,
            codigoItem: codigoItem,
            tipoItem: tipoLabel
        };

        if (tipoItem === 'produto') {
            item.produtoId = novoItem.id;
        } else {
            item.servicoId = novoItem.id;
        }

        if (isEdit) {
            setEditFormData(prev => ({
                ...prev,
                produtos: [...prev.produtos, item]
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                produtos: [...prev.produtos, item]
            }));
        }

        setNovoItem({
            id: '',
            quantidade: 1,
            precoUnitario: 0,
            descontoPercentual: 0,
            tipo: tipoItem
        });
        setSearchItem('');
        setSearchItemEdit(isEdit ? '' : '');
    };

    const removerItem = (index, isEdit = false) => {
        if (isEdit && editFormData) {
            setEditFormData(prev => ({
                ...prev,
                produtos: prev.produtos.filter((_, i) => i !== index)
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                produtos: prev.produtos.filter((_, i) => i !== index)
            }));
        }
    };

    // =============================================
    // BUSCAR DADOS
    // =============================================
    const fetchClientes = async () => {
        try {
            const response = await api.get('/clientes?limit=100');
            if (response.data && response.data.data) {
                setClientes(response.data.data);
                setClientesFiltrados(response.data.data);
            }
        } catch (error) {
            console.error('❌ Erro ao carregar clientes:', error);
        }
    };

    const fetchProdutos = async () => {
        try {
            console.log('📦 Buscando produtos...');
            const response = await api.get('/produtos?limit=100');
            if (response.data && response.data.data) {
                console.log(`📦 ${response.data.data.length} produtos carregados`);
                setProdutos(response.data.data);
            }
        } catch (error) {
            console.error('❌ Erro ao carregar produtos:', error);
        }
    };

    const fetchServicos = async () => {
        try {
            console.log('🔧 Iniciando busca de serviços...');
            const response = await api.get('/servicos?limit=1000');

            if (response.data && response.data.success !== false) {
                let servicosData = response.data.data;
                if (!servicosData) {
                    servicosData = response.data;
                }
                if (servicosData && !Array.isArray(servicosData) && servicosData.data) {
                    servicosData = servicosData.data;
                }
                if (Array.isArray(servicosData)) {
                    console.log(`✅ ${servicosData.length} serviços carregados com sucesso!`);
                    setServicos(servicosData);
                    return servicosData;
                } else {
                    console.warn('⚠️ Dados recebidos não são um array:', servicosData);
                    setServicos([]);
                    return [];
                }
            } else {
                console.warn('⚠️ Resposta da API indica erro:', response.data);
                setServicos([]);
                return [];
            }
        } catch (error) {
            console.error('❌ Erro ao carregar serviços:', error);
            try {
                console.log('🔄 Tentando rota alternativa sem /api...');
                const response2 = await api.get('/servicos?limit=1000');
                if (response2.data && response2.data.success !== false) {
                    let servicosData = response2.data.data || response2.data;
                    if (Array.isArray(servicosData)) {
                        console.log(`✅ ${servicosData.length} serviços carregados (rota alternativa)!`);
                        setServicos(servicosData);
                        return servicosData;
                    }
                }
            } catch (error2) {
                console.error('❌ Rota alternativa também falhou:', error2);
            }
            setServicos([]);
            return [];
        }
    };

    // =============================================
    // fetchFaturas
    // =============================================
    const fetchFaturas = async (showLoading = true, pageOverride = null) => {
        if (showLoading) setTableLoading(true);
        setLoading(true);

        const currentPage = pageOverride !== null ? pageOverride : pagination.page;

        try {
            const params = new URLSearchParams();
            if (searchTerm) params.append('search', searchTerm);
            if (filtroStatus && filtroStatus !== 'todos') params.append('status', filtroStatus);
            params.append('page', currentPage);
            params.append('limit', pagination.limit);

            console.log(`📄 Buscando página ${currentPage}...`);

            const response = await api.get(`/faturas?${params.toString()}`);

            if (response.data) {
                if (response.data.empresa) {
                    const empresa = response.data.empresa;

                    const morada = empresa.morada || {};
                    const enderecoCompleto = [
                        morada.rua,
                        morada.numero,
                        morada.bairro,
                        morada.cidade,
                        morada.provincia,
                        morada.pais
                    ].filter(Boolean).join(', ');

                    const dadosBancarios = empresa.dadosBancarios || [];
                    const bancoPrincipal = dadosBancarios.find(b => b.principal === true) || dadosBancarios[0] || null;

                    const ivaPercent = empresa.percentagemIVA;

                    if (ivaPercent === undefined || ivaPercent === null) {
                        console.error('❌ ERRO: IVA da empresa não está definido!');
                        showToast('Erro: IVA da empresa não configurado. Contacte o administrador.', 'danger');
                        setLoading(false);
                        return;
                    }

                    console.log(`📊 IVA da empresa: ${ivaPercent}%`);
                    ivaRef.current = ivaPercent;

                    const modulos = empresa.modulos || empresa.modulosAtivos || {};

                    setEmpresaConfig(prev => ({
                        ...prev,
                        id: empresa.id || empresa._id,
                        nome: empresa.nome || '',
                        nomeCurto: empresa.nomeCurto || '',
                        slug: empresa.slug || '',
                        imagemPerfil: empresa.imagemPerfil || null,
                        nuit: empresa.nuit || '',
                        alvara: empresa.alvara || '',
                        email: empresa.email || '',
                        emailAlternativo: empresa.emailAlternativo || '',
                        telefone: empresa.telefone || '',
                        telefoneAlternativo: empresa.telefoneAlternativo || '',
                        whatsapp: empresa.whatsapp || '',
                        website: empresa.website || '',
                        morada: {
                            rua: morada.rua || '',
                            numero: morada.numero || '',
                            complemento: morada.complemento || '',
                            bairro: morada.bairro || '',
                            quarteirao: morada.quarteirao || '',
                            casa: morada.casa || '',
                            cidade: morada.cidade || '',
                            provincia: morada.provincia || '',
                            distrito: morada.distrito || '',
                            postoAdministrativo: morada.postoAdministrativo || '',
                            pais: morada.pais || 'Moçambique',
                            codigoPostal: morada.codigoPostal || '',
                            coordenadas: morada.coordenadas || {},
                            enderecoCompleto: enderecoCompleto
                        },
                        dadosBancarios: dadosBancarios,
                        bancoPrincipal: bancoPrincipal,
                        regimeIVA: empresa.regimeIVA || 'Normal',
                        percentagemIVA: ivaPercent,
                        retencoaFonte: empresa.retencoaFonte || false,
                        moeda: empresa.moeda || prev.moeda,
                        iva: {
                            ...prev.iva,
                            ...empresa.iva,
                            percentualPadrao: empresa.iva?.percentualPadrao ?? ivaPercent,
                            regimeAtivo: empresa.regimeIVA || 'Normal',
                            percentuaisPermitidos: empresa.iva?.percentuaisPermitidos || [0, 5, 16]
                        },
                        formatacao: empresa.formatacao || prev.formatacao,
                        configuracao: {
                            plano: empresa.configuracoes?.plano || {},
                            setorActividade: empresa.configuracoes?.setorActividade || '',
                            ramoAtividade: empresa.configuracoes?.ramoAtividade || ''
                        },
                        status: empresa.status || 'Ativa',
                        arquivado: empresa.arquivado || false,
                        cafe: empresa.cafe || '',
                        criadoEm: empresa.criadoEm || null,
                        actualizadoEm: empresa.actualizadoEm || null,
                        dataArquivo: empresa.dataArquivo || null,
                        motivoArquivo: empresa.motivoArquivo || '',
                        utilizadores: empresa.utilizadores || [],
                        actualizadoPor: empresa.actualizadoPor || null,
                        contactosEmergencia: empresa.contactosEmergencia || [],
                        sedes: empresa.sedes || [],
                        actividadesEconomicas: empresa.actividadesEconomicas || [],
                        estatisticas: empresa.estatisticas || {},
                        modulos: {
                            gestaoStock: modulos.gestaoStock === true || modulos.stock === true || modulos.estoque === true || false,
                            gestaoProdutos: modulos.gestaoProdutos === true || modulos.produtos === true || false,
                            gestaoServicos: modulos.gestaoServicos === true || modulos.servicos === true || false,
                            gestaoEstoque: modulos.gestaoEstoque === true || modulos.estoque === true || false,
                            gestaoArmazens: modulos.gestaoArmazens === true || modulos.armazens === true || false,
                            gestaoInventario: modulos.gestaoInventario === true || modulos.inventario === true || false,
                            gestaoCategorias: modulos.gestaoCategorias === true || modulos.categorias === true || false,
                            gestaoFrotas: modulos.gestaoFrotas === true || modulos.frotas === true || false,
                            gestaoProjetos: modulos.gestaoProjetos === true || modulos.projetos === true || false,
                            gestaoRh: modulos.gestaoRh === true || modulos.rh === true || false,
                            gestaoAtivos: modulos.gestaoAtivos === true || modulos.ativos === true || false
                        }
                    }));

                    if (empresa.iva?.percentuaisPermitidos) {
                        setPercentuaisIva(empresa.iva.percentuaisPermitidos);
                    }

                    const ivaPadrao = empresa.iva?.percentualPadrao ?? ivaPercent;
                    if (!showCreateModal) {
                        setFormData(prev => ({ ...prev, ivaPercent: ivaPadrao }));
                    }
                }

                if (response.data.data && Array.isArray(response.data.data)) {
                    setFaturas(response.data.data);
                    setFilteredFaturas(response.data.data);

                    if (response.data.pagination) {
                        const newPagination = {
                            ...response.data.pagination,
                            page: currentPage
                        };
                        setPagination(newPagination);
                    }

                    if (response.data.resumo) {
                        const resumo = response.data.resumo;
                        const statsData = {
                            total: response.data.pagination?.total || 0,
                            rascunho: 0,
                            aberta: 0,
                            emitida: 0,
                            pago: 0,
                            vencida: 0,
                            cancelada: 0,
                            totalValor: 0,
                            totalValorFormatado: '0 MT'
                        };

                        resumo.forEach(item => {
                            if (item.status === 'Rascunho') statsData.rascunho = item.count;
                            if (item.status === 'Aberta') statsData.aberta = item.count;
                            if (item.status === 'Emitida') statsData.emitida = item.count;
                            if (item.status === 'Pago') statsData.pago = item.count;
                            if (item.status === 'Vencida') statsData.vencida = item.count;
                            if (item.status === 'Cancelada') statsData.cancelada = item.count;
                            statsData.totalValor += item.total || 0;
                            if (item.totalFormatado) {
                                statsData.totalValorFormatado = item.totalFormatado;
                            }
                        });

                        setStats(statsData);
                    }
                } else {
                    setFaturas([]);
                    setFilteredFaturas([]);
                }
            }
        } catch (error) {
            console.error('❌ Erro ao carregar faturas:', error);
            showMessage('Erro ao carregar faturas', 'danger');
            setFaturas([]);
            setFilteredFaturas([]);
        } finally {
            setLoading(false);
            setTableLoading(false);
        }
    };

    // =============================================
    // FUNÇÃO PARA VERIFICAR CAMPOS OBRIGATÓRIOS
    // =============================================
    const camposObrigatoriosPreenchidos = useCallback(() => {
        if (!formData.clienteId) return false;
        if (!formData.dataVencimento) return false;
        if (formData.produtos.length === 0) return false;
        for (const item of formData.produtos) {
            if (!item.quantidade || item.quantidade <= 0) return false;
            if (!item.precoUnitario || item.precoUnitario <= 0) return false;
        }
        return true;
    }, [formData.clienteId, formData.dataVencimento, formData.produtos]);

    // =============================================
    // CRIAR FATURA
    // =============================================
    const handleCreate = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!formData.clienteId) {
            showToast('Selecione um cliente', 'danger');
            setLoading(false);
            return;
        }

        if (formData.produtos.length === 0) {
            showToast('Adicione pelo menos um produto ou serviço', 'danger');
            setLoading(false);
            return;
        }

        if (!formData.dataVencimento) {
            showToast('Data de vencimento é obrigatória', 'danger');
            setLoading(false);
            return;
        }

        try {
            const ivaPercentFinal = empresaConfig.percentagemIVA;

            if (ivaPercentFinal === undefined || ivaPercentFinal === null) {
                showToast('Erro: IVA da empresa não configurado. Contacte o administrador.', 'danger');
                setLoading(false);
                return;
            }

            const dadosEnvio = {
                clienteId: formData.clienteId,
                produtos: formData.produtos.map(p => {
                    const item = {
                        quantidade: p.quantidade,
                        precoUnitario: p.precoUnitario,
                        descontoPercentual: p.descontoPercentual || 0
                    };
                    if (p.produtoId) item.produtoId = p.produtoId;
                    if (p.servicoId) item.servicoId = p.servicoId;
                    return item;
                }),
                ivaPercent: ivaPercentFinal,
                ivaIncluso: ivaIncluso,
                descontoGlobal: parseFloat(formData.descontoGlobal) || 0,
                dataEmissao: formData.dataEmissao || new Date().toISOString().split('T')[0],
                dataVencimento: formData.dataVencimento,
                observacoes: formData.observacoes || '',
                status: formData.status || 'Rascunho'
            };

            console.log('📤 Enviando dados para API:', dadosEnvio);

            const response = await api.post('/faturas', dadosEnvio);

            if (response.data) {
                showToast('Fatura criada com sucesso!', 'success');
                setShowCreateModal(false);
                resetForm();
                cancelarEdicaoItem();
                fetchFaturas(false);
            }
        } catch (error) {
            console.error('❌ Erro ao criar fatura:', error);
            showToast(error.response?.data?.erro || 'Erro ao criar fatura', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // 🔥 DUPLICAR FATURA
    // =============================================
    const duplicarFatura = async (fatura) => {
        setLoading(true);
        try {
            console.log(`📋 Duplicando fatura ${fatura.numero}...`);

            const response = await api.get(`/faturas/${fatura._id}`);
            const dadosOriginal = response.data.data;

            const dadosDuplicados = {
                clienteId: dadosOriginal.clienteId._id || dadosOriginal.clienteId,
                produtos: dadosOriginal.produtos.map(item => {
                    const produto = {
                        quantidade: item.quantidade,
                        precoUnitario: item.precoUnitario,
                        descontoPercentual: item.descontoPercentual || 0
                    };
                    if (item.produtoId) {
                        produto.produtoId = typeof item.produtoId === 'object' ? item.produtoId._id : item.produtoId;
                    }
                    if (item.servicoId) {
                        produto.servicoId = typeof item.servicoId === 'object' ? item.servicoId._id : item.servicoId;
                    }
                    return produto;
                }),
                ivaPercent: dadosOriginal.ivaPercent || empresaConfig.percentagemIVA,
                ivaIncluso: dadosOriginal.ivaIncluso || false,
                descontoGlobal: dadosOriginal.descontoGlobal || 0,
                dataEmissao: new Date().toISOString().split('T')[0],
                dataVencimento: dadosOriginal.dataVencimento ? new Date(dadosOriginal.dataVencimento).toISOString().split('T')[0] : '',
                observacoes: `Fatura duplicada de ${dadosOriginal.numero} - ${new Date().toLocaleDateString()}`,
                status: 'Duplicado'
            };

            console.log('📤 Enviando dados duplicados:', dadosDuplicados);

            const createResponse = await api.post('/faturas', dadosDuplicados);

            if (createResponse.data) {
                showToast(`Fatura duplicada com sucesso! Nova fatura: ${createResponse.data.data.numero}`, 'success');
                setShowDetailsModal(false);
                fetchFaturas(false);
            }
        } catch (error) {
            console.error('❌ Erro ao duplicar fatura:', error);
            showToast(error.response?.data?.erro || 'Erro ao duplicar fatura', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // ATUALIZAR FATURA
    // =============================================
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!editFormData) return;
        setLoading(true);

        try {
            const ivaPercentFinal = empresaConfig.percentagemIVA;

            if (ivaPercentFinal === undefined || ivaPercentFinal === null) {
                showToast('Erro: IVA da empresa não configurado. Contacte o administrador.', 'danger');
                setLoading(false);
                return;
            }

            const dadosEnvio = {
                clienteId: editFormData.clienteId,
                produtos: editFormData.produtos.map(p => {
                    const item = {
                        quantidade: p.quantidade,
                        precoUnitario: p.precoUnitario,
                        descontoPercentual: p.descontoPercentual || 0
                    };
                    if (p.produtoId) item.produtoId = p.produtoId;
                    if (p.servicoId) item.servicoId = p.servicoId;
                    return item;
                }),
                ivaPercent: ivaPercentFinal,
                ivaIncluso: ivaIncluso,
                descontoGlobal: parseFloat(editFormData.descontoGlobal) || 0,
                dataEmissao: editFormData.dataEmissao || new Date().toISOString().split('T')[0],
                dataVencimento: editFormData.dataVencimento,
                observacoes: editFormData.observacoes,
                status: editFormData.status
            };

            console.log('📤 Enviando atualização:', dadosEnvio);

            const response = await api.put(`/faturas/${editFormData._id}`, dadosEnvio);

            if (response.data) {
                showToast('Fatura atualizada com sucesso!', 'success');
                setShowEditModal(false);
                setEditFormData(null);
                cancelarEdicaoItem();
                fetchFaturas(false);
            }
        } catch (error) {
            console.error('❌ Erro ao atualizar fatura:', error);
            showToast(error.response?.data?.erro || 'Erro ao atualizar fatura', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // REGISTRAR PAGAMENTO
    // 🔥 ALTERADO: Stock NÃO sai mais no pagamento
    // =============================================
    const registrarPagamento = async (id) => {
        setLoading(true);
        try {
            if (!formaPagamentoSelecionada) {
                showToast('Selecione a forma de pagamento', 'warning');
                setLoading(false);
                return;
            }

            if (formaPagamentoSelecionada !== 'Dinheiro' && !detalhesPagamento.trim()) {
                showToast('Informe os detalhes da transação (ex: número de referência)', 'warning');
                setLoading(false);
                return;
            }

            const dadosEnvio = {
                dataPagamento: dataPagamento || new Date().toISOString().split('T')[0],
                formaPagamento: formaPagamentoSelecionada,
                detalhesPagamento: detalhesPagamento.trim() || '',
                observacao: observacaoPagamento.trim() || ''
            };

            console.log('📤 Enviando pagamento:', dadosEnvio);

            const response = await api.post(`/faturas/${id}/pagar`, dadosEnvio);

            if (response.data) {
                showToast('Pagamento registado com sucesso!', 'success');

                const recibo = response.data.recibo;
                if (recibo) {
                    setTimeout(() => {
                        showToast(
                            `📄 Recibo ${recibo.numero} gerado automaticamente (${recibo.valorPagoFormatado || recibo.valorPago})`,
                            'success'
                        );
                    }, 600);
                }

                setTimeout(() => {
                    showToast(
                        '📦 O stock será atualizado quando a Guia de Entrega for confirmada',
                        'info'
                    );
                }, 1200);

                setShowPayModal(false);
                setFaturaToPay(null);
                setDataPagamento('');
                setFormaPagamentoSelecionada('Dinheiro');
                setDetalhesPagamento('');
                setObservacaoPagamento('');
                setShowDetalhesPagamento(false);

                fetchFaturas(false);

                if (faturaDetalhes && faturaDetalhes._id === id) {
                    setFaturaDetalhes(response.data.data);
                }

                window.dispatchEvent(new CustomEvent('recibo-criado', {
                    detail: {
                        recibo: recibo,
                        faturaId: id,
                        stockAtualizado: []
                    }
                }));
            }
        } catch (error) {
            console.error('❌ Erro ao registrar pagamento:', error);
            showToast(error.response?.data?.erro || 'Erro ao registrar pagamento', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // 🔥 CRIAR GUIA DE ENTREGA - ABRIR MODAL DE CONFIRMAÇÃO
    // =============================================
    const abrirCriarGuia = (fatura) => {
        // 🔥 Bloquear se já tem guia criada
        if (fatura.temGuiaCriada) {
            showToast(
                `Esta fatura já tem uma guia de entrega${fatura.guiaNumero ? ` (${fatura.guiaNumero})` : ''}`,
                'warning'
            );
            return;
        }

        setFaturaParaGuia(fatura);
        setShowCreateGuiaModal(true);
        if (showDetailsModal) {
            setShowDetailsModal(false);
        }
    };

    // =============================================
    // 🔥 CRIAR GUIA DE ENTREGA DIRETAMENTE VIA API
    // =============================================
    const confirmarCriarGuia = async () => {
        if (!faturaParaGuia) return;

        console.log('📦 Criando guia de entrega para fatura:', faturaParaGuia.numero);

        setLoading(true);

        try {
            // Preparar os itens da guia a partir dos produtos da fatura
            const itens = (faturaParaGuia.produtos || []).map(item => {
                const isServico = !!item.servicoId;
                const itemId = isServico
                    ? (typeof item.servicoId === 'object' ? item.servicoId._id : item.servicoId)
                    : (typeof item.produtoId === 'object' ? item.produtoId._id : item.produtoId);

                return {
                    produtoId: isServico ? null : itemId,
                    servicoId: isServico ? itemId : null,
                    nomeItem: item.nomeItem || (item.produtoId?.nome) || (item.servicoId?.nome) || 'Item',
                    codigoItem: item.codigoItem || (item.produtoId?.codigo) || (item.servicoId?.codigo) || '',
                    descricao: item.descricao || '',
                    unidadeMedida: item.unidadeMedida || 'UN',
                    quantidade: item.quantidade || 0,
                    precoUnitario: item.precoUnitario || 0,
                    subtotal: (item.quantidade || 0) * (item.precoUnitario || 0)
                };
            });

            // Dados do cliente para endereço de entrega
            const cliente = faturaParaGuia.clienteId || faturaParaGuia.clienteInfo || {};
            const moradaCliente = cliente.morada || {};

            const dadosGuia = {
                faturaId: faturaParaGuia._id,
                itens,
                tipoEntrega: 'Total',
                transportadora: '',
                matricula: '',
                motorista: '',
                documentoMotorista: '',
                enderecoEntrega: cliente.endereco || moradaCliente.rua || '',
                cidadeEntrega: moradaCliente.cidade || cliente.cidade || '',
                provinciaEntrega: moradaCliente.provincia || cliente.provincia || '',
                contactoEntrega: cliente.telefone || '',
                observacoes: `Guia criada a partir da fatura ${faturaParaGuia.numero}`,
                dataEmissao: new Date().toISOString().split('T')[0]
            };

            console.log('📤 Enviando dados da guia:', dadosGuia);

            const response = await api.post('/guias-entrega', dadosGuia);

            if (response.data && response.data.success) {
                const guiaCriada = response.data.data;

                showToast(
                    `✅ Guia de Entrega ${guiaCriada.numero} criada com sucesso!`,
                    'success'
                );

                // 🔥 Marcar a fatura como tendo guia criada no estado local
                setFaturas(prev => prev.map(f =>
                    f._id === faturaParaGuia._id
                        ? { ...f, temGuiaCriada: true, guiaNumero: guiaCriada.numero }
                        : f
                ));
                setFilteredFaturas(prev => prev.map(f =>
                    f._id === faturaParaGuia._id
                        ? { ...f, temGuiaCriada: true, guiaNumero: guiaCriada.numero }
                        : f
                ));

                // Atualizar detalhes se estiver aberto
                if (faturaDetalhes && faturaDetalhes._id === faturaParaGuia._id) {
                    setFaturaDetalhes(prev => ({
                        ...prev,
                        temGuiaCriada: true,
                        guiaNumero: guiaCriada.numero
                    }));
                }

                // Disparar evento global para o módulo GuiasEntrega recarregar
                window.dispatchEvent(new CustomEvent('guia-criada', {
                    detail: { guia: guiaCriada, faturaId: faturaParaGuia._id }
                }));

                // Fechar modal e limpar
                setShowCreateGuiaModal(false);
                setFaturaParaGuia(null);

                // Recarregar faturas para sincronizar
                setTimeout(() => {
                    fetchFaturas(false);
                }, 800);

            } else {
                throw new Error(response.data?.erro || 'Erro ao criar guia');
            }

        } catch (error) {
            console.error('❌ Erro ao criar guia de entrega:', error);

            const erroMsg = error.response?.data?.erro || error.message || 'Erro ao criar guia de entrega';

            if (erroMsg.includes('já existe') || erroMsg.includes('duplicad')) {
                showToast('Esta fatura já tem uma guia de entrega criada', 'warning');

                // Marcar localmente como já tendo guia
                setFaturas(prev => prev.map(f =>
                    f._id === faturaParaGuia._id
                        ? { ...f, temGuiaCriada: true }
                        : f
                ));
                setFilteredFaturas(prev => prev.map(f =>
                    f._id === faturaParaGuia._id
                        ? { ...f, temGuiaCriada: true }
                        : f
                ));
            } else {
                showToast(erroMsg, 'danger');
            }
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // CANCELAR FATURA
    // =============================================
    const cancelarFatura = async (id) => {
        if (!motivoCancelamento.trim()) {
            showToast('Informe o motivo do cancelamento', 'warning');
            return;
        }

        setLoading(true);
        try {
            const response = await api.post(`/faturas/${id}/cancelar`, {
                motivo: motivoCancelamento
            });

            if (response.data) {
                showToast('Fatura cancelada com sucesso!', 'success');
                setShowCancelModal(false);
                setFaturaToCancel(null);
                setMotivoCancelamento('');
                fetchFaturas(false);
                if (faturaDetalhes && faturaDetalhes._id === id) {
                    setFaturaDetalhes(response.data.data);
                }
            }
        } catch (error) {
            console.error('❌ Erro ao cancelar fatura:', error);
            showToast(error.response?.data?.erro || 'Erro ao cancelar fatura', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // EXCLUIR FATURA
    // =============================================
    const handleDelete = async () => {
        if (!faturaToDelete) return;
        setLoading(true);

        try {
            const response = await api.delete(`/faturas/${faturaToDelete._id}`);
            if (response.data) {
                showToast('Fatura removida com sucesso!', 'success');
                setShowDeleteModal(false);
                setFaturaToDelete(null);
                fetchFaturas(false);
            }
        } catch (error) {
            console.error('❌ Erro ao remover fatura:', error);
            showToast(error.response?.data?.erro || 'Erro ao remover fatura', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // VER DETALHES
    // =============================================
    const verDetalhes = async (fatura) => {
        setLoading(true);
        try {
            console.log('🔍 Buscando detalhes da fatura ID:', fatura._id);

            const response = await api.get(`/faturas/${fatura._id}`);
            console.log('📦 Resposta completa:', response.data);

            if (response.data) {
                const dadosFatura = response.data.data || response.data;

                if (response.data.empresa) {
                    console.log('✅ Dados da empresa encontrados na resposta!');
                    const empresa = response.data.empresa;

                    const ivaPercent = empresa.percentagemIVA;

                    if (ivaPercent === undefined || ivaPercent === null) {
                        console.error('❌ ERRO: IVA da empresa não está definido!');
                        showToast('Erro: IVA da empresa não configurado. Contacte o administrador.', 'danger');
                        setLoading(false);
                        return;
                    }

                    console.log(`📊 IVA da empresa: ${ivaPercent}%`);
                    ivaRef.current = ivaPercent;

                    const modulos = empresa.modulos || empresa.modulosAtivos || {};

                    const novaConfig = {
                        id: empresa.id || empresa._id,
                        nome: empresa.nome || '',
                        nomeCurto: empresa.nomeCurto || '',
                        imagemPerfil: empresa.imagemPerfil || null,
                        nuit: empresa.nuit || '',
                        alvara: empresa.alvara || '',
                        email: empresa.email || '',
                        emailAlternativo: empresa.emailAlternativo || '',
                        telefone: empresa.telefone || '',
                        telefoneAlternativo: empresa.telefoneAlternativo || '',
                        whatsapp: empresa.whatsapp || '',
                        website: empresa.website || '',
                        morada: empresa.morada || {},
                        dadosBancarios: empresa.dadosBancarios || [],
                        bancoPrincipal: empresa.bancoPrincipal || null,
                        regimeIVA: empresa.regimeIVA || 'Normal',
                        percentagemIVA: ivaPercent,
                        retencoaFonte: empresa.retencoaFonte || false,
                        moeda: empresa.moeda || empresaConfig.moeda,
                        iva: {
                            ...empresaConfig.iva,
                            ...empresa.iva,
                            percentualPadrao: empresa.iva?.percentualPadrao ?? ivaPercent,
                            regimeAtivo: empresa.regimeIVA || 'Normal',
                            percentuaisPermitidos: empresa.iva?.percentuaisPermitidos || [0, 5, 16]
                        },
                        formatacao: empresa.formatacao || empresaConfig.formatacao,
                        configuracao: empresa.configuracao || empresaConfig.configuracao,
                        status: empresa.status || 'Ativa',
                        arquivado: empresa.arquivado || false,
                        cafe: empresa.cafe || '',
                        criadoEm: empresa.criadoEm || null,
                        actualizadoEm: empresa.actualizadoEm || null,
                        dataArquivo: empresa.dataArquivo || null,
                        motivoArquivo: empresa.motivoArquivo || '',
                        utilizadores: empresa.utilizadores || [],
                        actualizadoPor: empresa.actualizadoPor || null,
                        contactosEmergencia: empresa.contactosEmergencia || [],
                        sedes: empresa.sedes || [],
                        actividadesEconomicas: empresa.actividadesEconomicas || [],
                        estatisticas: empresa.estatisticas || {},
                        timezone: empresa.timezone || 'Africa/Maputo',
                        idioma: empresa.idioma || 'pt-PT',
                        formatoHora: empresa.formatoHora || '24h',
                        modulos: {
                            gestaoStock: modulos.gestaoStock === true || modulos.stock === true || modulos.estoque === true || false,
                            gestaoProdutos: modulos.gestaoProdutos === true || modulos.produtos === true || false,
                            gestaoServicos: modulos.gestaoServicos === true || modulos.servicos === true || false,
                            gestaoEstoque: modulos.gestaoEstoque === true || modulos.estoque === true || false,
                            gestaoArmazens: modulos.gestaoArmazens === true || modulos.armazens === true || false,
                            gestaoInventario: modulos.gestaoInventario === true || modulos.inventario === true || false,
                            gestaoCategorias: modulos.gestaoCategorias === true || modulos.categorias === true || false,
                            gestaoFrotas: modulos.gestaoFrotas === true || modulos.frotas === true || false,
                            gestaoProjetos: modulos.gestaoProjetos === true || modulos.projetos === true || false,
                            gestaoRh: modulos.gestaoRh === true || modulos.rh === true || false,
                            gestaoAtivos: modulos.gestaoAtivos === true || modulos.ativos === true || false
                        }
                    };

                    console.log('🏢 Atualizando empresaConfig:', novaConfig);
                    setEmpresaConfig(novaConfig);

                    dadosFatura.empresa = {
                        _id: empresa.id || empresa._id,
                        nome: empresa.nome || '',
                        nomeCurto: empresa.nomeCurto || '',
                        imagemPerfil: empresa.imagemPerfil || null,
                        nuit: empresa.nuit || '',
                        email: empresa.email || '',
                        telefone: empresa.telefone || '',
                        website: empresa.website || '',
                        morada: empresa.morada || {},
                        dadosBancarios: empresa.dadosBancarios || [],
                        bancoPrincipal: empresa.bancoPrincipal || null,
                        regimeIVA: empresa.regimeIVA || 'Normal',
                        percentagemIVA: ivaPercent,
                        moeda: empresa.moeda || {},
                        cafe: empresa.cafe || '',
                        modulos: novaConfig.modulos
                    };
                }

                console.log('📋 Dados finais da fatura:', dadosFatura);
                setFaturaDetalhes(dadosFatura);
                setShowDetailsModal(true);
            }
        } catch (error) {
            console.error('❌ Erro ao buscar detalhes:', error);
            showToast('Erro ao carregar detalhes', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // CARREGAR PARA EDIÇÃO
    // =============================================
    const carregarParaEdicao = async (fatura) => {
        setLoading(true);
        try {
            setShowDetailsModal(false);
            const response = await api.get(`/faturas/${fatura._id}`);
            if (response.data) {
                const data = response.data.data;
                const clienteId = data.clienteId?._id || data.clienteId || '';

                const ivaPercentValue = data.ivaPercent !== undefined && data.ivaPercent !== null
                    ? data.ivaPercent
                    : empresaConfig.percentagemIVA;

                if (ivaPercentValue === undefined || ivaPercentValue === null) {
                    console.error('❌ ERRO: IVA não disponível para edição!');
                    showToast('Erro: IVA não configurado. Contacte o administrador.', 'danger');
                    setLoading(false);
                    return;
                }

                ivaRef.current = ivaPercentValue;

                const isIvaIncluso = data.ivaIncluso === true || ivaPercentValue === 0;

                setIvaIncluso(isIvaIncluso);

                const descontoGlobalValue = data.descontoGlobal || 0;
                const dataEmissaoValue = data.dataEmissao ? new Date(data.dataEmissao).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];

                const produtosEnriquecidos = await Promise.all((data.produtos || []).map(async (item) => {
                    const itemEnriquecido = { ...item };

                    if (item.produtoId) {
                        const produtoId = typeof item.produtoId === 'object' ? item.produtoId._id : item.produtoId;
                        const produto = produtos.find(p => p._id === produtoId);
                        if (produto) {
                            itemEnriquecido.produtoData = produto;
                            itemEnriquecido.nomeItem = produto.nome;
                            itemEnriquecido.codigoItem = produto.codigo;
                            itemEnriquecido.tipoItem = 'Produto';
                        }
                    }

                    if (item.servicoId) {
                        const servicoId = typeof item.servicoId === 'object' ? item.servicoId._id : item.servicoId;
                        const servico = servicos.find(s => s._id === servicoId);
                        if (servico) {
                            itemEnriquecido.servicoData = servico;
                            itemEnriquecido.nomeItem = servico.nome;
                            itemEnriquecido.codigoItem = servico.codigo;
                            itemEnriquecido.tipoItem = 'Servico';
                        }
                    }

                    return itemEnriquecido;
                }));

                const ivaFinal = isIvaIncluso ? 0 : ivaPercentValue;

                setEditFormData({
                    _id: data._id,
                    clienteId: clienteId,
                    produtos: produtosEnriquecidos,
                    ivaPercent: ivaFinal,
                    descontoGlobal: descontoGlobalValue,
                    dataEmissao: dataEmissaoValue,
                    dataVencimento: data.dataVencimento ? new Date(data.dataVencimento).toISOString().split('T')[0] : '',
                    observacoes: data.observacoes || '',
                    status: data.status || 'Rascunho'
                });

                const clienteEncontrado = clientes.find(c => c._id === clienteId);
                if (clienteEncontrado) {
                    setSearchClienteEdit(clienteEncontrado.nome);
                }

                setShowEditModal(true);
            }
        } catch (error) {
            console.error('❌ Erro ao carregar fatura:', error);
            showToast('Erro ao carregar dados', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // =============================================
    // TOGGLE EXPANDIR LINHA
    // =============================================
    const toggleExpandRow = (faturaId) => {
        setExpandedRows(prev => ({
            ...prev,
            [faturaId]: !prev[faturaId]
        }));
        if (!expandedRows[faturaId]) {
            setItensPage(prev => ({
                ...prev,
                [faturaId]: 1
            }));
        }
    };

    const changeItensPage = (faturaId, page) => {
        setItensPage(prev => ({
            ...prev,
            [faturaId]: page
        }));
    };

    // =============================================
    // 🔥 RESET FORM
    // =============================================
    const resetForm = useCallback(() => {
        let ivaAtual = ivaRef.current;

        if (ivaAtual === undefined || ivaAtual === null) {
            ivaAtual = empresaConfig.percentagemIVA;
        }

        if (ivaAtual === undefined || ivaAtual === null) {
            ivaAtual = formData.ivaPercent;
        }

        if (ivaAtual === undefined || ivaAtual === null) {
            console.warn('⚠️ IVA não disponível para reset, mantendo valor atual');
            return;
        }

        ivaRef.current = ivaAtual;

        const hoje = new Date().toISOString().split('T')[0];
        const trintaDias = new Date();
        trintaDias.setDate(trintaDias.getDate() + 30);
        const dataVencimento = trintaDias.toISOString().split('T')[0];

        const tipoInicial = showProduto ? 'produto' : 'servico';

        setFormData({
            clienteId: '',
            produtos: [],
            ivaPercent: ivaAtual,
            descontoGlobal: 0,
            dataEmissao: hoje,
            dataVencimento: dataVencimento,
            observacoes: '',
            status: 'Rascunho',
        });
        setNovoItem({
            id: '',
            quantidade: 1,
            precoUnitario: 0,
            descontoPercentual: 0,
            tipo: tipoInicial
        });
        setIvaIncluso(ivaAtual === 0 || ivaAtual === 15);
        setSearchCliente('');
        setSearchItem('');
        setTipoItem(tipoInicial);
        cancelarEdicaoItem();
    }, [empresaConfig, formData.ivaPercent, showProduto]);

    // =============================================
    // 🔥 RESET EDIT FORM
    // =============================================
    const resetEditForm = useCallback(() => {
        setEditFormData(null);
        setSearchClienteEdit('');
        setSearchItemEdit('');
        setIvaIncluso(false);
        const tipoInicial = showProduto ? 'produto' : 'servico';
        setTipoItem(tipoInicial);
        setNovoItem({
            id: '',
            quantidade: 1,
            precoUnitario: 0,
            descontoPercentual: 0,
            tipo: tipoInicial
        });
        cancelarEdicaoItem();
    }, [showProduto]);

    // =============================================
    // MENSAGENS
    // =============================================
    const showMessage = (text, type = 'success') => {
        setMessage({ text, type });
        setTimeout(() => setMessage({ text: '', type: '' }), 5000);
    };

    // =============================================
    // FILTROS
    // =============================================
    const aplicarFiltros = () => {
        setPagination(prev => ({ ...prev, page: 1 }));
        fetchFaturas(true, 1);
    };

    const limparFiltros = () => {
        setSearchTerm('');
        setFiltroStatus('todos');
        setPagination(prev => ({ ...prev, page: 1 }));
        setTimeout(() => {
            fetchFaturas(true, 1);
        }, 100);
    };

    // =============================================
    // PAGINAÇÃO
    // =============================================
    const goToPage = (page) => {
        if (page < 1 || page > pagination.pages) return;
        setPagination(prev => ({ ...prev, page }));
        fetchFaturas(true, page);
    };

    // =============================================
    // 🔥 HANDLER PARA MUDANÇA DE FORMA DE PAGAMENTO
    // =============================================
    const handleFormaPagamentoChange = (e) => {
        const value = e.target.value;
        setFormaPagamentoSelecionada(value);

        if (value === 'Dinheiro') {
            setShowDetalhesPagamento(false);
            setDetalhesPagamento('');
        } else {
            setShowDetalhesPagamento(true);
        }
    };

    // =============================================
    // USE EFFECTS
    // =============================================
    useEffect(() => {
        const carregarDados = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('usuario') || '{}');
                if (user.empresaId) setEmpresaId(user.empresaId);
                else if (user.empresa?._id) setEmpresaId(user.empresa._id);
                else if (user.empresaId?._id) setEmpresaId(user.empresaId._id);
            } catch (e) {
                console.warn('⚠️ Não foi possível obter empresaId do usuário');
            }

            await Promise.all([
                fetchClientes(),
                fetchProdutos(),
                fetchServicos(),
                fetchFaturas(true, 1)
            ]);
        };
        carregarDados();
    }, []);

    useEffect(() => {
        if (empresaConfig.percentagemIVA !== undefined && empresaConfig.percentagemIVA !== null) {
            ivaRef.current = empresaConfig.percentagemIVA;
            console.log(`📊 IVA guardado no ref: ${ivaRef.current}%`);
        }
    }, [empresaConfig.percentagemIVA]);

    useEffect(() => {
        if (formData.clienteId) {
            const cliente = clientesFiltrados.find(c => c._id === formData.clienteId);
            if (cliente) setSearchCliente(cliente.nome);
        } else {
            setSearchCliente('');
        }
    }, [formData.clienteId, clientesFiltrados]);

    useEffect(() => {
        if (novoItem.id) {
            const items = tipoItem === 'produto' ? produtos : servicos;
            const item = items.find(p => p._id === novoItem.id);
            if (item) setSearchItem(item.nome);
        } else {
            setSearchItem('');
        }
    }, [novoItem.id, tipoItem, produtos, servicos]);

    // =============================================
    // 🔥 ESCUTAR EVENTOS DE COTAÇÃO APROVADA/CONVERTIDA
    // =============================================
    useEffect(() => {
        const handleCotacaoEvent = (event) => {
            console.log('🔄 Evento recebido:', event.type, event.detail);

            const faturaCriada = event.detail?.fatura;
            if (faturaCriada) {
                console.log(`✅ Fatura ${faturaCriada.numero} criada, recarregando lista...`);
                showToast(`📄 Nova fatura ${faturaCriada.numero} criada automaticamente!`, 'success');
            } else {
                console.log('🔄 Recarregando faturas...');
            }

            fetchFaturas(true, pagination.page);
        };

        window.addEventListener('cotacao-aprovada', handleCotacaoEvent);
        window.addEventListener('cotacao-convertida', handleCotacaoEvent);

        return () => {
            window.removeEventListener('cotacao-aprovada', handleCotacaoEvent);
            window.removeEventListener('cotacao-convertida', handleCotacaoEvent);
        };
    }, [pagination.page]);

    // =============================================
    // RENDER PAGINAÇÃO PRINCIPAL
    // =============================================
    const renderPagination = () => {
        const { page, pages, total } = pagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * pagination.limit + 1;
        const endItem = Math.min(page * pagination.limit, total);

        const getPageNumbers = (currentPage, totalPages) => {
            const pagesArray = [];

            if (totalPages <= 5) {
                for (let i = 1; i <= totalPages; i++) {
                    pagesArray.push(i);
                }
                return pagesArray;
            }

            pagesArray.push(1);

            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);

            if (currentPage <= 3) {
                startPage = 2;
                endPage = Math.min(totalPages - 1, 4);
            }

            if (currentPage >= totalPages - 2) {
                startPage = Math.max(2, totalPages - 3);
                endPage = totalPages - 1;
            }

            if (startPage > 2) {
                pagesArray.push('...');
            }

            for (let i = startPage; i <= endPage; i++) {
                pagesArray.push(i);
            }

            if (endPage < totalPages - 1) {
                pagesArray.push('...');
            }

            pagesArray.push(totalPages);

            return pagesArray;
        };

        const pageNumbers = getPageNumbers(page, pages);

        return (
            <div className="cotacoes-pagination">
                <div className="pagination-info">
                    <span>Mostrando {startItem} - {endItem} de {total} faturas</span>
                </div>
                <div className="pagination-controls">
                    <button
                        className="pagination-btn"
                        onClick={() => goToPage(page - 1)}
                        disabled={page === 1}
                    >
                        <Icon name="chevron_left" size={18} />
                    </button>
                    <div className="pagination-numbers">
                        {pageNumbers.map((p, index) => {
                            if (p === '...') {
                                return (
                                    <span key={`dots-${index}`} className="pagination-dots">
                                        …
                                    </span>
                                );
                            }
                            return (
                                <button
                                    key={p}
                                    className={`pagination-number ${page === p ? 'active' : ''}`}
                                    onClick={() => goToPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        })}
                    </div>
                    <button
                        className="pagination-btn"
                        onClick={() => goToPage(page + 1)}
                        disabled={page === pages}
                    >
                        <Icon name="chevron_right" size={18} />
                    </button>
                </div>
            </div>
        );
    };

    // =============================================
    // RENDER PRINCIPAL
    // =============================================
    return (
        <div className="cotacoes-container">
            {/* HEADER */}
            <div className="cotacoes-header">
                <div className="header-title">
                    <h2><Icon name="receipt" size={24} /> Faturas</h2>
                    <p>Gerencie as faturas para clientes</p>
                </div>
                <div className="header-actions">
                    <button className="btn-refresh" onClick={() => fetchFaturas(true)} title="Atualizar">
                        <Icon name="refresh" size={18} />
                    </button>
                    <button className="btn-create" onClick={() => setShowCreateModal(true)}>
                        <Icon name="add" size={18} /> Nova Fatura
                    </button>
                </div>
            </div>

            {/* MENSAGENS DA PÁGINA PRINCIPAL */}
            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    <Icon name={message.type === 'success' ? 'check_circle' : 'error'} size={16} />
                    <span>{message.text}</span>
                    <button className="alert-close" onClick={() => setMessage({ text: '', type: '' })}>×</button>
                </div>
            )}

            {/* KPIs */}
            <div className="cotacoes-kpi-grid">
                <div className="kpi-card primary">
                    <div className="kpi-icon"><Icon name="receipt" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{stats.total}</span>
                        <span className="kpi-label">Total Faturas</span>
                    </div>
                </div>
                <div className="kpi-card warning">
                    <div className="kpi-icon"><Icon name="pending" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{stats.aberta + stats.emitida}</span>
                        <span className="kpi-label">Abertas</span>
                    </div>
                </div>
                <div className="kpi-card success">
                    <div className="kpi-icon"><Icon name="check_circle" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{stats.pago}</span>
                        <span className="kpi-label">Pagas</span>
                    </div>
                </div>
                <div className="kpi-card info">
                    <div className="kpi-icon"><Icon name="warning" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{stats.vencida || 0}</span>
                        <span className="kpi-label">Vencidas</span>
                    </div>
                </div>
            </div>

            {/* FILTROS */}
            <div className="cotacoes-filters">
                <div className="search-box">
                    <Icon name="search" size={18} />
                    <input
                        type="text"
                        placeholder="Pesquisar faturas (número, cliente)..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && aplicarFiltros()}
                    />
                    {searchTerm && (
                        <button className="search-clear" onClick={() => setSearchTerm('')}>
                            <Icon name="close" size={16} />
                        </button>
                    )}
                </div>
                <div className="filter-actions">
                    <select className="filter-select" value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
                        <option value="todos">Todos os Status</option>
                        {STATUS_FATURA.map(s => (
                            <option key={s.value} value={s.value}>{s.label}</option>
                        ))}
                    </select>
                    <button className="btn-filter-apply" onClick={aplicarFiltros}>
                        <Icon name="search" size={16} /> Aplicar
                    </button>
                    <button className="btn-filter-clear" onClick={limparFiltros}>
                        <Icon name="clear" size={16} />
                    </button>
                </div>
            </div>

            {/* TABELA */}
            <div className="cotacoes-table-container">
                {tableLoading && (
                    <div className="table-loading-overlay active">
                        <div className="spinner"></div>
                        <span className="loading-text">A carregar faturas...</span>
                    </div>
                )}

                <div className="cotacoes-table-wrapper">
                    <table className="cotacoes-table">
                        <thead>
                            <tr>
                                <th className="col-expand" style={{ width: '40px', textAlign: 'center' }}></th>
                                <th className="col-numero">Nº</th>
                                <th className="col-cliente">Cliente</th>
                                <th className="col-desconto" style={{ textAlign: 'center' }}>Desconto</th>
                                <th className="col-iva" style={{ textAlign: 'right' }}>IVA</th>
                                <th className="col-total" style={{ textAlign: 'right' }}>Total</th>
                                <th className="col-validade" style={{ textAlign: 'center' }}>Vencimento</th>
                                <th className="col-status" style={{ textAlign: 'center' }}>Status</th>
                                <th className="col-acoes" style={{ textAlign: 'center' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading && !tableLoading ? (
                                Array.from({ length: 5 }).map((_, index) => (
                                    <tr key={`skeleton-${index}`} className="skeleton-row">
                                        <td><div className="skeleton-line" style={{ width: '20%' }}></div></td>
                                        <td><div className="skeleton-line" style={{ width: '40%' }}></div></td>
                                        <td><div className="skeleton-line" style={{ width: '60%' }}></div></td>
                                        <td><div className="skeleton-line" style={{ width: '30%' }}></div></td>
                                        <td><div className="skeleton-line" style={{ width: '30%' }}></div></td>
                                        <td><div className="skeleton-line" style={{ width: '50%' }}></div></td>
                                        <td><div className="skeleton-line" style={{ width: '40%' }}></div></td>
                                        <td><div className="skeleton-badge"></div></td>
                                        <td>
                                            <div className="skeleton-actions">
                                                <div className="skeleton-circle small"></div>
                                                <div className="skeleton-circle small"></div>
                                                <div className="skeleton-circle small"></div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : filteredFaturas.length === 0 ? (
                                <tr className="empty-row">
                                    <td colSpan="9">
                                        <div className="empty-state">
                                            <Icon name="receipt" size={48} />
                                            <p>Nenhuma fatura encontrada</p>
                                            <button className="btn-create-small" onClick={() => setShowCreateModal(true)}>
                                                <Icon name="add" size={16} /> Criar primeira fatura
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                filteredFaturas.map(fatura => {
                                    const statusValue = fatura.status || 'Rascunho';
                                    const statusInfo = getStatusInfo(statusValue);
                                    const totalItens = fatura.produtos?.length || 0;
                                    const isExpanded = expandedRows[fatura._id] || false;

                                    const podeEditar = !['Pago', 'Cancelada'].includes(statusValue);
                                    const podePagar = ['Aberta', 'Emitida', 'Vencida', 'Excluida'].includes(statusValue);
                                    const podeCancelar = !['Cancelada', 'Pago'].includes(statusValue);
                                    const podeExcluir = !['Pago', 'Emitida', 'Cancelada'].includes(statusValue);
                                    // 🔥 Guia de Entrega: pode ser criada para faturas pagas, emitidas ou abertas
                                    const podeCriarGuia = ['Pago', 'Emitida', 'Aberta'].includes(statusValue);

                                    const descontoDisplay = getDescontoDisplay(fatura);
                                    const ivaPercent = fatura.ivaPercent ?? empresaConfig.percentagemIVA;
                                    const isIvaIncluso = fatura.ivaIncluso === true || ivaPercent === 0 || ivaPercent === 15;
                                    const ivaDisplay = ivaPercent === undefined || ivaPercent === null ? '⚠️ N/A'
                                        : isIvaIncluso
                                            ? (ivaPercent === 0 ? 'Isento' : 'Incluso')
                                            : `${ivaPercent}%`;
                                    const ivaDescricao = getIvaDescricao(fatura);
                                    const totalDisplay = getTotalDisplay(fatura);
                                    const vencimentoDisplay = getVencimentoDisplay(fatura);
                                    const statusDisplay = getStatusFormatado(fatura);
                                    const statusClass = getStatusClass(fatura);
                                    const statusIcon = getStatusIcon(fatura);

                                    const nomeCliente = getClienteNome(fatura);
                                    const nifCliente = getClienteNif(fatura);

                                    const temItens = fatura.produtos && fatura.produtos.length > 0;

                                    const currentItensPage = itensPage[fatura._id] || 1;
                                    const totalItensPages = Math.ceil(totalItens / ITEMS_PER_PAGE);
                                    const startIndex = (currentItensPage - 1) * ITEMS_PER_PAGE;
                                    const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItens);
                                    const itensPaginados = fatura.produtos?.slice(startIndex, endIndex) || [];

                                    const isVencida = statusValue === 'Vencida' || (fatura.dataVencimento && new Date(fatura.dataVencimento) < new Date() && !['Pago', 'Cancelada'].includes(statusValue));

                                    const temCotacaoOrigem = fatura.cotacaoId && (typeof fatura.cotacaoId === 'object' || fatura.cotacaoId);

                                    return (
                                        <React.Fragment key={fatura._id}>
                                            <tr className={`cotacao-row ${statusValue === 'Pago' ? 'converted-row' : ''} ${statusValue === 'Emitida' ? 'approved-row' : ''} ${statusValue === 'Cancelada' ? 'cancelled-row' : ''} ${statusValue === 'Vencida' ? 'cancelled-row' : ''} ${isExpanded ? 'expanded' : ''}`}>
                                                <td className="col-expand" style={{ textAlign: 'center' }}>
                                                    {temItens && (
                                                        <button
                                                            className="btn-expand-row"
                                                            onClick={() => toggleExpandRow(fatura._id)}
                                                            title={isExpanded ? 'Recolher itens' : 'Expandir itens'}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                color: '#6b7280',
                                                                transition: 'transform 0.3s ease',
                                                                transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                                                padding: '4px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <Icon name="chevron_right" size={18} />
                                                        </button>
                                                    )}
                                                    {!temItens && (
                                                        <span style={{ color: '#d1d5db', fontSize: '12px' }}>•</span>
                                                    )}
                                                </td>
                                                <td className="col-numero">
                                                    <span className="numero-badge">{fatura.numero}</span>
                                                    {temCotacaoOrigem && (
                                                        <span style={{
                                                            display: 'block',
                                                            fontSize: '0.45rem',
                                                            color: '#6b7280',
                                                            marginTop: '2px'
                                                        }}>
                                                            {typeof fatura.cotacaoId === 'object' ? `CT: ${fatura.cotacaoId.numero || fatura.cotacaoId}` : `CT: ${fatura.cotacaoId}`}
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="col-cliente">
                                                    <div className="cliente-info">
                                                        <strong>{nomeCliente}</strong>
                                                        {nifCliente && (
                                                            <span className="nif">NUIT: {nifCliente}</span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="col-desconto" style={{ textAlign: 'center' }}>
                                                    <span style={{
                                                        fontWeight: descontoDisplay !== '-' ? 700 : 400,
                                                        color: descontoDisplay !== '-' ? '#dc2626' : '#9ca3af'
                                                    }}>
                                                        {descontoDisplay}
                                                    </span>
                                                </td>
                                                <td className="col-iva" style={{ textAlign: 'right' }}>
                                                    {ivaDescricao} - {ivaDisplay}
                                                </td>
                                                <td className="col-total" style={{ textAlign: 'right' }}>
                                                    <strong>{totalDisplay}</strong>
                                                </td>
                                                <td className="col-validade" style={{ textAlign: 'center' }}>
                                                    <span className={`validade-badge ${isVencida ? 'expirado' : ''}`}>
                                                        {vencimentoDisplay}
                                                        {isVencida && (
                                                            <span style={{
                                                                display: 'block',
                                                                fontSize: '0.4rem',
                                                                color: '#dc2626',
                                                                fontWeight: 700
                                                            }}>
                                                                VENCIDA
                                                            </span>
                                                        )}
                                                    </span>
                                                </td>
                                                <td className="col-status" style={{ textAlign: 'center' }}>
                                                    <span className={`status-badge ${statusClass}`}>
                                                        <Icon name={statusIcon} size={12} />
                                                        {statusDisplay}
                                                    </span>
                                                </td>
                                                <td className="col-acoes" style={{ textAlign: 'center' }}>
                                                    <div className="actions-cell">
                                                        <button className="action-btn view" onClick={() => verDetalhes(fatura)} title="Ver detalhes">
                                                            <Icon name="visibility" size={16} />
                                                        </button>
                                                        {podeEditar && (
                                                            <button className="action-btn edit" onClick={() => carregarParaEdicao(fatura)} title="Editar">
                                                                <Icon name="edit" size={16} />
                                                            </button>
                                                        )}
                                                        {podePagar && (
                                                            <button className="action-btn approve" onClick={() => {
                                                                setFaturaToPay(fatura);
                                                                setDataPagamento(new Date().toISOString().split('T')[0]);
                                                                setFormaPagamentoSelecionada('Dinheiro');
                                                                setDetalhesPagamento('');
                                                                setObservacaoPagamento('');
                                                                setShowDetalhesPagamento(false);
                                                                setShowPayModal(true);
                                                            }} title="Registrar Pagamento">
                                                                <Icon name="paid" size={16} />
                                                            </button>
                                                        )}
                                                        {/* 🔥 Botão Criar Guia de Entrega na tabela - com estado "Guia Criada" */}
                                                        {podeCriarGuia && (
                                                            <button
                                                                className="action-btn guide"
                                                                onClick={() => !fatura.temGuiaCriada && abrirCriarGuia(fatura)}
                                                                disabled={fatura.temGuiaCriada}
                                                                title={
                                                                    fatura.temGuiaCriada
                                                                        ? `Guia já criada${fatura.guiaNumero ? ': ' + fatura.guiaNumero : ''}`
                                                                        : "Criar Guia de Entrega"
                                                                }
                                                                style={{
                                                                    color: fatura.temGuiaCriada ? '#10b981' : '#4f46e5',
                                                                    opacity: fatura.temGuiaCriada ? 0.7 : 1,
                                                                    cursor: fatura.temGuiaCriada ? 'not-allowed' : 'pointer'
                                                                }}
                                                            >
                                                                <Icon name={fatura.temGuiaCriada ? "check_circle" : "delivery_truck"} size={16} />
                                                            </button>
                                                        )}
                                                        {podeCancelar && (
                                                            <button className="action-btn cancel" onClick={() => {
                                                                setFaturaToCancel(fatura);
                                                                setMotivoCancelamento('');
                                                                setShowCancelModal(true);
                                                            }} title="Cancelar">
                                                                <Icon name="cancel" size={16} />
                                                            </button>
                                                        )}
                                                        {podeExcluir && (
                                                            <button className="action-btn delete" onClick={() => {
                                                                setFaturaToDelete(fatura);
                                                                setShowDeleteModal(true);
                                                            }} title="Excluir">
                                                                <Icon name="delete" size={16} />
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                            {isExpanded && temItens && (
                                                <tr className="expanded-details-row">
                                                    <td colSpan="9" style={{ padding: 0 }}>
                                                        <div className="expanded-itens-container">
                                                            <div className="expanded-itens-header">
                                                                <span className="expanded-itens-title">
                                                                    <Icon name="list" size={14} /> Itens da Fatura
                                                                </span>
                                                                <span className="expanded-itens-count">
                                                                    Total: {totalItens} {totalItens === 1 ? 'item' : 'itens'}
                                                                    {totalItensPages > 1 && ` | Pág. ${currentItensPage} de ${totalItensPages}`}
                                                                </span>
                                                            </div>
                                                            <table className="itens-expanded-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="col-item">Item</th>
                                                                        <th className="col-tipo">Tipo</th>
                                                                        <th className="col-qtd">Qtd</th>
                                                                        <th className="col-preco">Preço Unit.</th>
                                                                        <th className="col-desconto-header">Desconto %</th>
                                                                        <th className="col-subtotal-header">Subtotal</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {itensPaginados.map((item, idx) => {
                                                                        const isServico = !!item.servicoId;
                                                                        const itemId = isServico ? item.servicoId : item.produtoId;
                                                                        const itemsList = isServico ? servicos : produtos;
                                                                        const itemData = itemsList.find(p => p._id === itemId);
                                                                        const nomeItem = itemData ? itemData.nome : getItemNome(item);
                                                                        const codigoItem = itemData ? itemData.codigo : getItemCodigo(item);
                                                                        const descontoPercentual = item.descontoPercentual || 0;
                                                                        const subtotalItem = item.quantidade * item.precoUnitario * (1 - descontoPercentual / 100);
                                                                        const tipoLabel = isServico ? 'Serviço' : 'Produto';

                                                                        return (
                                                                            <tr key={idx} className="expanded-item-row">
                                                                                <td className="col-item">
                                                                                    <span className="item-nome">{nomeItem}</span>
                                                                                    {codigoItem && (
                                                                                        <span className="item-codigo">({codigoItem})</span>
                                                                                    )}
                                                                                </td>
                                                                                <td className="col-tipo">
                                                                                    <span className={`tipo-badge ${isServico ? 'servico' : 'produto'}`}>
                                                                                        {tipoLabel}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="col-qtd">{item.quantidade}</td>
                                                                                <td className="col-preco">{formatarMoeda(item.precoUnitario)}</td>
                                                                                <td className="col-desconto">
                                                                                    {descontoPercentual > 0 ? (
                                                                                        <span className="desconto-positivo">{descontoPercentual}%</span>
                                                                                    ) : (
                                                                                        <span className="desconto-zero">0%</span>
                                                                                    )}
                                                                                </td>
                                                                                <td className="col-subtotal">{formatarMoeda(subtotalItem)}</td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                                {totalItens > 0 && (
                                                                    <tfoot>
                                                                        <tr className="subtotal-row">
                                                                            <td colSpan="5" className="subtotal-label">Subtotal:</td>
                                                                            <td className="subtotal-value">
                                                                                {(() => {
                                                                                    const subtotalCalculado = fatura.produtos?.reduce((acc, item) => {
                                                                                        return acc + (item.quantidade * item.precoUnitario * (1 - (item.descontoPercentual || 0) / 100));
                                                                                    }, 0) || 0;
                                                                                    return formatarMoeda(subtotalCalculado);
                                                                                })()}
                                                                            </td>
                                                                        </tr>

                                                                        {fatura.descontoGlobal > 0 && (
                                                                            <>
                                                                                <tr className="desconto-row">
                                                                                    <td colSpan="5" className="desconto-label">
                                                                                        Desconto ({fatura.descontoGlobal}%):
                                                                                    </td>
                                                                                    <td className="desconto-value">
                                                                                        -{formatarMoeda(fatura.descontoGlobalValor ||
                                                                                            (fatura.produtos?.reduce((acc, item) => acc + (item.quantidade * item.precoUnitario * (1 - (item.descontoPercentual || 0) / 100)), 0) || 0) * (fatura.descontoGlobal / 100))}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr className="subtotal-com-desconto-row">
                                                                                    <td colSpan="5" className="subtotal-com-desconto-label">Subtotal c/ Desconto:</td>
                                                                                    <td className="subtotal-com-desconto-value">
                                                                                        {formatarMoeda(fatura.subtotalComDesconto || fatura.subtotal || 0)}
                                                                                    </td>
                                                                                </tr>
                                                                            </>
                                                                        )}

                                                                        <tr className="iva-row">
                                                                            <td colSpan="5" className="iva-label">IVA {fatura.ivaPercent ? `(${fatura.ivaPercent}%)` : ''}:</td>
                                                                            <td className="iva-value">
                                                                                {fatura.ivaIncluso ? '-' : formatarMoeda(fatura.iva || 0)}
                                                                            </td>
                                                                        </tr>

                                                                        <tr className="total-row">
                                                                            <td colSpan="5" className="total-label">TOTAL:</td>
                                                                            <td className="total-value">{formatarMoeda(fatura.total || 0)}</td>
                                                                        </tr>

                                                                        {fatura.ivaIncluso && (
                                                                            <tr>
                                                                                <td colSpan="6" className="iva-info">
                                                                                    <Icon name="info" size={10} /> IVA já está incluído no preço
                                                                                </td>
                                                                            </tr>
                                                                        )}

                                                                        {fatura.status === 'Pago' && fatura.dataPagamento && (
                                                                            <tr>
                                                                                <td colSpan="6" className="iva-info" style={{ color: '#059669' }}>
                                                                                    <Icon name="check_circle" size={10} /> Pago em: {formatarData(fatura.dataPagamento)}
                                                                                </td>
                                                                            </tr>
                                                                        )}

                                                                        {temCotacaoOrigem && (
                                                                            <tr>
                                                                                <td colSpan="6" className="iva-info" style={{ color: '#6b7280', fontSize: '0.45rem' }}>
                                                                                    <Icon name="receipt" size={10} /> Fatura gerada a partir da cotação {typeof fatura.cotacaoId === 'object' ? fatura.cotacaoId.numero : fatura.cotacaoId}
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tfoot>
                                                                )}
                                                            </table>
                                                            {totalItensPages > 1 && (
                                                                <ItensPagination
                                                                    currentPage={currentItensPage}
                                                                    totalPages={totalItensPages}
                                                                    onPageChange={(page) => changeItensPage(fatura._id, page)}
                                                                />
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* PAGINAÇÃO */}
            {renderPagination()}

            {/* ============================================= */}
            {/* MODAL DE CRIAÇÃO */}
            {/* ============================================= */}
            {showCreateModal && (
                <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
                    <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3><Icon name="add_box" size={22} /> Nova Fatura</h3>
                            <button className="modal-close" onClick={() => setShowCreateModal(false)}>×</button>
                        </div>
                        <div className="modal-body-pdf-criar">
                            <form onSubmit={handleCreate}>
                                <div className="form-section">
                                    <h4>Dados Gerais</h4>
                                    <div className="form-row">
                                        <div className="form-group" style={{ flex: '1 1 100%' }}>
                                            <label>Cliente <span className="required">*</span></label>
                                            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                                                <div style={{ flex: 1 }}>
                                                    <SearchInput
                                                        value={searchCliente}
                                                        onChange={(val) => {
                                                            setSearchCliente(val);
                                                            if (val === '') limparSelecaoCliente();
                                                        }}
                                                        onSelect={selecionarCliente}
                                                        onClear={limparSelecaoCliente}
                                                        placeholder="Buscar cliente por nome..."
                                                        items={clientesFiltrados}
                                                        getItemLabel={(c) => c.nome}
                                                        getItemSub={(c) => c.nif ? `NUIT: ${c.nif}` : (c.email || '')}
                                                        getItemTag={(c) => c.tipoCliente || 'Particular'}
                                                        selectedId={formData.clienteId}
                                                        iconName="person_search"
                                                        iconName="hidden"
                                                        itemsPerPage={SEARCH_ITEMS_PER_PAGE}
                                                        noResultsMessage="Nenhum cliente encontrado"
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-add-cliente"
                                                    onClick={() => setShowClienteModal(true)}
                                                    title="Adicionar novo cliente"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '30px',
                                                        height: '30px',
                                                        borderRadius: '8px',
                                                        border: '1.5px dashed #d1d5db',
                                                        background: 'transparent',
                                                        color: '#9ca3af',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        flexShrink: 0,
                                                        padding: 0
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = '#4f46e5';
                                                        e.currentTarget.style.color = '#4f46e5';
                                                        e.currentTarget.style.background = 'rgba(79, 70, 229, 0.05)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = '#d1d5db';
                                                        e.currentTarget.style.color = '#9ca3af';
                                                        e.currentTarget.style.background = 'transparent';
                                                    }}
                                                >
                                                    <Icon name="add" size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Data de Emissão</label>
                                            <input
                                                type="date"
                                                value={formData.dataEmissao}
                                                onChange={(e) => setFormData({ ...formData, dataEmissao: e.target.value })}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Data de Vencimento <span className="required">*</span></label>
                                            <input
                                                type="date"
                                                value={formData.dataVencimento}
                                                onChange={(e) => setFormData({ ...formData, dataVencimento: e.target.value })}
                                                required
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Desconto Global (%)</label>
                                            <input
                                                type="number"
                                                value={formData.descontoGlobal}
                                                onChange={(e) => {
                                                    const valor = parseFloat(e.target.value) || 0;
                                                    const hasItemDesconto = formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) || false;

                                                    if (valor > 0 && hasItemDesconto) {
                                                        showToast('Não é possível aplicar desconto global porque existem itens com desconto individual. Remova os descontos dos itens primeiro.', 'warning');
                                                        return;
                                                    }
                                                    setFormData({ ...formData, descontoGlobal: Math.min(Math.max(valor, 0), 100) });
                                                }}
                                                placeholder="0"
                                                min="0"
                                                max="100"
                                                step="0.5"
                                                disabled={formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) || false}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) ? '#f3f4f6' : '#ffffff',
                                                    color: formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) ? '#6b7280' : '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    marginBottom: 'auto',
                                                    boxSizing: 'border-box',
                                                    cursor: formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) ? 'not-allowed' : 'text'
                                                }}
                                                onFocus={(e) => {
                                                    if (!formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0)) {
                                                        e.target.style.borderColor = '#4f46e5';
                                                        e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                            {formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) && (
                                                <small style={{
                                                    color: '#dc2626',
                                                    display: 'block',
                                                    marginTop: '0.25rem',
                                                    fontSize: '0.55rem !important'
                                                }}>
                                                    Remova os descontos individuais dos itens primeiro
                                                </small>
                                            )}
                                            {!formData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) && (formData?.descontoGlobal || 0) > 0 && (
                                                <small style={{
                                                    color: '#059669',
                                                    display: 'block',
                                                    marginTop: '0.25rem',
                                                    fontSize: '0.55rem'
                                                }}>
                                                    Desconto global de {formData.descontoGlobal}% aplicado
                                                </small>
                                            )}
                                        </div>
                                       <div className="form-row">
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select
                                                value={formData.status}
                                                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box',
                                                    cursor: 'pointer'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            >
                                                <option value="Rascunho">Rascunho</option>
                                                <option value="Aberta">Aberta</option>
                                                <option value="Emitida">Emitida</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                        <div className="form-group">
                                            <label>Observações</label>
                                            <textarea
                                                value={formData.observacoes}
                                                onChange={(e) => setFormData({ ...formData, observacoes: e.target.value })}
                                                placeholder="Observações adicionais"
                                                rows="2"
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    boxSizing: 'border-box',
                                                    fontFamily: 'inherit',
                                                    resize: 'vertical',
                                                    minHeight: '60px'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                        <h4 style={{ margin: 0 }}>Itens</h4>
                                        <ToggleProdutoServico
                                            tipo={tipoItem}
                                            onChange={(novoTipo) => {
                                                console.log(`🔄 Toggle alterado para: ${novoTipo}`);
                                                setTipoItem(novoTipo);
                                                setNovoItem({
                                                    id: '',
                                                    quantidade: 1,
                                                    precoUnitario: 0,
                                                    descontoPercentual: 0,
                                                    tipo: novoTipo
                                                });
                                                setSearchItem('');
                                            }}
                                            onAddProduto={handleAddProduto}
                                            onAddServico={handleAddServico}
                                            showProduto={showProduto}
                                            showServico={showServico}
                                        />
                                    </div>

                                    <div className="itens-container">
                                        <div className="item-form-row">
                                            <div className="form-group-produto">
                                                <label> {tipoItem === 'produto' ? 'Produto' : 'Serviço'} <span className="required">*</span></label>
                                                <SearchInput
                                                    value={searchItem}
                                                    onChange={(val) => {
                                                        setSearchItem(val);
                                                        if (val === '') limparSelecaoItem();
                                                    }}
                                                    onSelect={selecionarItem}
                                                    onClear={limparSelecaoItem}
                                                    placeholder={`Buscar ${tipoItem === 'produto' ? 'produto' : 'serviço'}...`}
                                                    items={getItemsPorTipo()}
                                                    getItemLabel={getItemLabel}
                                                    getItemSub={getItemSub}
                                                    getItemTag={getItemTag}
                                                    getItemPrice={getItemPrice}
                                                    selectedId={novoItem.id}
                                                    iconName="search"
                                                    iconName="hidden"
                                                    itemsPerPage={SEARCH_ITEMS_PER_PAGE}
                                                    noResultsMessage={`Nenhum ${tipoItem === 'produto' ? 'produto' : 'serviço'} encontrado`}
                                                />
                                            </div>

                                            <div className="form-group-qtd">
                                                <label style={{ marginLeft: '0.2rem' }}>Qtd <span className="required">*</span></label>
                                                <input
                                                    type="number"
                                                    value={novoItem.quantidade}
                                                    onChange={(e) => setNovoItem({ ...novoItem, quantidade: parseInt(e.target.value) || 1 })}
                                                    min="1"
                                                    step="1"
                                                    style={{ marginLeft: '0.2rem' }}
                                                />
                                            </div>

                                            <div className="form-group-desconto">
                                                <label style={{ marginLeft: '-0.7rem' }}>Desconto %</label>
                                                <input
                                                    type="number"
                                                    value={novoItem.descontoPercentual}
                                                    onChange={(e) => {
                                                        const valor = parseFloat(e.target.value) || 0;
                                                        const hasGlobalDesconto = (formData?.descontoGlobal || 0) > 0;

                                                        if (valor > 0 && hasGlobalDesconto) {
                                                            showToast('Não é possível adicionar desconto individual porque há um desconto global ativo. Remova o desconto global primeiro.', 'warning');
                                                            return;
                                                        }
                                                        setNovoItem({ ...novoItem, descontoPercentual: Math.min(Math.max(valor, 0), 100) });
                                                    }}
                                                    placeholder="0"
                                                    min="0"
                                                    max="100"
                                                    step="0.5"
                                                    disabled={(formData?.descontoGlobal || 0) > 0}
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.6rem 0.8rem',
                                                        border: '1.5px solid var(--color-border, #e5e7eb)',
                                                        borderRadius: '8px',
                                                        fontSize: '0.7rem',
                                                        background: (formData?.descontoGlobal || 0) > 0
                                                            ? 'var(--color-light, #f3f4f6)'
                                                            : 'var(--color-white, #ffffff)',
                                                        color: (formData?.descontoGlobal || 0) > 0
                                                            ? 'var(--color-info-dark, #6b7280)'
                                                            : 'var(--color-dark, #1a1a2e)',
                                                        outline: 'none',
                                                        transition: 'all 0.25s ease',
                                                        height: '38px',
                                                        marginBottom: 'auto',
                                                        boxSizing: 'border-box',
                                                        cursor: (formData?.descontoGlobal || 0) > 0 ? 'not-allowed' : 'text',
                                                        marginLeft: '-0.7rem'
                                                    }}
                                                    onFocus={(e) => {
                                                        if ((formData?.descontoGlobal || 0) === 0) {
                                                            e.target.style.borderColor = 'var(--primary, #4f46e5)';
                                                            e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = 'var(--color-border, #e5e7eb)';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>

                                            <div className="form-group-preco">
                                                <label style={{ marginLeft: '-1.5rem' }}>Preço Unit. <span className="required">*</span></label>
                                                <input
                                                    type="number"
                                                    value={novoItem.precoUnitario}
                                                    onChange={(e) => setNovoItem({ ...novoItem, precoUnitario: parseFloat(e.target.value) || 0 })}
                                                    placeholder="0.00"
                                                    min="0"
                                                    step="0.01"
                                                    style={{ marginLeft: '-1.5rem' }}
                                                />
                                            </div>

                                            <div className="form-group-add">
                                                <div style={{ marginLeft: '-8px' }}>
                                                    <button
                                                        type="button"
                                                        className="btn-add-item"
                                                        onClick={() => adicionarItem(false)}
                                                    >
                                                        <Icon name={itemEditando.index !== null ? "save" : "add"} size={16} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {formData.produtos.length > 0 && (
                                            <div className="itens-list">
                                                <table className="itens-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '30%' }}>Item</th>
                                                            <th style={{ width: '10%', textAlign: 'center' }}>Qtd</th>
                                                            <th style={{ width: '15%', textAlign: 'right' }}>Preço Unit.</th>
                                                            <th style={{ width: '12%', textAlign: 'center' }}>Desconto %</th>
                                                            <th style={{ width: '18%', textAlign: 'right' }}>Subtotal</th>
                                                            <th style={{ width: '10%', textAlign: 'center' }}>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData.produtos.map((item, index) => {
                                                            const isServico = !!item.servicoId;
                                                            const itemId = isServico ? item.servicoId : item.produtoId;
                                                            const itemsList = isServico ? servicos : produtos;
                                                            const itemData = itemsList.find(p => p._id === itemId);
                                                            const subtotalItem = item.quantidade * item.precoUnitario * (1 - (item.descontoPercentual || 0) / 100);
                                                            const isEditando = itemEditando.index === index && !itemEditando.isEdit;

                                                            return (
                                                                <tr key={index} className={isEditando ? 'editing' : ''}>
                                                                    <td>
                                                                        <div className="produto-info">
                                                                            <span className="produto-nome">
                                                                                {itemData ? itemData.nome : item.nomeItem || 'Item não encontrado'}
                                                                            </span>
                                                                            {itemData?.codigo && (
                                                                                <span className="produto-codigo">{itemData.codigo}</span>
                                                                            )}
                                                                            {isEditando && (
                                                                                <span className="edit-badge" style={{
                                                                                    marginLeft: '0.5rem',
                                                                                    fontSize: '0.55rem',
                                                                                    color: '#4f46e5',
                                                                                    background: 'rgba(79, 70, 229, 0.1)',
                                                                                    padding: '0.05rem 0.5rem',
                                                                                    borderRadius: '100px'
                                                                                }}>
                                                                                    Editando...
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>{item.quantidade}</td>
                                                                    <td style={{ textAlign: 'right' }}>{formatarMoeda(item.precoUnitario)}</td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {item.descontoPercentual > 0 ? (
                                                                            <span style={{ color: '#dc2626', fontWeight: 600 }}>
                                                                                {item.descontoPercentual}%
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ color: '#9ca3af' }}>0%</span>
                                                                        )}
                                                                    </td>
                                                                    <td style={{ textAlign: 'right', fontWeight: 600, color: '#4f46e5' }}>
                                                                        {formatarMoeda(subtotalItem)}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'center' }}>
                                                                            <button
                                                                                type="button"
                                                                                className="btn-edit-item"
                                                                                onClick={() => iniciarEdicaoItem(index, false)}
                                                                                title="Editar item"
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    color: '#6b7280',
                                                                                    padding: '4px',
                                                                                    borderRadius: '4px',
                                                                                    transition: 'all 0.2s ease'
                                                                                }}
                                                                                onMouseEnter={(e) => {
                                                                                    e.currentTarget.style.background = 'rgba(79, 70, 229, 0.1)';
                                                                                    e.currentTarget.style.color = '#4f46e5';
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    e.currentTarget.style.background = 'transparent';
                                                                                    e.currentTarget.style.color = '#6b7280';
                                                                                }}
                                                                            >
                                                                                <Icon name="edit" size={16} />
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn-remove-item"
                                                                                onClick={() => removerItem(index, false)}
                                                                                title="Remover item"
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    color: '#ef4444',
                                                                                    padding: '4px',
                                                                                    borderRadius: '4px',
                                                                                    transition: 'all 0.2s ease'
                                                                                }}
                                                                                onMouseEnter={(e) => {
                                                                                    e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)';
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    e.currentTarget.style.background = 'transparent';
                                                                                }}
                                                                            >
                                                                                <Icon name="delete" size={16} />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="form-section">
                                    <h4>Resumo da Fatura</h4>
                                    <div className="resumo-container">
                                        {(() => {
                                            const produtos = formData?.produtos || [];
                                            const descontoGlobal = formData?.descontoGlobal || 0;
                                            const ivaPercent = formData?.ivaPercent ?? ivaRef.current ?? 0;

                                            let descontoItensValor = 0;
                                            let itensComDesconto = 0;

                                            produtos.forEach((item) => {
                                                const descontoPercentual = item.descontoPercentual || 0;
                                                if (descontoPercentual > 0) {
                                                    const descontoItemValor = item.precoUnitario * (descontoPercentual / 100) * item.quantidade;
                                                    descontoItensValor += descontoItemValor;
                                                    itensComDesconto++;
                                                }
                                            });

                                            const subtotalOriginal = produtos.reduce((acc, item) => {
                                                return acc + (item.quantidade * item.precoUnitario);
                                            }, 0);

                                            const subtotalComDescontosItens = subtotalOriginal - descontoItensValor;
                                            const descontoGlobalValor = subtotalComDescontosItens * (descontoGlobal / 100);
                                            const descontoTotalValor = descontoItensValor + descontoGlobalValor;
                                            const subtotalFinal = subtotalOriginal - descontoTotalValor;
                                            const percentualTotal = subtotalOriginal > 0 ? (descontoTotalValor / subtotalOriginal) * 100 : 0;
                                            const hasDesconto = descontoGlobal > 0 || itensComDesconto > 0;

                                            const isIvaIncluso = ivaIncluso || ivaPercent === 0 || ivaPercent === 15;
                                            let ivaValor = 0;
                                            let totalFinal = subtotalFinal;

                                            if (!isIvaIncluso) {
                                                ivaValor = subtotalFinal * (ivaPercent / 100);
                                                totalFinal = subtotalFinal + ivaValor;
                                            }

                                            const fmt = (valor) => formatarMoeda(valor);
                                            const isZeroDesconto = descontoTotalValor === 0;

                                            return (
                                                <>
                                                    <div className="resumo-row">
                                                        <span className="resumo-label">Subtotal</span>
                                                        <span className="resumo-valor">{fmt(subtotalOriginal)}</span>
                                                    </div>

                                                    <div className="resumo-row" style={{
                                                        color: isZeroDesconto ? '#9ca3af' : '#dc2626',
                                                        opacity: isZeroDesconto ? 0.6 : 1
                                                    }}>
                                                        <span className="resumo-label" style={{ fontWeight: 700 }}>
                                                            Desconto {!isZeroDesconto && `(${percentualTotal.toFixed(1)}%)`}
                                                            {isZeroDesconto && '(0%)'}
                                                        </span>
                                                        <span className="resumo-valor" style={{
                                                            fontWeight: 600,
                                                            color: isZeroDesconto ? '#9ca3af' : '#dc2626'
                                                        }}>
                                                            {fmt(descontoTotalValor)}
                                                        </span>
                                                    </div>

                                                    {hasDesconto && (
                                                        <div className="resumo-row">
                                                            <span className="resumo-label" style={{ fontWeight: 700 }}>Subtotal c/ Desconto</span>
                                                            <span className="resumo-valor" style={{ fontWeight: 700 }}>
                                                                {fmt(subtotalFinal)}
                                                            </span>
                                                        </div>
                                                    )}

                                                    {!isIvaIncluso && (
                                                        <div className="resumo-row">
                                                            <span className="resumo-label">IVA {ivaPercent}%</span>
                                                            <span className="resumo-valor">{fmt(ivaValor)}</span>
                                                        </div>
                                                    )}

                                                    <div className="resumo-row resumo-total">
                                                        <span className="resumo-label"><strong>Total</strong></span>
                                                        <span className="resumo-valor"><strong>{fmt(totalFinal)}</strong></span>
                                                    </div>

                                                    {isIvaIncluso && (
                                                        <div className="resumo-info" style={{ fontSize: '7px' }}>
                                                            <Icon name="info" size={9} />
                                                            {ivaPercent === 15 ? 'IVA (15%) já está incluído no preço' :
                                                                ivaPercent === 0 ? 'Operação não sujeita a IVA' :
                                                                    'IVA já está incluído no preço'}
                                                        </div>
                                                    )}

                                                    {itensComDesconto > 0 && descontoGlobal === 0 && (
                                                        <div className="resumo-info" style={{ color: '#dc2626', fontSize: '7px' }}>
                                                            <Icon name="info" size={9} />
                                                            {itensComDesconto} {itensComDesconto === 1 ? 'item' : 'itens'} com desconto individual aplicado
                                                        </div>
                                                    )}

                                                    {descontoGlobal > 0 && itensComDesconto === 0 && (
                                                        <div className="resumo-info" style={{ color: '#059669', fontSize: '7px' }}>
                                                            <Icon name="info" size={9} />
                                                            Desconto global de {descontoGlobal}% aplicado a todos os itens
                                                        </div>
                                                    )}

                                                    {descontoGlobal > 0 && itensComDesconto > 0 && (
                                                        <div className="resumo-info" style={{ color: '#dc2626', background: '#fef2f2', padding: '4px 8px', borderRadius: '4px', fontSize: '7px' }}>
                                                            <Icon name="warning" size={9} />
                                                            ⚠️ Conflito: Desconto global e descontos individuais ativos simultaneamente!
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </div>
                                </div>

                                <div className="modal-actions">
                                    <button type="submit" className="modal-btn-primary" disabled={loading}>
                                        {loading ? 'A criar...' : 'Criar Fatura'}
                                    </button>
                                    <button type="button" className="modal-btn-secondary" onClick={() => { setShowCreateModal(false); resetForm(); }}>
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================= */}
            {/* MODAL DE EDIÇÃO */}
            {/* ============================================= */}
            {showEditModal && editFormData && (
                <div className="modal-overlay" onClick={() => { setShowEditModal(false); resetEditForm(); }}>
                    <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3><Icon name="edit" size={22} /> Editar Fatura</h3>
                            <button className="modal-close" onClick={() => { setShowEditModal(false); resetEditForm(); }}>×</button>
                        </div>
                        <div className="modal-body-pdf-editar">
                            <form onSubmit={handleUpdate}>
                                <div className="form-section">
                                    <h4>Dados Gerais</h4>
                                    <div className="form-row">
                                        <div className="form-group" style={{ flex: '1 1 100%' }}>
                                            <label>Cliente <span className="required">*</span></label>
                                            <div style={{
                                                background: editFormData?.clienteId ? 'rgba(16, 185, 129, 0.55)' : 'transparent',
                                                borderRadius: '8px',
                                                padding: '2px',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                <SearchInput
                                                    value={searchClienteEdit}
                                                    onChange={(val) => {
                                                        setSearchClienteEdit(val);
                                                        if (val === '') limparSelecaoClienteEdit();
                                                    }}
                                                    onSelect={selecionarClienteEdit}
                                                    onClear={limparSelecaoClienteEdit}
                                                    placeholder="Buscar cliente por nome..."
                                                    items={clientes}
                                                    getItemLabel={(c) => c.nome}
                                                    getItemSub={(c) => c.nif ? `NUIT: ${c.nif}` : (c.email || '')}
                                                    getItemTag={(c) => c.tipoCliente || 'Particular'}
                                                    selectedId={editFormData.clienteId}
                                                    iconName="person_search"
                                                    iconName="hidden"
                                                    itemsPerPage={SEARCH_ITEMS_PER_PAGE}
                                                    noResultsMessage="Nenhum cliente encontrado"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Data de Emissão</label>
                                            <input
                                                type="date"
                                                value={editFormData.dataEmissao || new Date().toISOString().split('T')[0]}
                                                onChange={(e) => setEditFormData({ ...editFormData, dataEmissao: e.target.value })}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Data de Vencimento <span className="required">*</span></label>
                                            <input
                                                type="date"
                                                value={editFormData.dataVencimento}
                                                onChange={(e) => setEditFormData({ ...editFormData, dataVencimento: e.target.value })}
                                                required
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Desconto Global (%)</label>
                                            <input
                                                type="number"
                                                value={editFormData.descontoGlobal || 0}
                                                onChange={(e) => {
                                                    const valor = parseFloat(e.target.value) || 0;
                                                    const hasItemDesconto = editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) || false;

                                                    if (valor > 0 && hasItemDesconto) {
                                                        showToast('Não é possível aplicar desconto global porque existem itens com desconto individual. Remova os descontos dos itens primeiro.', 'warning');
                                                        return;
                                                    }
                                                    setEditFormData({ ...editFormData, descontoGlobal: Math.min(Math.max(valor, 0), 100) });
                                                }}
                                                placeholder="0"
                                                min="0"
                                                max="100"
                                                step="0.5"
                                                disabled={editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) || false}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) ? '#f3f4f6' : '#ffffff',
                                                    color: editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) ? '#6b7280' : '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box',
                                                    cursor: editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) ? 'not-allowed' : 'text'
                                                }}
                                                onFocus={(e) => {
                                                    if (!editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0)) {
                                                        e.target.style.borderColor = '#4f46e5';
                                                        e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                            {editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) && (
                                                <small style={{
                                                    color: '#dc2626',
                                                    display: 'block',
                                                    marginTop: '0.25rem',
                                                    fontSize: '0.55rem'
                                                }}>
                                                    Desabilitado: remova os descontos individuais dos itens primeiro
                                                </small>
                                            )}
                                            {!editFormData?.produtos?.some(item => (item.descontoPercentual || 0) > 0) && (editFormData?.descontoGlobal || 0) > 0 && (
                                                <small style={{
                                                    color: '#059669',
                                                    display: 'block',
                                                    marginTop: '0.25rem',
                                                    fontSize: '0.7rem'
                                                }}>
                                                    ✅ Desconto global de {editFormData.descontoGlobal}% aplicado
                                                </small>
                                            )}
                                        </div>
                                       <div className="form-row">
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select
                                                value={editFormData.status || 'Rascunho'}
                                                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
                                                disabled={['Pago', 'Cancelada'].includes(editFormData.status)}
                                                style={{
                                                    width: '100%',
                                                    padding: '0.6rem 0.8rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.85rem',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    height: '42px',
                                                    boxSizing: 'border-box',
                                                    cursor: 'pointer'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            >
                                                <option value="Rascunho">Rascunho</option>
                                                <option value="Aberta">Aberta</option>
                                                <option value="Emitida">Emitida</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                        <div className="form-group">
                                            <label>Observações</label>
                                            <textarea
                                                value={editFormData.observacoes || ''}
                                                onChange={(e) => setEditFormData({ ...editFormData, observacoes: e.target.value })}
                                                placeholder="Observações adicionais"
                                                rows="3"
                                                style={{
                                                    width: '100% !important',
                                                    padding: '0.7rem 0.9rem',
                                                    border: '1.5px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '0.78rem',
                                                    lineHeight: '1.5',
                                                    background: '#ffffff',
                                                    color: '#1a1a2e',
                                                    outline: 'none',
                                                    transition: 'all 0.25s ease',
                                                    boxSizing: 'border-box',
                                                    fontFamily: 'inherit',
                                                    resize: 'vertical',
                                                    minHeight: '150px !important',
                                                    height: '100px !important',
                                                    maxHeight: '300px !important'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#4f46e5';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                        <h4 style={{ margin: 0 }}>Itens</h4>
                                        <ToggleProdutoServico
                                            tipo={tipoItem}
                                            onChange={(novoTipo) => {
                                                setTipoItem(novoTipo);
                                                setNovoItem({
                                                    id: '',
                                                    quantidade: 1,
                                                    precoUnitario: 0,
                                                    descontoPercentual: 0,
                                                    tipo: novoTipo
                                                });
                                                setSearchItemEdit('');
                                            }}
                                            onAddProduto={handleAddProduto}
                                            onAddServico={handleAddServico}
                                            showProduto={showProduto}
                                            showServico={showServico}
                                        />
                                    </div>

                                    <div className="itens-container">
                                        <div className="item-form-row">
                                            <div className="form-group-produto">
                                                <label>{tipoItem === 'produto' ? 'Produto' : 'Serviço'}</label>
                                                <SearchInput
                                                    value={searchItemEdit}
                                                    onChange={(val) => {
                                                        setSearchItemEdit(val);
                                                        if (val === '') limparSelecaoItemEdit();
                                                    }}
                                                    onSelect={selecionarItemEdit}
                                                    onClear={limparSelecaoItemEdit}
                                                    placeholder={`Buscar ${tipoItem === 'produto' ? 'produto' : 'serviço'}...`}
                                                    items={getItemsPorTipo()}
                                                    getItemLabel={getItemLabel}
                                                    getItemSub={getItemSub}
                                                    getItemTag={getItemTag}
                                                    getItemPrice={getItemPrice}
                                                    selectedId={novoItem.id}
                                                    iconName="search"
                                                    iconName="hidden"
                                                    itemsPerPage={SEARCH_ITEMS_PER_PAGE}
                                                    noResultsMessage={`Nenhum ${tipoItem === 'produto' ? 'produto' : 'serviço'} encontrado`}
                                                />
                                            </div>

                                            <div className="form-group-qtd">
                                                <label style={{ marginLeft: '0.2rem' }}>Qtd</label>
                                                <input
                                                    type="number"
                                                    value={novoItem.quantidade}
                                                    onChange={(e) => setNovoItem({ ...novoItem, quantidade: parseInt(e.target.value) || 1 })}
                                                    min="1"
                                                    step="1"
                                                    style={{ marginLeft: '0.2rem' }}
                                                />
                                            </div>

                                            <div className="form-group-desconto">
                                                <label style={{ marginLeft: '-0.7rem' }}>Desconto %</label>
                                                <input
                                                    type="number"
                                                    value={novoItem.descontoPercentual}
                                                    onChange={(e) => {
                                                        const valor = parseFloat(e.target.value) || 0;
                                                        const hasGlobalDesconto = (editFormData?.descontoGlobal || 0) > 0;

                                                        if (valor > 0 && hasGlobalDesconto) {
                                                            showToast('Não é possível adicionar desconto individual porque há um desconto global ativo. Remova o desconto global primeiro.', 'warning');
                                                            return;
                                                        }
                                                        setNovoItem({ ...novoItem, descontoPercentual: Math.min(Math.max(valor, 0), 100) });
                                                    }}
                                                    placeholder="0"
                                                    min="0"
                                                    max="100"
                                                    step="0.5"
                                                    disabled={(editFormData?.descontoGlobal || 0) > 0}
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.6rem 0.8rem',
                                                        border: '1.5px solid var(--color-border, #e5e7eb)',
                                                        borderRadius: '8px',
                                                        fontSize: '0.7rem',
                                                        background: (editFormData?.descontoGlobal || 0) > 0
                                                            ? 'var(--color-light, #f3f4f6)'
                                                            : 'var(--color-white, #ffffff)',
                                                        color: (editFormData?.descontoGlobal || 0) > 0
                                                            ? 'var(--color-info-dark, #6b7280)'
                                                            : 'var(--color-dark, #1a1a2e)',
                                                        outline: 'none',
                                                        transition: 'all 0.25s ease',
                                                        height: '38px',
                                                        marginBottom: 'auto',
                                                        boxSizing: 'border-box',
                                                        cursor: (editFormData?.descontoGlobal || 0) > 0 ? 'not-allowed' : 'text',
                                                        marginLeft: '-0.7rem'
                                                    }}
                                                    onFocus={(e) => {
                                                        if ((editFormData?.descontoGlobal || 0) === 0) {
                                                            e.target.style.borderColor = 'var(--primary, #4f46e5)';
                                                            e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = 'var(--color-border, #e5e7eb)';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>

                                            <div className="form-group-preco">
                                                <label style={{ marginLeft: '-1.5rem' }}>Preço Unit.</label>
                                                <input
                                                    type="number"
                                                    value={novoItem.precoUnitario}
                                                    onChange={(e) => setNovoItem({ ...novoItem, precoUnitario: parseFloat(e.target.value) || 0 })}
                                                    placeholder="0.00"
                                                    min="0"
                                                    step="0.01"
                                                    style={{ marginLeft: '-1.5rem' }}
                                                />
                                            </div>

                                            <div className="form-group-add">
                                                <div style={{ marginLeft: '-2rem' }}>
                                                    <button
                                                        type="button"
                                                        className="btn-add-item"
                                                        onClick={() => adicionarItem(true)}
                                                    >
                                                        <Icon name={itemEditando.index !== null && itemEditando.isEdit ? "save" : "add"} size={16} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {editFormData.produtos && editFormData.produtos.length > 0 && (
                                            <div className="itens-list">
                                                <table className="itens-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '30%' }}>Item</th>
                                                            <th style={{ width: '10%', textAlign: 'center' }}>Qtd</th>
                                                            <th style={{ width: '15%', textAlign: 'right' }}>Preço Unit.</th>
                                                            <th style={{ width: '12%', textAlign: 'center' }}>Desconto %</th>
                                                            <th style={{ width: '18%', textAlign: 'right' }}>Subtotal</th>
                                                            <th style={{ width: '10%', textAlign: 'center' }}>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {editFormData.produtos.map((item, index) => {
                                                            const isServico = !!item.servicoId;
                                                            const itemId = isServico ? item.servicoId : item.produtoId;

                                                            let nomeItem = '';
                                                            let codigoItem = '';

                                                            if (item.nomeItem) {
                                                                nomeItem = item.nomeItem;
                                                                codigoItem = item.codigoItem || '';
                                                            } else if (itemId) {
                                                                const id = typeof itemId === 'object' ? itemId._id || itemId : itemId;
                                                                const itemsList = isServico ? servicos : produtos;
                                                                const itemData = itemsList.find(p => p._id === id);
                                                                if (itemData) {
                                                                    nomeItem = itemData.nome || 'Item';
                                                                    codigoItem = itemData.codigo || '';
                                                                }
                                                            } else if (item.produtoData) {
                                                                nomeItem = item.produtoData.nome || 'Item';
                                                                codigoItem = item.produtoData.codigo || '';
                                                            } else if (item.servicoData) {
                                                                nomeItem = item.servicoData.nome || 'Item';
                                                                codigoItem = item.servicoData.codigo || '';
                                                            } else if (!isServico && item.produtoId && typeof item.produtoId === 'object' && item.produtoId.nome) {
                                                                nomeItem = item.produtoId.nome;
                                                                codigoItem = item.produtoId.codigo || '';
                                                            } else if (isServico && item.servicoId && typeof item.servicoId === 'object' && item.servicoId.nome) {
                                                                nomeItem = item.servicoId.nome;
                                                                codigoItem = item.servicoId.codigo || '';
                                                            } else {
                                                                nomeItem = 'Item não encontrado';
                                                            }

                                                            const subtotalItem = item.quantidade * item.precoUnitario * (1 - (item.descontoPercentual || 0) / 100);
                                                            const isEditando = itemEditando.index === index && itemEditando.isEdit;

                                                            return (
                                                                <tr key={index} className={isEditando ? 'editing' : ''}>
                                                                    <td>
                                                                        <div className="produto-info" style={{ fontSize: '0.6rem' }}>
                                                                            <span className="produto-nome">{nomeItem}</span>
                                                                            {codigoItem && (
                                                                                <span className="produto-codigo">{codigoItem}</span>
                                                                            )}
                                                                            {isEditando && (
                                                                                <span className="edit-badge" style={{
                                                                                    marginLeft: '0.5rem',
                                                                                    fontSize: '0.55rem',
                                                                                    color: '#4f46e5',
                                                                                    background: 'rgba(79, 70, 229, 0.1)',
                                                                                    padding: '0.05rem 0.5rem',
                                                                                    borderRadius: '100px'
                                                                                }}>
                                                                                    Editando...
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>{item.quantidade}</td>
                                                                    <td style={{ textAlign: 'right' }}>{formatarMoeda(item.precoUnitario)}</td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {item.descontoPercentual > 0 ? (
                                                                            <span style={{ color: '#dc2626', fontWeight: 600 }}>
                                                                                {item.descontoPercentual}%
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ color: '#9ca3af' }}>0%</span>
                                                                        )}
                                                                    </td>
                                                                    <td style={{ textAlign: 'right', fontWeight: 600, color: '#4f46e5' }}>
                                                                        {formatarMoeda(subtotalItem)}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'center' }}>
                                                                            <button
                                                                                type="button"
                                                                                className="btn-edit-item"
                                                                                onClick={() => iniciarEdicaoItem(index, true)}
                                                                                title="Editar item"
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    color: '#6b7280',
                                                                                    padding: '4px',
                                                                                    height: '25px',
                                                                                    borderRadius: '16px',
                                                                                    transition: 'all 0.2s ease'
                                                                                }}
                                                                                onMouseEnter={(e) => {
                                                                                    e.currentTarget.style.background = 'rgba(79, 70, 229, 0.1)';
                                                                                    e.currentTarget.style.color = '#4f46e5';
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    e.currentTarget.style.background = 'transparent';
                                                                                    e.currentTarget.style.color = '#6b7280';
                                                                                }}
                                                                            >
                                                                                <Icon name="edit" size={16} />
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn-remove-item"
                                                                                onClick={() => removerItem(index, true)}
                                                                                title="Remover item"
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    color: '#ef4444',
                                                                                    padding: '4px',
                                                                                    borderRadius: '16px',
                                                                                    transition: 'all 0.2s ease'
                                                                                }}
                                                                                onMouseEnter={(e) => {
                                                                                    e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)';
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    e.currentTarget.style.background = 'transparent';
                                                                                }}
                                                                            >
                                                                                <Icon name="delete" size={16} />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="form-section">
                                    <h4>Resumo da Fatura</h4>
                                    <div className="resumo-container">
                                        {(() => {
                                            const produtos = editFormData?.produtos || [];
                                            const descontoGlobal = editFormData?.descontoGlobal || 0;
                                            const ivaPercent = editFormData?.ivaPercent ?? ivaRef.current ?? 0;

                                            let descontoItensValor = 0;
                                            let itensComDesconto = 0;

                                            produtos.forEach((item) => {
                                                const descontoPercentual = item.descontoPercentual || 0;
                                                if (descontoPercentual > 0) {
                                                    const descontoItemValor = item.precoUnitario * (descontoPercentual / 100) * item.quantidade;
                                                    descontoItensValor += descontoItemValor;
                                                    itensComDesconto++;
                                                }
                                            });

                                            const subtotalOriginal = produtos.reduce((acc, item) => {
                                                return acc + (item.quantidade * item.precoUnitario);
                                            }, 0);

                                            const subtotalComDescontosItens = subtotalOriginal - descontoItensValor;
                                            const descontoGlobalValor = subtotalComDescontosItens * (descontoGlobal / 100);
                                            const descontoTotalValor = descontoItensValor + descontoGlobalValor;
                                            const subtotalFinal = subtotalOriginal - descontoTotalValor;
                                            const percentualTotal = subtotalOriginal > 0 ? (descontoTotalValor / subtotalOriginal) * 100 : 0;
                                            const hasDesconto = descontoGlobal > 0 || itensComDesconto > 0;

                                            const isIvaIncluso = ivaIncluso || ivaPercent === 0 || ivaPercent === 15;
                                            let ivaValor = 0;
                                            let totalFinal = subtotalFinal;

                                            if (!isIvaIncluso) {
                                                ivaValor = subtotalFinal * (ivaPercent / 100);
                                                totalFinal = subtotalFinal + ivaValor;
                                            }

                                            const fmt = (valor) => formatarMoeda(valor);
                                            const isZeroDesconto = descontoTotalValor === 0;

                                            return (
                                                <>
                                                    <div className="resumo-row">
                                                        <span className="resumo-label">Subtotal</span>
                                                        <span className="resumo-valor">{fmt(subtotalOriginal)}</span>
                                                    </div>

                                                    <div className="resumo-row" style={{
                                                        color: isZeroDesconto ? '#9ca3af' : '#dc2626',
                                                        opacity: isZeroDesconto ? 0.6 : 1
                                                    }}>
                                                        <span className="resumo-label" style={{ fontWeight: 700 }}>
                                                            Desconto {!isZeroDesconto && `(${percentualTotal.toFixed(1)}%)`}
                                                            {isZeroDesconto && '(0%)'}
                                                        </span>
                                                        <span className="resumo-valor" style={{
                                                            fontWeight: 600,
                                                            color: isZeroDesconto ? '#9ca3af' : '#dc2626'
                                                        }}>
                                                            {fmt(descontoTotalValor)}
                                                        </span>
                                                    </div>

                                                    {hasDesconto && (
                                                        <div className="resumo-row">
                                                            <span className="resumo-label" style={{ fontWeight: 700 }}>Subtotal c/ Desconto</span>
                                                            <span className="resumo-valor" style={{ fontWeight: 700 }}>
                                                                {fmt(subtotalFinal)}
                                                            </span>
                                                        </div>
                                                    )}

                                                    {!isIvaIncluso && (
                                                        <div className="resumo-row">
                                                            <span className="resumo-label">IVA {ivaPercent}%</span>
                                                            <span className="resumo-valor">{fmt(ivaValor)}</span>
                                                        </div>
                                                    )}

                                                    <div className="resumo-row resumo-total">
                                                        <span className="resumo-label"><strong>Total</strong></span>
                                                        <span className="resumo-valor"><strong>{fmt(totalFinal)}</strong></span>
                                                    </div>

                                                    {isIvaIncluso && (
                                                        <div className="resumo-info" style={{ fontSize: '7px' }}>
                                                            <Icon name="info" size={9} />
                                                            {ivaPercent === 15 ? 'IVA (15%) já está incluído no preço' :
                                                                ivaPercent === 0 ? 'Operação não sujeita a IVA' :
                                                                    'IVA já está incluído no preço'}
                                                        </div>
                                                    )}

                                                    {itensComDesconto > 0 && descontoGlobal === 0 && (
                                                        <div className="resumo-info" style={{ color: '#dc2626', fontSize: '7px' }}>
                                                            <Icon name="info" size={9} />
                                                            {itensComDesconto} {itensComDesconto === 1 ? 'item' : 'itens'} com desconto individual aplicado
                                                        </div>
                                                    )}

                                                    {descontoGlobal > 0 && itensComDesconto === 0 && (
                                                        <div className="resumo-info" style={{ color: '#059669', fontSize: '7px' }}>
                                                            <Icon name="info" size={9} />
                                                            Desconto global de {descontoGlobal}% aplicado a todos os itens
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </div>
                                </div>

                                <div className="modal-actions">
                                    <button type="submit" className="modal-btn-primary" disabled={loading}>
                                        {loading ? 'A atualizar...' : 'Atualizar Fatura'}
                                    </button>
                                    <button type="button" className="modal-btn-secondary" onClick={() => { setShowEditModal(false); resetEditForm(); }}>
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================= */}
            {/* MODAL DE PAGAMENTO */}
            {/* ============================================= */}
            {showPayModal && faturaToPay && (
                <div className="modal-overlay" onClick={() => setShowPayModal(false)}>
                    <div className="modal-content-popups-cotacao modal-confirm" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3><span className="header-icon">💰</span> Registrar Pagamento</h3>
                            <button className="modal-close" onClick={() => setShowPayModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="confirm-icon success">
                                <Icon name="paid" size={32} />
                            </div>
                            <h4>Registrar Pagamento</h4>
                            <p>Deseja registrar o pagamento da fatura #{faturaToPay.numero}?</p>
                            <p className="confirm-subtext">
                                <Icon name="info" size={14} />
                                Valor total: <strong>{formatarMoeda(faturaToPay.total || 0)}</strong>
                            </p>

                            <div className="form-group-pagamento">
                                <label>Data de Pagamento <span className="required">*</span></label>
                                <input
                                    type="date"
                                    value={dataPagamento}
                                    onChange={(e) => setDataPagamento(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '0.6rem 0.8rem',
                                        border: '1.5px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '0.85rem',
                                        background: 'var(--color-white, #fff)',
                                        color: 'var(--color-dark, #1a1a2e)',
                                        outline: 'none',
                                        transition: 'all 0.25s ease',
                                        height: '42px',
                                        boxSizing: 'border-box'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#4f46e5';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e5e7eb';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            </div>

                            <div className="form-group-pagamento" style={{ marginTop: '12px' }}>
                                <label>Forma de Pagamento <span className="required">*</span></label>
                                <select
                                    value={formaPagamentoSelecionada}
                                    onChange={handleFormaPagamentoChange}
                                    style={{
                                        width: '100%',
                                        padding: '0.6rem 0.8rem',
                                        border: '1.5px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '0.85rem',
                                        background: 'var(--color-white, #fff)',
                                        color: 'var(--color-dark, #1a1a2e)',
                                        outline: 'none',
                                        transition: 'all 0.25s ease',
                                        height: '42px',
                                        boxSizing: 'border-box',
                                        cursor: 'pointer'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#4f46e5';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e5e7eb';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                >
                                    {FORMAS_PAGAMENTO.map(fp => (
                                        <option key={fp.value} value={fp.value}>
                                            {fp.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {showDetalhesPagamento && (
                                <div className="form-group-pagamento" style={{ marginTop: '12px' }}>
                                    <label>
                                        {formaPagamentoSelecionada === 'Transferência Bancária' && 'Nº de Transferência / Comprovativo'}
                                        {formaPagamentoSelecionada === 'Cheque' && 'Nº do Cheque / Banco'}
                                        {formaPagamentoSelecionada === 'Cartão' && 'Nº do Cartão / Terminal'}
                                        {formaPagamentoSelecionada === 'MBWay' && 'Nº de Telefone / Código'}
                                        {formaPagamentoSelecionada === 'M-Pesa' && 'Nº de Telefone / Código'}
                                        {formaPagamentoSelecionada === 'E-Mola' && 'Nº de Telefone / Código'}
                                        {formaPagamentoSelecionada === 'Outro' && 'Detalhes da Transação'}
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={detalhesPagamento}
                                        onChange={(e) => setDetalhesPagamento(e.target.value)}
                                        placeholder={
                                            formaPagamentoSelecionada === 'Transferência Bancária' ? 'Ex: TB-2024-001234' :
                                                formaPagamentoSelecionada === 'Cheque' ? 'Ex: CHQ-001234 - Banco XYZ' :
                                                    formaPagamentoSelecionada === 'Cartão' ? 'Ex: **** 1234 - Terminal 01' :
                                                        formaPagamentoSelecionada === 'MBWay' ? 'Ex: 84 123 4567 - Código: 123456' :
                                                            formaPagamentoSelecionada === 'M-Pesa' ? 'Ex: 84 123 4567 - Código: 123456' :
                                                                formaPagamentoSelecionada === 'E-Mola' ? 'Ex: 84 123 4567 - Código: 123456' :
                                                                    'Informe os detalhes da transação'
                                        }
                                        style={{
                                            width: '100%',
                                            padding: '0.6rem 0.8rem',
                                            border: '1.5px solid #e5e7eb',
                                            borderRadius: '8px',
                                            fontSize: '0.85rem',
                                            background: 'var(--color-white, #fff)',
                                            color: 'var(--color-dark, #1a1a2e)',
                                            outline: 'none',
                                            transition: 'all 0.25s ease',
                                            height: '42px',
                                            boxSizing: 'border-box'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#4f46e5';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e5e7eb';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                    <small style={{
                                        display: 'block',
                                        marginTop: '0.25rem',
                                        fontSize: '0.65rem',
                                        color: '#6b7280'
                                    }}>
                                        Informe o número de referência ou comprovativo da transação
                                    </small>
                                </div>
                            )}

                            {formaPagamentoSelecionada === 'Dinheiro' && (
                                <div style={{
                                    marginTop: '10px',
                                    padding: '8px 12px',
                                    background: 'rgba(5, 150, 105, 0.08)',
                                    borderRadius: '6px',
                                    fontSize: '0.75rem',
                                    color: '#059669',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    <Icon name="info" size={14} />
                                    <span>Pagamento em dinheiro - não é necessário informar detalhes adicionais</span>
                                </div>
                            )}

                            <div className="form-group-pagamento" style={{ marginTop: '12px' }}>
                                <label>
                                    Observação <span style={{ color: '#9ca3af', fontSize: '0.7rem', fontWeight: 400 }}>(opcional)</span>
                                </label>
                                <input
                                    type="text"
                                    value={observacaoPagamento}
                                    onChange={(e) => setObservacaoPagamento(e.target.value)}
                                    placeholder="Nota adicional (opcional)"
                                    style={{
                                        width: '100%',
                                        padding: '0.6rem 0.8rem',
                                        border: '1.5px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '0.85rem',
                                        background: 'var(--color-white, #fff)',
                                        color: 'var(--color-dark, #1a1a2e)',
                                        outline: 'none',
                                        transition: 'all 0.25s ease',
                                        height: '42px',
                                        boxSizing: 'border-box'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#4f46e5';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e5e7eb';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                                <small style={{
                                    display: 'block',
                                    marginTop: '0.25rem',
                                    fontSize: '0.65rem',
                                    color: '#6b7280'
                                }}>
                                    Aparecerá no recibo como observação. Deixe em branco se não precisar.
                                </small>
                            </div>

                            {/* 🔥 AVISO: Stock só sai na Guia de Entrega */}
                            <div style={{
                                marginTop: '12px',
                                padding: '10px 14px',
                                background: 'rgba(79, 70, 229, 0.06)',
                                border: '1px solid rgba(79, 70, 229, 0.15)',
                                borderRadius: '8px',
                                fontSize: '0.75rem',
                                color: '#4f46e5',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <Icon name="info" size={16} />
                                <span>
                                    O stock dos produtos será atualizado quando a <strong>Guia de Entrega</strong> for confirmada como entregue.
                                </span>
                            </div>
                        </div>
                        <div className="modal-actions">
                            <button className="btn-confirm-payment" onClick={() => registrarPagamento(faturaToPay._id)} disabled={loading}>
                                {loading ? 'A processar...' : 'Sim, Registrar Pagamento'}
                            </button>
                            <button className="btn-cancel" onClick={() => setShowPayModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================= */}
            {/* MODAL CRIAR GUIA DE ENTREGA */}
            {/* ============================================= */}
            {showCreateGuiaModal && faturaParaGuia && (
                <div className="modal-overlay" onClick={() => setShowCreateGuiaModal(false)}>
                    <div className="modal-content-popups-cotacao modal-confirm" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3><span className="header-icon"></span> Criar Guia de Entrega</h3>
                            <button className="modal-close" onClick={() => setShowCreateGuiaModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="confirm-icon" style={{ background: 'rgba(79, 70, 229, 0.1)' }}>
                                <Icon name="delivery_truck" size={32} style={{ color: '#4f46e5' }} />
                            </div>
                            <h4>Criar Guia de Entrega</h4>
                            <p>Deseja criar uma guia de entrega para a fatura <strong>{faturaParaGuia.numero}</strong>?</p>
                            <p className="confirm-subtext">
                                <Icon name="info" size={14} />
                                Cliente: <strong>{getClienteNome(faturaParaGuia)}</strong>
                            </p>

                            <div style={{
                                marginTop: '16px',
                                padding: '12px 16px',
                                background: 'rgba(79, 70, 229, 0.06)',
                                borderRadius: '8px',
                                borderLeft: '3px solid #4f46e5',
                                fontSize: '0.8rem',
                                color: '#4f46e5'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                                    <Icon name="info" size={16} />
                                    <strong>Importante:</strong>
                                </div>
                                <p style={{ margin: 0, fontSize: '0.75rem', lineHeight: 1.5, textAlign: 'left' }}>
                                    A guia será criada com todos os itens da fatura. O stock dos produtos será atualizado apenas
                                    quando a guia for confirmada como <strong>entregue</strong> no módulo de Guias de Entrega.
                                    Serviços não afetam o stock.
                                </p>
                            </div>
                        </div>
                        <div className="modal-actions">
                            <button
                                className="modal-btn-primary"
                                onClick={confirmarCriarGuia}
                                disabled={loading}
                                style={{
                                    background: 'linear-gradient(135deg, #4f46e5, #4338ca)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    opacity: loading ? 0.7 : 1,
                                    cursor: loading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <Icon name={loading ? "hourglass_top" : "delivery_truck"} size={18} />
                                {loading ? 'A criar guia...' : 'Criar Guia de Entrega'}
                            </button>
                            <button className="btn-cancel" onClick={() => setShowCreateGuiaModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DE CANCELAMENTO */}
            {showCancelModal && faturaToCancel && (
                <div className="modal-overlay" onClick={() => setShowCancelModal(false)}>
                    <div className="modal-content-popups-cotacao modal-confirm" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3><span className="header-icon">❌</span> Cancelar Fatura</h3>
                            <button className="modal-close" onClick={() => setShowCancelModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="confirm-icon danger">
                                <Icon name="warning" size={32} />
                            </div>
                            <h4>Confirmar Cancelamento</h4>
                            <p>Tem certeza que deseja cancelar a fatura #{faturaToCancel.numero}?</p>
                            <div className="form-group-cancelamento">
                                <label>Motivo do cancelamento <span className="required">*</span></label>
                                <textarea
                                    value={motivoCancelamento}
                                    onChange={(e) => setMotivoCancelamento(e.target.value)}
                                    placeholder="Informe o motivo do cancelamento"
                                    rows="3"
                                    style={{
                                        width: '100%',
                                        padding: '0.6rem 0.8rem',
                                        border: '1.5px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '0.85rem',
                                        background: 'var(--color-white, #fff)',
                                        color: 'var(--color-dark, #1a1a2e)',
                                        outline: 'none',
                                        transition: 'all 0.25s ease',
                                        boxSizing: 'border-box',
                                        fontFamily: 'inherit',
                                        resize: 'vertical',
                                        minHeight: '70px'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#4f46e5';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(79, 70, 229, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e5e7eb';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-actions">
                            <button className="btn-confirm-danger" onClick={() => cancelarFatura(faturaToCancel._id)} disabled={loading}>
                                {loading ? 'A processar...' : 'Sim, Cancelar'}
                            </button>
                            <button className="btn-cancel" onClick={() => setShowCancelModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DE EXCLUSÃO */}
            {showDeleteModal && faturaToDelete && (
                <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
                    <div className="modal-content-popups-cotacao modal-confirm" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3><span className="header-icon">⚠️</span> Confirmar Exclusão</h3>
                            <button className="modal-close" onClick={() => setShowDeleteModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="confirm-icon danger">
                                <Icon name="warning" size={32} />
                            </div>
                            <h4>Remover fatura?</h4>
                            <p>Tem certeza que deseja remover a fatura #{faturaToDelete.numero}?</p>
                            <p className="confirm-subtext">
                                <Icon name="info" size={14} /> Esta ação é irreversível.
                            </p>
                        </div>
                        <div className="modal-actions">
                            <button className="btn-confirm-danger" onClick={handleDelete} disabled={loading}>
                                {loading ? 'A processar...' : 'Eliminar'}
                            </button>
                            <button className="btn-cancel" onClick={() => setShowDeleteModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================= */}
            {/* MODAL DE DETALHES DA FATURA */}
            {/* ============================================= */}
            {showDetailsModal && faturaDetalhes && (
                <div className="modal-overlay" onClick={() => setShowDetailsModal(false)}>
                    <div className="modal-container-dual" onClick={(e) => e.stopPropagation()}>
                        {/* PAINEL ESQUERDO - CONTEÚDO PDF */}
                        <div className="modal-content modal-pdf" style={{ position: 'relative', overflow: 'hidden' }}>

                            {/* WATERMARK - PAGA */}
                            {faturaDetalhes.status === 'Pago' && (
                                <div className="watermark-overlay" style={{
                                    position: 'absolute',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none',
                                    zIndex: 10,
                                    borderRadius: '8px',
                                    overflow: 'hidden'
                                }}>
                                    <div className="watermark-text" style={{
                                        fontSize: '60px',
                                        fontWeight: 900,
                                        color: 'rgba(16, 185, 129, 0.12)',
                                        textTransform: 'uppercase',
                                        transform: 'rotate(-30deg)',
                                        letterSpacing: '15px',
                                        userSelect: 'none',
                                        pointerEvents: 'none',
                                        fontFamily: 'Arial, Helvetica, sans-serif',
                                        textShadow: '0 2px 10px rgba(16, 185, 129, 0.05)',
                                        border: '6px solid rgba(16, 185, 129, 0.15)',
                                        padding: '20px 50px',
                                        borderRadius: '12px',
                                        background: 'rgba(16, 185, 129, 0.03)'
                                    }}>
                                        PAGO
                                    </div>
                                </div>
                            )}

                            {/* WATERMARK - CANCELADA */}
                            {faturaDetalhes.status === 'Cancelada' && (
                                <div className="watermark-overlay" style={{
                                    position: 'absolute',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none',
                                    zIndex: 10,
                                    borderRadius: '8px',
                                    overflow: 'hidden'
                                }}>
                                    <div className="watermark-text" style={{
                                        fontSize: '60px',
                                        fontWeight: 900,
                                        color: 'rgba(220, 38, 38, 0.12)',
                                        textTransform: 'uppercase',
                                        transform: 'rotate(-30deg)',
                                        letterSpacing: '15px',
                                        userSelect: 'none',
                                        pointerEvents: 'none',
                                        fontFamily: 'Arial, Helvetica, sans-serif',
                                        textShadow: '0 2px 10px rgba(220, 38, 38, 0.05)',
                                        border: '6px solid rgba(220, 38, 38, 0.15)',
                                        padding: '20px 50px',
                                        borderRadius: '12px',
                                        background: 'rgba(220, 38, 38, 0.03)'
                                    }}>
                                        CANCELADA
                                    </div>
                                </div>
                            )}

                            {/* WATERMARK - VENCIDA */}
                            {faturaDetalhes.status === 'Vencida' && (
                                <div className="watermark-overlay" style={{
                                    position: 'absolute',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none',
                                    zIndex: 10,
                                    borderRadius: '8px',
                                    overflow: 'hidden'
                                }}>
                                    <div className="watermark-text" style={{
                                        fontSize: '50px',
                                        fontWeight: 900,
                                        color: 'rgba(245, 158, 11, 0.12)',
                                        textTransform: 'uppercase',
                                        transform: 'rotate(-30deg)',
                                        letterSpacing: '15px',
                                        userSelect: 'none',
                                        pointerEvents: 'none',
                                        fontFamily: 'Arial, Helvetica, sans-serif',
                                        textShadow: '0 2px 10px rgba(245, 158, 11, 0.05)',
                                        border: '6px solid rgba(245, 158, 11, 0.15)',
                                        padding: '20px 50px',
                                        borderRadius: '12px',
                                        background: 'rgba(245, 158, 11, 0.03)'
                                    }}>
                                        VENCIDA
                                    </div>
                                </div>
                            )}

                            <div className="modal-header">
                                <h3>
                                    <Icon name="receipt" size={22} />
                                    Fatura {faturaDetalhes.numero}
                                    {faturaDetalhes.cotacaoId && (
                                        <span style={{
                                            marginLeft: '10px',
                                            fontSize: '0.6rem',
                                            fontWeight: 500,
                                            color: '#6b7280',
                                            background: '#f1f3f5',
                                            padding: '2px 12px',
                                            borderRadius: '100px'
                                        }}>
                                            CT: {typeof faturaDetalhes.cotacaoId === 'object' ? faturaDetalhes.cotacaoId.numero : faturaDetalhes.cotacaoId}
                                        </span>
                                    )}
                                    {faturaDetalhes.status === 'Pago' && (
                                        <span style={{
                                            marginLeft: '10px',
                                            fontSize: '0.7rem',
                                            fontWeight: 700,
                                            color: '#059669',
                                            background: 'rgba(5, 150, 105, 0.1)',
                                            padding: '2px 12px',
                                            borderRadius: '100px',
                                            letterSpacing: '1px'
                                        }}>
                                            PAGO
                                        </span>
                                    )}
                                    {faturaDetalhes.status === 'Cancelada' && (
                                        <span style={{
                                            marginLeft: '10px',
                                            fontSize: '0.7rem',
                                            fontWeight: 700,
                                            color: '#dc2626',
                                            background: 'rgba(220, 38, 38, 0.1)',
                                            padding: '2px 12px',
                                            borderRadius: '100px',
                                            letterSpacing: '1px'
                                        }}>
                                            CANCELADA
                                        </span>
                                    )}
                                    {faturaDetalhes.status === 'Vencida' && (
                                        <span style={{
                                            marginLeft: '10px',
                                            fontSize: '0.7rem',
                                            fontWeight: 700,
                                            color: '#d97706',
                                            background: 'rgba(245, 158, 11, 0.1)',
                                            padding: '2px 12px',
                                            borderRadius: '100px',
                                            letterSpacing: '1px'
                                        }}>
                                            VENCIDA
                                        </span>
                                    )}
                                </h3>
                                <button className="modal-close" onClick={() => setShowDetailsModal(false)}>×</button>
                            </div>

                            {/* CONTEÚDO DO PDF */}
                            <div className="modal-body pdf-body">

                                {/* TOPO */}
                                <div className="pdf-header-top">
                                    <div className="pdf-header-left">
                                        <span className="pdf-label">Fatura</span>
                                        <span className="pdf-value">{faturaDetalhes.numero}</span>
                                    </div>
                                    <div className="pdf-header-right">
                                        <span className="pdf-label">Original</span>
                                        <span className="pdf-label">Data de Emissão</span>
                                        <span className="pdf-value">{formatarData(faturaDetalhes.dataEmissao)}</span>
                                    </div>
                                </div>

                                {/* DADOS DA EMPRESA E CLIENTE */}
                                <div className="pdf-cliente-empresa-grid">
                                    <div className="pdf-empresa-section">
                                        <div className="pdf-empresa-grid">
                                            <div className="pdf-empresa-row-logo" style={{
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center',
                                                padding: '4px 0 10px',
                                                borderBottom: '0px solid #e9ecef',
                                                marginTop: '-10px',
                                                marginBottom: '0px',
                                                width: '100%'
                                            }}>
                                                {(() => {
                                                    const empresaData = faturaDetalhes?.empresa || empresaConfig;
                                                    const logoUrl = empresaData?.imagemPerfil || null;
                                                    const nomeEmpresa = empresaData?.nome || '---';

                                                    if (logoUrl && logoUrl !== 'null' && logoUrl !== 'undefined' && logoUrl !== '') {
                                                        return (
                                                            <img
                                                                src={logoUrl}
                                                                alt={nomeEmpresa}
                                                                className="pdf-empresa-logo"
                                                                style={{
                                                                    maxHeight: '70px',
                                                                    maxWidth: '280px',
                                                                    objectFit: 'contain',
                                                                    display: 'block',
                                                                    marginRight: 'auto',
                                                                    marginLeft: '-70px'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.style.display = 'none';
                                                                    const parent = e.target.parentElement;
                                                                    if (parent) {
                                                                        parent.innerHTML = `<span class="pdf-empresa-value" style="font-size:16px;font-weight:bold;color:#1a3a5c;">${nomeEmpresa}</span>`;
                                                                    }
                                                                }}
                                                            />
                                                        );
                                                    }
                                                    return (
                                                        <span className="pdf-empresa-value" style={{
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: '#1a3a5c',
                                                            marginRight: 'auto'
                                                        }}>
                                                            {nomeEmpresa}
                                                        </span>
                                                    );
                                                })()}
                                            </div>
                                            <div className="pdf-empresa-row">
                                                <span className="pdf-empresa-value">
                                                    {faturaDetalhes?.empresa?.nome || empresaConfig.nome || '---'}
                                                </span>
                                            </div>
                                            <div className="pdf-empresa-row2">
                                                <span className="pdf-empresa-value2">
                                                    {faturaDetalhes?.empresa?.morada?.enderecoCompleto ||
                                                        empresaConfig.morada?.enderecoCompleto ||
                                                        '---'}
                                                </span>
                                            </div>
                                            <div className="pdf-empresa-row3">
                                               <span style={{ fontWeight: 'bold', fontSize: '8px' }}>NUIT : </span> <span className="pdf-empresa-value3">
                                                    {faturaDetalhes?.empresa?.nuit || empresaConfig.nuit || '---'}
                                                </span>
                                            </div>
                                            <div className="pdf-empresa-row4">
                                                <span className="pdf-empresa-value4">
                                                    {faturaDetalhes?.empresa?.email || empresaConfig.email || '---'}
                                                </span>
                                            </div>
                                            <div className="pdf-empresa-row5">
                                                <span className="pdf-empresa-value5">
                                                    {(() => {
                                                        const website = faturaDetalhes?.empresa?.website || empresaConfig.website || '---';
                                                        const cleanWebsite = website
                                                            .replace(/^https?:\/\//, '')
                                                            .replace(/\/$/, '');
                                                        return cleanWebsite || '---';
                                                    })()}
                                                </span>
                                            </div>
                                            <div className="pdf-empresa-row6">
                                                <span className="pdf-empresa-value6">
                                                    {faturaDetalhes?.empresa?.telefone || empresaConfig.telefone || '---'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pdf-cliente-section">
                                        <div className="pdf-cliente-grid">
                                            <div className="pdf-cliente-row" style={{ borderTop: '0px solid var(--pdf-border, #d0d7de)', marginTop: '50px' }}>
                                            </div>
                                            <div className="pdf-cliente-row">
                                                <span className="pdf-cliente-value-fatura" style={{ fontSize: '10.5px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                                    {getClienteNome(faturaDetalhes)}
                                                </span>
                                            </div>
                                            <div className="pdf-cliente-row">
                                                <span className="pdf-cliente-value" style={{ fontSize: '8px', whiteSpace: 'nowrap' }}>
                                                    {(() => {
                                                        const cliente = faturaDetalhes?.clienteId;
                                                        if (!cliente) return '---';
                                                        const m = cliente.morada || {};
                                                        const enderecoCompleto = [
                                                            cliente.endereco,
                                                            m.quarteirao ? `Q:${m.quarteirao}` : null,
                                                            m.cidade || cliente.cidade,
                                                            m.pais || cliente.provincia,
                                                            cliente.nacionalidade || '---',
                                                        ].filter(Boolean).join(', ');
                                                        return enderecoCompleto || cliente.endereco || '---';
                                                    })()}
                                                </span>
                                            </div>
                                           <div className="pdf-cliente-row"
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'baseline',
                                                    gap: '4px',
                                                    flexWrap: 'nowrap',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ fontWeight: 'bold', fontSize: '8px', whiteSpace: 'nowrap' }}>
                                                    NUIT :
                                                </span>
                                                <span
                                                    className="pdf-cliente-value"
                                                    style={{ whiteSpace: 'nowrap' }}
                                                >
                                                    {getClienteNif(faturaDetalhes) || '---'}
                                                </span>
                                            </div>
    
                                            <div className="pdf-cliente-row">
                                                <span className="pdf-cliente-value">{faturaDetalhes.clienteId?.telefone || '---'}</span>
                                            </div>
                                            <div className="pdf-cliente-row">
                                                <span className="pdf-cliente-value" style={{ fontSize: '9px' }}>{faturaDetalhes.clienteId?.email || '---'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* PROCESSADO POR COMPUTADOR */}
                                <div className="pdf-processado" style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '4px 0 8px',
                                    borderBottom: '1px solid #e9ecef',
                                    marginBottom: '10px'
                                }}>
                                    <span className="pdf-empresa-label" style={{ fontWeight: 500, color: '#6c757d', fontSize: '8px', textTransform: 'uppercase' }}>
                                        Processado por computador
                                    </span>
                                    {(faturaDetalhes?.empresa?.cafe || empresaConfig.cafe) && (
                                        <span className="pdf-cafe-code" style={{
                                            fontSize: '8.5px',
                                            color: 'white',
                                            fontWeight: 700,
                                            fontFamily: 'Courier New, monospace',
                                            background: 'Grey',
                                            padding: '2px 10px',
                                            borderRadius: '4px'
                                        }}>
                                            CAFE: {faturaDetalhes?.empresa?.cafe || empresaConfig.cafe || '---'}
                                        </span>
                                    )}
                                </div>

                                {/* VENCIMENTO, MOEDA, OBSERVAÇÕES */}
                                <div className="pdf-info-row" style={{
                                    gridTemplateColumns: '1fr 1fr 1fr 2fr',
                                    gap: '15px',
                                    padding: '8px 14px',
                                    background: '#f8f9fa',
                                    borderRadius: '4px',
                                    border: '1px solid #d0d7de',
                                    marginBottom: '12px'
                                }}>
                                    <div className="pdf-info-item">
                                        <span className="pdf-info-label">Vencimento</span>
                                        <span className="pdf-info-value">
                                            {formatarData(faturaDetalhes.dataVencimento)}
                                            ({(() => {
                                                if (!faturaDetalhes.dataEmissao || !faturaDetalhes.dataVencimento) return '30 dias';
                                                try {
                                                    const dataEmissao = new Date(faturaDetalhes.dataEmissao);
                                                    const dataVencimento = new Date(faturaDetalhes.dataVencimento);
                                                    if (isNaN(dataEmissao.getTime()) || isNaN(dataVencimento.getTime())) return '30 dias';
                                                    const diffTime = dataVencimento.getTime() - dataEmissao.getTime();
                                                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                                    if (diffDays < 0) return `Vencida há ${Math.abs(diffDays)} dias`;
                                                    return `${diffDays} dias`;
                                                } catch (error) {
                                                    return '30 dias';
                                                }
                                            })()})
                                        </span>
                                    </div>
                                    <div className="pdf-info-item">
                                        <span className="pdf-info-label">Moeda</span>
                                        <span className="pdf-info-value">{empresaConfig.moeda?.codigo || 'MZN'}</span>
                                    </div>
                                    <div className="pdf-info-item">
                                        <span className="pdf-info-label">Status</span>
                                        <span className="pdf-info-value" style={{
                                            fontWeight: 600,
                                            color: faturaDetalhes.status === 'Pago' ? '#059669' :
                                                faturaDetalhes.status === 'Cancelada' ? '#dc2626' :
                                                    faturaDetalhes.status === 'Vencida' ? '#d97706' :
                                                        faturaDetalhes.status === 'Emitida' ? '#3b82f6' :
                                                            faturaDetalhes.status === 'Aberta' ? '#f59e0b' : '#6b7280'
                                        }}>
                                            {faturaDetalhes.status || 'Rascunho'}
                                        </span>
                                    </div>
                                    <div className="pdf-info-item">
                                        <span className="pdf-info-label">Observações</span>
                                        <span className="pdf-info-value">{faturaDetalhes.observacoes || '-'}</span>
                                    </div>
                                </div>

                                {/* TABELA DE ITENS */}
                                <div className="pdf-itens-table-wrapper">
                                    <table className="pdf-itens-table" style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        fontSize: '7px',
                                        border: '0.5px solid #d9d9d9',
                                        borderRadius: '8px',
                                        overflow: 'hidden'
                                    }}>
                                        <thead>
                                            <tr>
                                                <th className="col-codigo" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Cod</th>
                                                <th className="col-nome" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Nome</th>
                                                <th className="col-descricao" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Descrição</th>
                                                <th className="col-quantidade" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Qtd.</th>
                                                <th className="col-preco" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Preço Unitário</th>
                                                <th className="col-desconto" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Desconto %</th>
                                                <th className="col-total" style={{ background: '#1a3c5e', color: 'white', padding: '6px 8px', textAlign: 'center', fontWeight: 'bold', fontSize: '7px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Preço Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {faturaDetalhes.produtos?.map((item, index) => {
                                                const isServico = !!item.servicoId;
                                                const itemId = isServico ? item.servicoId : item.produtoId;
                                                const itemsList = isServico ? servicos : produtos;
                                                const itemData = itemsList.find(p => p._id === itemId);
                                                const nomeItem = itemData ? itemData.nome : getItemNome(item);
                                                const codigoItem = itemData ? itemData.codigo : getItemCodigo(item);

                                                let descricaoItem = '';
                                                if (itemData?.descricao) {
                                                    descricaoItem = itemData.descricao;
                                                } else if (item.descricao) {
                                                    descricaoItem = item.descricao;
                                                } else if (item.produtoId && typeof item.produtoId === 'object' && item.produtoId.descricao) {
                                                    descricaoItem = item.produtoId.descricao;
                                                } else if (item.servicoId && typeof item.servicoId === 'object' && item.servicoId.descricao) {
                                                    descricaoItem = item.servicoId.descricao;
                                                } else if (item.produtoInfo?.descricao) {
                                                    descricaoItem = item.produtoInfo.descricao;
                                                }

                                                const descontoItem = item.descontoPercentual || 0;
                                                const totalComDesconto = item.quantidade * item.precoUnitario * (1 - descontoItem / 100);

                                                return (
                                                    <tr key={index} style={{ borderBottom: '1px solid #e9ecef' }}>
                                                        <td className="col-codigo" style={{ padding: '5px 8px', textAlign: 'center', verticalAlign: 'middle', fontSize: '7.5px' }}>{codigoItem || '---'}</td>
                                                        <td className="col-nome" style={{ padding: '5px 8px', textAlign: 'left', verticalAlign: 'middle', fontSize: '7.5px' }}>{nomeItem}</td>
                                                        <td className="col-descricao" style={{ padding: '5px 8px', textAlign: 'left', verticalAlign: 'middle', fontSize: '7.5px' }}>{descricaoItem || '-'}</td>
                                                        <td className="col-quantidade" style={{ padding: '5px 8px', textAlign: 'center', verticalAlign: 'middle', fontSize: '7.5px' }}>{item.quantidade}</td>
                                                        <td className="col-preco" style={{ padding: '5px 8px', textAlign: 'right', verticalAlign: 'middle', fontSize: '7.5px' }}>{formatarMoeda(item.precoUnitario)}</td>
                                                        <td className="col-desconto" style={{ padding: '5px 8px', textAlign: 'center', verticalAlign: 'middle', fontSize: '7.5px' }}>{descontoItem > 0 ? `${descontoItem}%` : '0%'}</td>
                                                        <td className="col-total" style={{ padding: '5px 8px', textAlign: 'right', verticalAlign: 'middle', fontSize: '7.5px', fontWeight: 600, color: '#1a3c5e' }}>{formatarMoeda(totalComDesconto)}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* IMPOSTO, INCIDÊNCIA, VALOR + SUMÁRIO */}
                                <div className="pdf-tax-summary-wrapper" style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '20px',
                                    marginBottom: '12px',
                                    border: '1px solid #d0d7de',
                                    borderRadius: '4px',
                                    padding: '12px 16px',
                                    background: '#fafbfc'
                                }}>
                                    <div className="pdf-tax-section">
                                        <div className="pdf-tax-header" style={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr 1fr',
                                            gap: '8px',
                                            paddingBottom: '4px',
                                            borderBottom: '1px solid #d0d7de',
                                            marginBottom: '4px'
                                        }}>
                                            <span className="pdf-tax-label" style={{ fontWeight: 700, fontSize: '9px', color: '#1a3a5c', textAlign: 'center', textTransform: 'uppercase' }}>Imposto</span>
                                            <span className="pdf-tax-label" style={{ fontWeight: 700, fontSize: '9px', color: '#1a3a5c', textAlign: 'center', textTransform: 'uppercase' }}>Incidência</span>
                                            <span className="pdf-tax-label" style={{ fontWeight: 700, fontSize: '9px', color: '#1a3a5c', textAlign: 'center', textTransform: 'uppercase' }}>Valor</span>
                                        </div>
                                        <div className="pdf-tax-row" style={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr 1fr',
                                            gap: '8px',
                                            padding: '4px 0'
                                        }}>
                                            {(() => {
                                                const ivaPercent = faturaDetalhes.ivaPercent || 0;
                                                const isIvaIncluso = faturaDetalhes.ivaIncluso === true || ivaPercent === 0 || ivaPercent === 15;

                                                let ivaLabel = '';
                                                let ivaValue = '';

                                                const produtos = faturaDetalhes.produtos || [];
                                                const descontoGlobal = faturaDetalhes.descontoGlobal || 0;

                                                let descontoItensValor = 0;
                                                produtos.forEach((item) => {
                                                    const descontoPercentual = item.descontoPercentual || 0;
                                                    if (descontoPercentual > 0) {
                                                        descontoItensValor += item.precoUnitario * (descontoPercentual / 100) * item.quantidade;
                                                    }
                                                });

                                                const subtotalOriginal = produtos.reduce((acc, item) => {
                                                    return acc + (item.quantidade * item.precoUnitario);
                                                }, 0);

                                                const subtotalComDescontosItens = subtotalOriginal - descontoItensValor;
                                                const descontoGlobalValor = subtotalComDescontosItens * (descontoGlobal / 100);
                                                const subtotalFinal = subtotalOriginal - descontoItensValor - descontoGlobalValor;

                                                if (isIvaIncluso) {
                                                    if (ivaPercent === 0) {
                                                        ivaLabel = `Isento`;
                                                    } else {
                                                        ivaLabel = 'IVA Incluso';
                                                    }
                                                    ivaValue = '0,00 MT';
                                                } else {
                                                    ivaLabel = `IVA ${ivaPercent}%`;
                                                    ivaValue = formatarMoeda(faturaDetalhes.iva || 0);
                                                }

                                                return (
                                                    <>
                                                        <span className="pdf-tax-value" style={{ fontSize: '8.5px', textAlign: 'center', color: '#1a1a1a' }}>{ivaLabel}</span>
                                                        <span className="pdf-tax-value" style={{ fontSize: '8.5px', textAlign: 'center', color: '#1a1a1a' }}>{formatarMoeda(subtotalFinal)}</span>
                                                        <span className="pdf-tax-value" style={{ fontSize: '8.5px', textAlign: 'center', color: '#1a1a1a' }}>{ivaValue}</span>
                                                    </>
                                                );
                                            })()}
                                        </div>

                                        <div className="pdf-iva-obs" style={{ borderTop: '0px solid #d0d7de', marginTop: 'auto' }}>
                                        </div>
                                        <div className="pdf-iva-obs" style={{ borderTop: '0px solid #d0d7de' }}>
                                            {(() => {
                                                const ivaPercent = faturaDetalhes.ivaPercent || 0;
                                                let ivaObsText = '';
                                                if (ivaPercent === 0) {
                                                    ivaObsText = 'Iva isento. Regime de ISPC';
                                                } else if (ivaPercent === 5) {
                                                    ivaObsText = 'Iva 5% - Regime CIVA';
                                                } else if (ivaPercent === 16) {
                                                    ivaObsText = 'Iva não confere de direito a dedução, Artigo 42 do civa';
                                                }
                                                return <span style={{ fontSize: '9px', color: '#6c757d' }}>{ivaObsText}</span>;
                                            })()}
                                        </div>
                                    </div>

                                    <div className="pdf-summary-section" style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '2px',
                                        paddingLeft: '16px',
                                        borderLeft: '2px solid #1a3a5c'
                                    }}>
                                        <div className="pdf-summary-row subtotal" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            padding: '2px 0',
                                            fontSize: '10px',
                                            borderBottom: '1px dashed #d0d7de',
                                            marginBottom: '2px',
                                            paddingBottom: '3px'
                                        }}>
                                            <span className="pdf-summary-label" style={{ fontWeight: 600, color: '#1a1a1a' }}>Subtotal</span>
                                            <span className="pdf-summary-value" style={{ fontWeight: 600, color: '#1a1a1a' }}>
                                                {(() => {
                                                    const subtotalCalculado = faturaDetalhes.produtos?.reduce((acc, item) => {
                                                        return acc + (item.quantidade * item.precoUnitario);
                                                    }, 0) || 0;
                                                    return formatarMoeda(subtotalCalculado);
                                                })()}
                                            </span>
                                        </div>

                                        {(() => {
                                            const produtos = faturaDetalhes.produtos || [];
                                            const descontoGlobal = faturaDetalhes.descontoGlobal || 0;

                                            let descontoItensValor = 0;
                                            let itensComDesconto = 0;

                                            produtos.forEach((item) => {
                                                const descontoPercentual = item.descontoPercentual || 0;
                                                if (descontoPercentual > 0) {
                                                    const descontoItemValor = item.precoUnitario * (descontoPercentual / 100) * item.quantidade;
                                                    descontoItensValor += descontoItemValor;
                                                    itensComDesconto++;
                                                }
                                            });

                                            const subtotalOriginal = produtos.reduce((acc, item) => {
                                                return acc + (item.quantidade * item.precoUnitario);
                                            }, 0);

                                            const subtotalComDescontosItens = subtotalOriginal - descontoItensValor;
                                            const descontoGlobalValor = subtotalComDescontosItens * (descontoGlobal / 100);
                                            const descontoTotalValor = descontoItensValor + descontoGlobalValor;
                                            const subtotalFinal = subtotalOriginal - descontoTotalValor;
                                            const percentualTotal = subtotalOriginal > 0 ? (descontoTotalValor / subtotalOriginal) * 100 : 0;
                                            const hasDesconto = descontoGlobal > 0 || itensComDesconto > 0;
                                            const isZeroDesconto = descontoTotalValor === 0;

                                            return (
                                                <>
                                                    <div className="pdf-summary-row discount" style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '2px 0',
                                                        fontSize: '10px',
                                                        color: isZeroDesconto ? '#9ca3af' : '#dc2626',
                                                        opacity: isZeroDesconto ? 0.6 : 1
                                                    }}>
                                                        <span className="pdf-summary-label" style={{ fontWeight: 700 }}>
                                                            Desconto {!isZeroDesconto && `(${percentualTotal.toFixed(1)}%)`}
                                                            {isZeroDesconto && '(0%)'}
                                                        </span>
                                                        <span className="pdf-summary-value" style={{
                                                            fontWeight: 600,
                                                            color: isZeroDesconto ? '#9ca3af' : '#dc2626'
                                                        }}>
                                                            {formatarMoeda(descontoTotalValor)}
                                                        </span>
                                                    </div>
                                                    {hasDesconto && (
                                                        <div className="pdf-summary-row subtotal-com-desconto" style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '2px 0',
                                                            fontSize: '10px',
                                                            borderBottom: '1px dashed #d0d7de',
                                                            marginBottom: '2px',
                                                            paddingBottom: '3px',
                                                            fontWeight: 600
                                                        }}>
                                                            <span className="pdf-summary-label" style={{ fontWeight: 700 }}>Subtotal c/ Desconto</span>
                                                            <span className="pdf-summary-value" style={{ fontWeight: 700 }}>
                                                                {formatarMoeda(subtotalFinal)}
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()}

                                        {(() => {
                                            const ivaPercent = faturaDetalhes.ivaPercent || 0;
                                            const isIvaIncluso = faturaDetalhes.ivaIncluso === true || ivaPercent === 0 || ivaPercent === 15;

                                            if (!isIvaIncluso) {
                                                return (
                                                    <div className="pdf-summary-row iva" style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '2px 0',
                                                        fontSize: '10px',
                                                        borderBottom: '1px dashed #d0d7de',
                                                        marginBottom: '2px',
                                                        paddingBottom: '3px'
                                                    }}>
                                                        <span className="pdf-summary-label" style={{ fontWeight: 600, color: '#1a1a1a' }}>IVA {ivaPercent}%</span>
                                                        <span className="pdf-summary-value" style={{ fontWeight: 600, color: '#1a1a1a' }}>{formatarMoeda(faturaDetalhes.iva || 0)}</span>
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })()}

                                        <div className="pdf-summary-row total" style={{ border: '0px solid #000', marginBottom: 'auto' }}>
                                        </div>
                                        <div className="pdf-summary-row total" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            padding: '4px 0',
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            color: '#1a3c5e',
                                            paddingTop: '6px',
                                            borderTop: '2px solid #1a3c5e',
                                            marginTop: '4px'
                                        }}>
                                            <span className="pdf-summary-label" style={{ fontWeight: 800, color: '#1a3a5c' }}>Total</span>
                                            <span className="pdf-summary-value" style={{ fontWeight: 800, color: '#1a3c5e', fontSize: '14px' }}>
                                                {(() => {
                                                    const ivaPercent = faturaDetalhes.ivaPercent || 0;
                                                    const isIvaIncluso = faturaDetalhes.ivaIncluso === true || ivaPercent === 0 || ivaPercent === 15;

                                                    if (isIvaIncluso) {
                                                        const produtos = faturaDetalhes.produtos || [];
                                                        const descontoGlobal = faturaDetalhes.descontoGlobal || 0;

                                                        let descontoItensValor = 0;
                                                        produtos.forEach((item) => {
                                                            const descontoPercentual = item.descontoPercentual || 0;
                                                            if (descontoPercentual > 0) {
                                                                descontoItensValor += item.precoUnitario * (descontoPercentual / 100) * item.quantidade;
                                                            }
                                                        });

                                                        const subtotalOriginal = produtos.reduce((acc, item) => {
                                                            return acc + (item.quantidade * item.precoUnitario);
                                                        }, 0);

                                                        const subtotalComDescontosItens = subtotalOriginal - descontoItensValor;
                                                        const descontoGlobalValor = subtotalComDescontosItens * (descontoGlobal / 100);
                                                        const subtotalFinal = subtotalOriginal - descontoItensValor - descontoGlobalValor;

                                                        return formatarMoeda(subtotalFinal);
                                                    } else {
                                                        return getTotalDisplay(faturaDetalhes);
                                                    }
                                                })()}
                                            </span>
                                        </div>

                                        {faturaDetalhes.ivaIncluso && (
                                            <div className="pdf-iva-info" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                fontSize: '9px',
                                                color: '#059669',
                                                padding: '2px 0',
                                                justifyContent: 'flex-end',
                                                fontStyle: 'italic'
                                            }}>
                                                IVA já está incluído no preço
                                            </div>
                                        )}

                                        {faturaDetalhes.status === 'Pago' && faturaDetalhes.dataPagamento && (
                                            <div style={{
                                                marginTop: '8px',
                                                paddingTop: '6px',
                                                borderTop: '1px dashed #059669',
                                                fontSize: '8px',
                                                color: '#059669',
                                                textAlign: 'right'
                                            }}>
                                                Pago em: {formatarData(faturaDetalhes.dataPagamento)}
                                            </div>
                                        )}

                                        {faturaDetalhes.status === 'Vencida' && (
                                            <div style={{
                                                marginTop: '8px',
                                                paddingTop: '6px',
                                                borderTop: '1px dashed #d97706',
                                                fontSize: '8px',
                                                color: '#d97706',
                                                textAlign: 'right'
                                            }}>
                                                ⚠️ Fatura vencida desde {formatarData(faturaDetalhes.dataVencimento)}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* MÉTODOS DE PAGAMENTO E DADOS BANCÁRIOS */}
                                <div className="pdf-footer-bottom" style={{
                                    borderTop: '2px solid #1a3a5c',
                                    paddingTop: '12px',
                                    marginTop: '4px'
                                }}>
                                    <div className="pdf-metodos-pagamento" style={{
                                        textAlign: 'left',
                                        marginBottom: '8px',
                                        padding: '4px 0',
                                        background: '#f8f9fa',
                                        borderRadius: '4px'
                                    }}>
                                        <span className="pdf-metodos-label" style={{
                                            fontWeight: 700,
                                            fontSize: '9px',
                                            color: '#1a3a5c',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Métodos de pagamento &amp; Relação das nossas contas</span>
                                    </div>
                                    <div className="pdf-dados-bancarios-wrapper" style={{ marginBottom: '8px' }}>
                                        {(() => {
                                            const empresaData = faturaDetalhes?.empresa || empresaConfig;
                                            const bancos = empresaData?.dadosBancarios || [];

                                            if (bancos && bancos.length > 0) {
                                                const numBancos = bancos.length;
                                                let cols = 2;
                                                if (numBancos === 1) cols = 1;
                                                else if (numBancos === 2) cols = 2;
                                                else if (numBancos <= 4) cols = 2;
                                                else cols = 3;

                                                return (
                                                    <div
                                                        className="pdf-dados-bancarios-grid"
                                                        style={{
                                                            display: 'grid',
                                                            gridTemplateColumns: `repeat(${cols}, 1fr)`,
                                                            gap: '12px 20px',
                                                            padding: '0px 0px',
                                                            background: 'none',
                                                            borderRadius: '4px',
                                                            border: '0px solid #e9ecef'
                                                        }}
                                                    >
                                                        {bancos.map((banco, index) => (
                                                            <div
                                                                key={index}
                                                                className={`pdf-banco-card ${banco.principal ? 'principal' : ''}`}
                                                                style={{
                                                                    padding: '6px 10px',
                                                                    border: banco.principal ? '1.5px solid #059669' : '1px solid #e9ecef',
                                                                    borderRadius: '6px',
                                                                    background: banco.principal ? 'rgba(5, 150, 105, 0.05)' : 'none',
                                                                    position: 'relative'
                                                                }}
                                                            >
                                                                {banco.principal && (
                                                                    <div className="pdf-banco-principal-badge" style={{
                                                                        position: 'absolute',
                                                                        top: '-6px',
                                                                        right: '6px',
                                                                        fontSize: '7px',
                                                                        fontWeight: 'bold',
                                                                        color: '#ffffff',
                                                                        background: '#059669',
                                                                        padding: '1px 8px',
                                                                        borderRadius: '10px',
                                                                        textTransform: 'uppercase',
                                                                        letterSpacing: '0.3px'
                                                                    }}>
                                                                        Principal
                                                                    </div>
                                                                )}
                                                                <div className="pdf-banco-row" style={{ display: 'grid', gridTemplateColumns: '70px 1fr', gap: '2px 8px', fontSize: '9px', padding: '1px 0' }}>
                                                                    <span className="pdf-banco-nome" style={{ fontWeight: 600, fontSize: '8px', textTransform: 'uppercase' }}>Banco</span>
                                                                    <span className="pdf-banco-conta" style={{ fontFamily: 'Courier New, monospace', letterSpacing: '0.3px', fontWeight: 500, fontSize: '9px' }}>{banco.banco || '---'}</span>
                                                                </div>
                                                                {banco.titular && (
                                                                    <div className="pdf-banco-row" style={{ display: 'grid', gridTemplateColumns: '70px 1fr', gap: '2px 8px', fontSize: '9px', padding: '1px 0' }}>
                                                                        <span className="pdf-banco-nome" style={{ fontWeight: 600, fontSize: '8px', textTransform: 'uppercase' }}>Titular</span>
                                                                        <span className="pdf-banco-conta" style={{ fontFamily: 'Courier New, monospace', letterSpacing: '0.3px', fontWeight: 500, fontSize: '9px' }}>{banco.titular}</span>
                                                                    </div>
                                                                )}
                                                                <div className="pdf-banco-row" style={{ display: 'grid', gridTemplateColumns: '70px 1fr', gap: '2px 8px', fontSize: '9px', padding: '1px 0' }}>
                                                                    <span className="pdf-banco-nome" style={{ fontWeight: 600, fontSize: '8px', textTransform: 'uppercase' }}>Conta</span>
                                                                    <span className="pdf-banco-conta" style={{ fontFamily: 'Courier New, monospace', letterSpacing: '0.3px', fontWeight: 500, fontSize: '9px' }}>{banco.conta || '---'}</span>
                                                                </div>
                                                                <div className="pdf-banco-row" style={{ display: 'grid', gridTemplateColumns: '70px 1fr', gap: '2px 8px', fontSize: '9px', padding: '1px 0' }}>
                                                                    <span className="pdf-banco-nome" style={{ fontWeight: 600, fontSize: '8px', textTransform: 'uppercase' }}>NIB</span>
                                                                    <span className="pdf-banco-conta" style={{ fontFamily: 'Courier New, monospace', letterSpacing: '0.3px', fontWeight: 500, fontSize: '9px' }}>{banco.nib || '---'}</span>
                                                                </div>
                                                                <div className="pdf-banco-row" style={{ display: 'grid', gridTemplateColumns: '70px 1fr', gap: '2px 8px', fontSize: '9px', padding: '1px 0' }}>
                                                                    <span className="pdf-banco-nome" style={{ fontWeight: 600, fontSize: '8px', textTransform: 'uppercase' }}>Swift</span>
                                                                    <span className="pdf-banco-conta" style={{ fontFamily: 'Courier New, monospace', letterSpacing: '0.3px', fontWeight: 500, fontSize: '9px' }}>{banco.swift || '---'}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            }
                                            return (
                                                <div className="pdf-dados-bancarios-grid" style={{
                                                    padding: '8px 12px',
                                                    background: '#f8f9fa',
                                                    borderRadius: '4px',
                                                    border: '1px solid #e9ecef',
                                                    textAlign: 'center'
                                                }}>
                                                    <div className="pdf-banco-row" style={{ fontSize: '10px', color: '#6c757d' }}>
                                                        <span>Sem dados bancários cadastrados</span>
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>

                                    <div className="pdf-footer-info" style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr',
                                        gap: '4px 20px',
                                        padding: '6px 0',
                                        fontSize: '9px',
                                        color: '#6c757d',
                                        borderTop: '1px solid #e9ecef',
                                        marginTop: '6px'
                                    }}>
                                        <div style={{ textAlign: 'left' }}>
                                            <span className="pdf-doc-emitido-text">Documento emitido pelo Software RAF ERP</span>
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <span className="pdf-usuario-text">Utilizador: <strong className="pdf-usuario-nome">{faturaDetalhes.criadoPor?.nome || '---'}</strong></span>
                                            {faturaDetalhes.tipo && (
                                                <span style={{ marginLeft: '10px', fontSize: '7px', color: '#9ca3af', background: '#f1f3f5', padding: '2px 8px', borderRadius: '4px' }}>
                                                    {faturaDetalhes.tipo}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* PAINEL DIREITO - SIDE PANEL DE AÇÕES */}
                        <div className="modal-side-panel">
                            <div className="side-panel-header">
                                <h4>
                                    <Icon name="settings" size={18} />
                                    Ações
                                </h4>
                            </div>

                            <div className="side-panel-body">
                                <div className="side-panel-status">
                                    <span className="status-label">Status</span>
                                    <span className={`status-badge ${getStatusClass(faturaDetalhes)}`}>
                                        <Icon name={getStatusIcon(faturaDetalhes)} size={12} />
                                        {getStatusFormatado(faturaDetalhes)}
                                    </span>
                                </div>

                                {faturaDetalhes.status === 'Cancelada' && (
                                    <>
                                        <div className="side-panel-divider"></div>
                                        <div className="side-panel-cancel-motivo" style={{
                                            background: '#fef2f2',
                                            border: '1px solid #fecaca',
                                            borderRadius: '8px',
                                            padding: '12px 14px',
                                            marginTop: '4px'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginBottom: '6px'
                                            }}>
                                                <Icon name="cancel" size={16} color="#dc2626" />
                                                <span style={{
                                                    fontSize: '0.75rem',
                                                    fontWeight: 700,
                                                    color: '#dc2626',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    Motivo do Cancelamento
                                                </span>
                                            </div>
                                            <p style={{
                                                margin: 0,
                                                fontSize: '0.85rem',
                                                color: '#1a1a2e',
                                                lineHeight: 1.5,
                                                wordBreak: 'break-word',
                                                whiteSpace: 'pre-wrap'
                                            }}>
                                                {faturaDetalhes.observacoesInternas || 'Motivo não informado'}
                                            </p>
                                        </div>
                                    </>
                                )}

                                <div className="side-panel-divider"></div>

                                <button
                                    className="side-panel-btn btn-pdf"
                                    onClick={async () => {
                                        if (faturaDetalhes.status === 'Cancelada') {
                                            showToast('Esta fatura foi cancelada e não pode ser exportada', 'warning');
                                            return;
                                        }
                                        try {
                                            setLoading(true);
                                            const token = localStorage.getItem('token');
                                            if (!token) {
                                                showToast('Faça login novamente', 'danger');
                                                setLoading(false);
                                                return;
                                            }

                                            const response = await fetch(
                                                `/api/faturas/${faturaDetalhes._id}/pdf`,
                                                {
                                                    headers: {
                                                        'Authorization': `Bearer ${token}`
                                                    }
                                                }
                                            );

                                            if (!response.ok) {
                                                const errorText = await response.text();
                                                throw new Error(`Erro ${response.status}: ${errorText}`);
                                            }

                                            const blob = await response.blob();
                                            const nomeArquivo = `Fatura_${faturaDetalhes.numero}_${getClienteNome(faturaDetalhes)}.pdf`;

                                            const url = window.URL.createObjectURL(blob);
                                            const link = document.createElement('a');
                                            link.href = url;
                                            link.setAttribute('download', nomeArquivo);
                                            document.body.appendChild(link);
                                            link.click();

                                            setTimeout(() => {
                                                link.parentNode.removeChild(link);
                                                window.URL.revokeObjectURL(url);
                                            }, 100);

                                            showToast('PDF baixado com sucesso!', 'success');
                                        } catch (error) {
                                            console.error('❌ Erro ao baixar PDF:', error);
                                            showToast(error.message || 'Erro ao gerar PDF', 'danger');
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                    disabled={loading || faturaDetalhes.status === 'Cancelada'}
                                    style={{
                                        opacity: faturaDetalhes.status === 'Cancelada' ? 0.5 : 1,
                                        cursor: faturaDetalhes.status === 'Cancelada' ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner">⏳</span>
                                            <span>Gerando...</span>
                                        </>
                                    ) : (
                                        <>
                                            <Icon name="picture_as_pdf" size={18} />
                                            <span>Baixar PDF</span>
                                        </>
                                    )}
                                </button>

                                <button
                                    className="side-panel-btn btn-print"
                                    onClick={async () => {
                                        if (faturaDetalhes.status === 'Cancelada') {
                                            showToast('Esta fatura foi cancelada e não pode ser impressa', 'warning');
                                            return;
                                        }

                                        try {
                                            setLoading(true);
                                            const token = localStorage.getItem('token');
                                            if (!token) {
                                                showToast('Faça login novamente', 'danger');
                                                setLoading(false);
                                                return;
                                            }

                                            const response = await fetch(
                                                `/api/faturas/${faturaDetalhes._id}/pdf`,
                                                {
                                                    headers: {
                                                        'Authorization': `Bearer ${token}`
                                                    }
                                                }
                                            );

                                            if (!response.ok) {
                                                const errorText = await response.text();
                                                throw new Error(`Erro ${response.status}: ${errorText}`);
                                            }

                                            const blob = await response.blob();
                                            const url = window.URL.createObjectURL(blob);
                                            const printWindow = window.open(url, '_blank');

                                            if (!printWindow) {
                                                showToast('Por favor, permita pop-ups para imprimir', 'warning');
                                                window.URL.revokeObjectURL(url);
                                                setLoading(false);
                                                return;
                                            }

                                            printWindow.onload = function () {
                                                setTimeout(() => {
                                                    printWindow.print();
                                                }, 500);
                                            };

                                            showToast('Documento enviado para impressão', 'success');

                                        } catch (error) {
                                            console.error('❌ Erro ao imprimir:', error);
                                            showToast(error.message || 'Erro ao gerar documento para impressão', 'danger');
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                    disabled={loading || faturaDetalhes.status === 'Cancelada'}
                                    style={{
                                        opacity: faturaDetalhes.status === 'Cancelada' ? 0.5 : 1,
                                        cursor: faturaDetalhes.status === 'Cancelada' ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner">⏳</span>
                                            <span>A preparar...</span>
                                        </>
                                    ) : (
                                        <>
                                            <Icon name="print" size={18} />
                                            <span>Imprimir</span>
                                        </>
                                    )}
                                </button>

                                {/* 🔥 BOTÃO DUPLICAR */}
                                <button
                                    className="side-panel-btn btn-duplicate"
                                    onClick={() => duplicarFatura(faturaDetalhes)}
                                    disabled={loading}
                                    style={{
                                        background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                                        color: '#ffffff',
                                        boxShadow: '0 2px 8px rgba(139, 92, 246, 0.3)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateX(4px)';
                                        e.currentTarget.style.boxShadow = '0 4px 16px rgba(139, 92, 246, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateX(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(139, 92, 246, 0.3)';
                                    }}
                                >
                                    <Icon name="content_copy" size={18} />
                                    <span>Duplicar Fatura</span>
                                </button>

                                {faturaDetalhes.status !== 'Cancelada' && faturaDetalhes.status !== 'Pago' && (
                                    <button
                                        className="side-panel-btn btn-pay"
                                        onClick={() => {
                                            setFaturaToPay(faturaDetalhes);
                                            setDataPagamento(new Date().toISOString().split('T')[0]);
                                            setFormaPagamentoSelecionada('Transferência Bancária');
                                            setDetalhesPagamento('');
                                            setObservacaoPagamento('');
                                            setShowDetalhesPagamento(false);
                                            setShowDetailsModal(false);
                                            setShowPayModal(true);
                                        }}
                                    >
                                        <Icon name="paid" size={18} />
                                        <span>Registrar Pagamento</span>
                                    </button>
                                )}

                                {/* 🔥 BOTÃO CRIAR GUIA DE ENTREGA NO SIDE PANEL - COM ESTADO "GUIA CRIADA" */}
                                {['Pago', 'Emitida', 'Aberta'].includes(faturaDetalhes.status) && (
                                    <button
                                        className="side-panel-btn btn-guide"
                                        onClick={() => !faturaDetalhes.temGuiaCriada && abrirCriarGuia(faturaDetalhes)}
                                        disabled={loading || faturaDetalhes.temGuiaCriada}
                                        style={{
                                            background: faturaDetalhes.temGuiaCriada
                                                ? 'linear-gradient(135deg, #10b981, #059669)'
                                                : 'linear-gradient(135deg, #4f46e5, #4338ca)',
                                            color: '#ffffff',
                                            boxShadow: faturaDetalhes.temGuiaCriada
                                                ? '0 2px 8px rgba(16, 185, 129, 0.3)'
                                                : '0 2px 8px rgba(79, 70, 229, 0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: '10px',
                                            padding: '12px 16px',
                                            border: 'none',
                                            borderRadius: '8px',
                                            cursor: faturaDetalhes.temGuiaCriada ? 'not-allowed' : 'pointer',
                                            fontSize: '0.85rem',
                                            fontWeight: 600,
                                            transition: 'all 0.2s ease',
                                            width: '100%',
                                            textAlign: 'left',
                                            opacity: faturaDetalhes.temGuiaCriada ? 0.85 : 1
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!faturaDetalhes.temGuiaCriada) {
                                                e.currentTarget.style.transform = 'translateX(4px)';
                                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(79, 70, 229, 0.4)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!faturaDetalhes.temGuiaCriada) {
                                                e.currentTarget.style.transform = 'translateX(0)';
                                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(79, 70, 229, 0.3)';
                                            }
                                        }}
                                    >
                                        <Icon name={faturaDetalhes.temGuiaCriada ? "check_circle" : "delivery_truck"} size={18} />
                                        <span>
                                            {faturaDetalhes.temGuiaCriada
                                                ? `Guia Criada${faturaDetalhes.guiaNumero ? ': ' + faturaDetalhes.guiaNumero : ''}`
                                                : 'Criar Guia de Entrega'}
                                        </span>
                                    </button>
                                )}

                                {!['Pago', 'Cancelada'].includes(faturaDetalhes.status) && (
                                    <button
                                        className="side-panel-btn btn-cancel-action"
                                        onClick={() => {
                                            setFaturaToCancel(faturaDetalhes);
                                            setShowDetailsModal(false);
                                            setShowCancelModal(true);
                                        }}
                                    >
                                        <Icon name="cancel" size={18} />
                                        <span>Cancelar</span>
                                    </button>
                                )}

                                <div className="side-panel-divider"></div>

                                <button
                                    className="side-panel-btn btn-close"
                                    onClick={() => setShowDetailsModal(false)}
                                >
                                    <Icon name="close" size={18} />
                                    <span>Fechar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAIS DE CLIENTE, PRODUTO E SERVIÇO */}
            {showClienteModal && (
                <ClienteModal
                    onClose={() => setShowClienteModal(false)}
                    onClienteCriado={(cliente) => {
                        fetchClientes();
                        setFormData(prev => ({
                            ...prev,
                            clienteId: cliente._id
                        }));
                        setSearchCliente(cliente.nome);
                        setShowClienteModal(false);
                        showToast(`Cliente "${cliente.nome}" adicionado com sucesso!`, 'success');
                    }}
                    empresaId={empresaId}
                />
            )}

            {showProdutoModal && (
                <ProdutoModal
                    onClose={() => setShowProdutoModal(false)}
                    onProdutoCriado={handleProdutoCriado}
                    empresaId={empresaId}
                />
            )}

            {showServicoModal && (
                <ServicoModal
                    onClose={() => setShowServicoModal(false)}
                    onServicoCriado={handleServicoCriado}
                    empresaId={empresaId}
                />
            )}

            <Toast
                message={toast.message}
                type={toast.type}
                onClose={closeToast}
            />
        </div>
    );
}